import { AssetCatDropDownDto, AssetDto, AssetGridDto, AssetsClasificationDropDownDto, AssetServiceChecklistDTO, AssetsReportDto, AssetSubCatDropDownDto, MachineInwordReq, UpdateServiceRemarksDto } from '@gtpl/shared-models/asset-management';
import { AboutToExpireDetail, AssetCategoryWiseMaintenanceDetail, AssetCategoryWiseMaintenanceResponse, AssetCountValueModel, AssetDetails, AssetDownTimeDetails, AssetMaintenanceInfoModel, AssetServiceReq, AssetStatusInfoModel, AssetStatusTypeInfoModel, AssetStatusWiseAbstractInfoResp, AssetVendorDetailsModel, AssetVendorDetailsResponse, DownTimeDetailsModel, ErrorResponse, GlobalVariableValues, MessageParameters, ServiceFrequency, ServiceListDetails, serviceOwnerDetails, ServiceOwnerDetailsResponse, ServiceStatusEnum } from '@gtpl/shared-models/common-models';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { Injectable, Query } from '@nestjs/common';
import { AssetsAdapter } from './dto/open-assets-adpater';
import { AssetsDto } from './dto/open-assets-dto';
import { Assets } from './open-assets-entity';
import { AssetsResponseModel } from 'libs/shared-models/asset-management/src/lib/open-assets/create-open-assets-response';
import { AssetsRequest } from './dto/assets.request';
import { InjectRepository } from '@nestjs/typeorm';
import { Between, getManager, In, Index, LessThan, MoreThan, Repository } from 'typeorm';
import { AssetsRepository } from './dto/opens-assets-repository';
import { AssetByCode } from './dto/asset-by-code';
import { AssetLocationMapping } from '../asset-location-mapping/entity/asset-location-mapping.entity';
import { AssetLocationTransaction } from '../asset-location-mapping/entity/asset-location-transaction.entity';
import { AssetLocationMappingRepository } from '../asset-location-mapping/repository/asset-location-mapping.repository';
import { AssetAssignment } from '../asset-assignment/entity/asset-assignment.entity';
import moment from 'moment';
import { AssetAssignmentTransaction } from '../asset-assignment/entity/asset-assignment-transaction.entity';
import { AssetAssignmentRepository } from '../asset-assignment/repository/asset-assignment.repository';
import { LocationRepository } from '../locations/dto/location-repository';
import { AssetStatusEnum } from 'libs/shared-models/common-models/src/lib/enum/asset-status.enum';
import { AssetByStatus } from './dto/asset-by-status.dto';
import appSettings from 'apps/services/config';
import { AssetAssignmentDto } from '../asset-assignment/dto/asset-assignment.dto';
import { AssetAssignmentTransactionDto } from '../asset-assignment/dto/asset-assignment-transaction.dto';
import { whatsApp } from '../../../../whatsapp';
import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';
import { AssetById } from './dto/asset-by-id.dto';
import { AssetRACIReport } from './dto/raci-report-dto';
import { length } from 'class-validator';
import { AbstractDetails } from './dto/abstract-details-dto';
import { AssetServiceRepository } from './dto/asset-service.repository';
import { AssetServiceAdapater } from './dto/asset-service.adapter';
import { AssetServiceDto } from './dto/asset-service.dto';
import { AssetsId } from './dto/asset-id-req';
import { AssetsCatagoryByIdDto } from '../assets-sub-catagory/asset-catagory-id-request';
import { AssetServiceRportReq } from "libs/shared-models/asset-management/src/lib/open-assets/asset-by-status.dto";
import { AssetServiceHelper } from "./assets-service-helper"
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { UpdateRemarksDto } from './dto/remarks-update.dto';
import { Cron } from '@nestjs/schedule';
import { AssetTransaction } from './asset-transaction-entity';
import { AssetTransactionDto } from './dto/asset-transaction-dto';
import { AssetTransactionAdapter } from './dto/asset-transaction-adapter';
import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast';
import { WhatsAppLogDto } from '@gtpl/shared-models/whatsapp-broad-cast';
import { AssetMaintainanceService } from '../asset-maintainance/asset-maintainance.service';
import { AssetServiceChecklist } from './asset-service-checklist.entity';
import { AssetService } from './asset-service.entity';
import { ChecklistRepository } from './dto/checklist-repository';
import { ChecklistItem, UpdateChecklist } from './dto/checklist-update.dto';
import { AssetServiceChecklistDto } from './dto/asset-service-checklist.dto';
import { AssetChecklistRequestDto } from './dto/checklist-request.dto';
import { AssetServiceUpload } from './asset-service-upload.entity';
import { ServiceUploadDto } from './dto/service-upload.dto';
import { MachineInwordDto } from './dto/machine-dto';
import { AssetModelReq } from './dto/asset-model.dto';
import { PaginationReq } from './dto/pagenation.req.dto';
import { PaginatedResponse } from './dto/pagination.response.dto';
import { locationWiseReq } from '../asset-sale/dto/location-wise.dto';

@Injectable()
export class AssetsService {



    constructor(
        private adapter: AssetsAdapter,
        @InjectRepository(Assets)
        private repo: Repository<Assets>,
        private locationRepo: AssetLocationMappingRepository,
        @InjectRepository(AssetLocationTransaction)
        private locationTransRepo: Repository<AssetLocationTransaction>,

        private assignmentRepo: AssetAssignmentRepository,
        @InjectRepository(AssetAssignmentTransaction)
        private assignmentTransRepo: Repository<AssetAssignmentTransaction>,

        private locationMasterRepo: LocationRepository,
        private wpService: WhatsAppNotificationService,
        private assetServiceRepo: AssetServiceRepository,
        private assetServiceAdapter: AssetServiceAdapater,
        private locationMapRepo: AssetLocationMappingRepository,
        private assetServiceHelper: AssetServiceHelper,
        @InjectRepository(AssetTransaction)
        private assetTransactionRepo: Repository<AssetTransaction>,
        private assetTransactionAdapter: AssetTransactionAdapter,
        private wtsAppBroadCatService: WhatsappBroadCastService,
        private maintainanceService: AssetMaintainanceService,
        private checklistRepo: ChecklistRepository,
        @InjectRepository(AssetServiceUpload)
        private uploadRepo: Repository<AssetServiceUpload>,

    ) { }


    async create(createDto: AssetsDto): Promise<CommonResponse> {
        const qrymanager = getManager();
        const manager = new GenericTransactionManager
        try {
            await manager.startTransaction()
            const entity = this.adapter.convertDtoToEntity(createDto);
            if (createDto.status == AssetStatusEnum.GRN) {
                entity.status = AssetStatusEnum.GRN
            }
            if (createDto.assetId) {
                entity.assetType = createDto.assetType
            } else {
                // const qry = `SELECT it.asset_type FROM ` + appSettings.masters_db + `.items it WHERE it.item_id = ${createDto.assetsName}`
                // const data: { asset_type: string }[] = await qrymanager.query(qry)
                // entity.assetType = data[0].asset_type
                // const assetCode = `${createDto.assetsName + '-' + moment(Date.now()).format('mmss')}`
                // entity.assetsCode = assetCode;
            }
            entity.status = createDto.assetcondition !== 'Damaged' ? AssetStatusEnum.Idle : AssetStatusEnum.Damaged
            if (entity.dateOfPurchased == null) {
                entity.dateOfPurchased = new Date();
            }
            const saved = await manager.getRepository(Assets).save(entity);
            const saveTransaction = await manager.getRepository(AssetTransaction).save(entity)
            if (!saved) {
                throw new ErrorResponse(1111, 'Failed to save')
            }
            let locationMappingRepo: AssetLocationMapping;
            if (createDto.currentLocation) {
                const locationDetail = await this.locationRepo.findOne({ where: { assetsId: saved.assetId } })
                if (!locationDetail) {
                    const locationEntity = new AssetLocationMapping();
                    locationEntity.assetsId = saved;
                    locationEntity.createdUser = saved.createdUser;
                    locationEntity.locationId = createDto.currentLocation;
                    locationMappingRepo = await manager.getCustomRepository(AssetLocationMappingRepository).save(locationEntity);
                    // location transaction mapping 
                    const locationEntityTrans = new AssetLocationTransaction();
                    locationEntityTrans.assetId = saved.assetId;
                    locationEntityTrans.createdUser = saved.createdUser;
                    locationEntityTrans.locationId = createDto.currentLocation;
                    locationEntityTrans.assetLocationMapping = locationMappingRepo;
                    const locationMappingTransRepo = await manager.getRepository(AssetLocationTransaction).save(locationEntityTrans);
                }
            }
            if (createDto.serviceStatus == 'yes' && createDto.serviceType == 'planned') {
                if (createDto.assetId) {
                    const updateServices = await manager.getCustomRepository(AssetServiceRepository).delete({ assetId: createDto.assetId, status: ServiceStatusEnum.OPEN })
                }
                const saveService = await this.createPlannedServiceEntries(saved, manager)
                if (saveService.status) {
                    await manager.completeTransaction()
                    return new CommonResponse(true, 98898, "Asset Successfully Created", saved);
                }
            } else {
                await manager.completeTransaction()
                if (saved) {
                    const manager = getManager()
                    let qry = `SELECT it.item_name AS assets_name , aas.assets_code,aas.asset_cost,aas.date_of_purchased,aas.warrenty_expired_date,aas.insurance_date FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.masters_db + `.items it ON it.item_id = aas.assets_name WHERE aas.asset_id = ${saved.assetId}`
                    const data = await manager.query(qry);
                    const parameters = [
                        { "type": "text", "text": moment().format('DD-MM-YYYY') },
                        { "type": "text", "text": data[0].assets_name ? data[0].assets_name : "No Data" },
                        { "type": "text", "text": data[0].assets_code ? data[0].assets_code : "No Data" },
                        { "type": "text", "text": data[0].asset_cost ? data[0].asset_cost : "No Data" },
                        { "type": "text", "text": moment(data[0].date_of_purchased).format('DD-MM-YYYY') ? moment(data[0].date_of_purchased).format('DD-MM-YYYY') : "No Data" },
                        { "type": "text", "text": moment(data[0].warrenty_expired_date).format('DD-MM-YYYY') ? moment(data[0].warrenty_expired_date).format('DD-MM-YYYY') : "No Data" },
                        { "type": "text", "text": moment(data[0].insurance_date).format('DD-MM-YYYY') ? moment(data[0].insurance_date).format('DD-MM-YYYY') : "No Data" },
                    ];
                    for (const contact of whatsApp.contacts) {
                        let statusFlag = true
                        const req = await new MessageParameters(contact, 'asset_create_message', parameters, "en_us")
                        const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
                        if (!messageStatus.status) {
                            statusFlag = false
                        }
                        // else {
                        //     const testdata = 'INSERT INTO ' + appSettings.whatsapp_db + '.whatsapp_logs (contact_no,template_name,project_name,company_id,module_id) VALUES("' + contact + '","asset_assign","Brandix_assets",' + GlobalVariableValues.companyId + ',' + GlobalVariableValues.assetManagementmoduleId + ')'
                        //     const result = await qrymanager.query(testdata)
                        //     const res = new CommonResponse(true, 1111, "Data retreived sucesssfuly", result)
                        // }

                    }
                }
                return new CommonResponse(true, 98898, "Asset Successfully Created", saved);
            }

        } catch (error) {
            await manager.releaseTransaction()
            return new CommonResponse(false, 98898, "Error while creating",);
        }
    }


    async getAllAssets(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT aas.asset_category,isc.item_sub_category , it.item_name AS assets_name,aas.assets_code,aas.amc_available ,aas.date_of_purchased,
        aas.name,aas.warrenty_expired_date,aas.insurance_date,aas.insurance,aas.warrenty_available,aas.expired_date,aas.asset_cost,aas.status, 
        aas.asset_serialno,aas.model,aas.year,aas.asset_supplier,aas.asset_condition,emp.employee_name AS owner_of_asset,aas.transaction_date,aas.decommission_approved_by,
        aas.service_tenure,aas.insurance_provided_by,aas.asset_invoice_no,aas.item_id,aas.grn_id,aas.no_of_units,aas.units_of_measurements,aas.last_checkin,aas.last_checkout,aas.amc_reason,
        aas.department,aas.employee_id,aas.maintenance_duedate,aas.asset_id,unc.unit_name AS plant,aas.asset_type,assi.employee_id,empd.employee_name,empd.department_id,dep.dept_name,aas.service_type,aas.service_status,aas.amc_provider,
        locc.location_id,lo.location_id ,loc.location_name,it.item_name FROM ` + appSettings.assets_db + `.assets aas 
        LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
        LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id 
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN `+ appSettings.masters_db + `.employee_details emp ON emp.employee_id = aas.owner_of_asset
        LEFT JOIN `+ appSettings.assets_db + `.asset_assignment assi ON assi.asset_id = aas.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.employee_details empd ON empd.employee_id = assi.employee_id
        LEFT JOIN `+ appSettings.masters_db + `.departments dep ON dep.dept_id = empd.department_id
        WHERE aas.asset_id > 0 `
        
        if (req.plantId > 0 && req.plantId != 5) {
            getEntities = getEntities + 'and aas.plant = ' + req.plantId
        }
        getEntities = getEntities + ` GROUP BY aas.assets_code ORDER BY it.item_name ASC`
        const assetdata: {
            asset_category: string, assets_name: number, assets_code: string, amc_available: string, date_of_purchased: Date,
            name: string, warrenty_expired_date: Date, insurance_date: Date, insurance: string, warrenty_available: string,
            expired_date: Date, asset_cost: number, status: AssetStatusEnum, asset_serialno: string, asset_condition: string, invoice: string, model: string,
            asset_supplier: string, item_id: number, grn_id: number, no_of_units: number, year: Date, units_of_measurements: string, last_checkin: Date, last_checkout: Date, amc_reason: string,
            asset_invoice_no: string, owner_of_asset: string, department: string, employee_id: number, maintenance_duedate: Date, transaction_date: Date, decommission_approved_by: string,
            service_tenure: string, insurance_provided_by: string, plant: string, asset_id: number, location_name: string, asset_type: string, employee_name: string, dept_name: string, service_type: string, service_status: ServiceStatusEnum, amc_provider: string, item_sub_category: string, item_name: string
        }[] = await manager.query(getEntities)

        const response = [];
        assetdata.forEach(data => {
            response.push(new AssetDto(data.asset_id, data.assets_name, data.assets_code, data.asset_serialno, data.item_id, data.grn_id,
                data.no_of_units, data.insurance, data.insurance_date, null, data.model, data.year,
                data.asset_supplier, data.asset_invoice_no, data.expired_date, data.asset_cost, data.date_of_purchased, data.asset_category, data.status, data.asset_condition, data.amc_available, data.name,
                null, data.owner_of_asset, data.units_of_measurements, data.location_name, data.last_checkin, data.last_checkout, data.warrenty_available, data.warrenty_expired_date,
                data.employee_id, data.department, data.maintenance_duedate, data.transaction_date, null, true, data.item_name, null, 1, data.decommission_approved_by,
                data.service_tenure, data.insurance_provided_by, data.plant, data.amc_reason, data.item_sub_category, data.asset_type, data.employee_name, data.dept_name, data.service_status, data.service_type, data.amc_provider,))
        })
        
        return new CommonResponse(true, 1, 'Data retrieved', response)
    }


    async getAllMachinesData(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT it.item_name AS assets_name,aas.assets_code,aas.asset_cost, 
        aas.asset_serialno,aas.model,aas.asset_supplier,unc.unit_name AS plant,
        locc.location_id,lo.location_id ,loc.location_name FROM ` + appSettings.assets_db + `.assets aas 
        LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
        LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id 
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        WHERE aas.asset_id > 0 `
        
        if (req.plantId > 0 && req.plantId != 5) {
            getEntities = getEntities + 'and aas.plant = ' + req.plantId
        }
        getEntities = getEntities + ` GROUP BY aas.assets_code ORDER BY it.item_name ASC`
        const assetdata: {
            asset_category: string, assets_name: number, assets_code: string, amc_available: string, date_of_purchased: Date,
            name: string, warrenty_expired_date: Date, insurance_date: Date, insurance: string, warrenty_available: string,
            expired_date: Date, asset_cost: number, status: AssetStatusEnum, asset_serialno: string, asset_condition: string, invoice: string, model: string,
            asset_supplier: string, item_id: number, grn_id: number, no_of_units: number, year: Date, units_of_measurements: string, last_checkin: Date, last_checkout: Date, amc_reason: string,
            asset_invoice_no: string, owner_of_asset: string, department: string, employee_id: number, maintenance_duedate: Date, transaction_date: Date, decommission_approved_by: string,
            service_tenure: string, insurance_provided_by: string, plant: string, asset_id: number, location_name: string, asset_type: string, employee_name: string, dept_name: string, service_type: string, service_status: ServiceStatusEnum, amc_provider: string, item_sub_category: string, item_name: string
        }[] = await manager.query(getEntities)

        const response = [];
        assetdata.forEach(data => {
            response.push(new AssetDto(data.asset_id, data.assets_name, data.assets_code, data.asset_serialno, data.item_id, data.grn_id,
                data.no_of_units, data.insurance, data.insurance_date, null, data.model, data.year,
                data.asset_supplier, data.asset_invoice_no, data.expired_date, data.asset_cost, data.date_of_purchased, data.asset_category, data.status, data.asset_condition, data.amc_available, data.name,
                null, data.owner_of_asset, data.units_of_measurements, data.location_name, data.last_checkin, data.last_checkout, data.warrenty_available, data.warrenty_expired_date,
                data.employee_id, data.department, data.maintenance_duedate, data.transaction_date, null, true, data.item_name, null, 1, data.decommission_approved_by,
                data.service_tenure, data.insurance_provided_by, data.plant, data.amc_reason, data.item_sub_category, data.asset_type, data.employee_name, data.dept_name, data.service_status, data.service_type, data.amc_provider,))
        })
        const responseObj = new CommonResponse(true,1111,'Data Retrieved Successfully', response)
        
        return new CommonResponse(true, 1, 'Data retrieved', responseObj)
    }

    async getByStatus(req: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        const page = req?.page || 1; // Default to first page if page is not provided
        const limit = req?.limit || 20; // Default to 10 records per page
        const offset = (page - 1) * limit;
        let getEntities = `
        SELECT isc.item_sub_category_id AS asset_category,isc.item_sub_category,it.item_id AS assets_name, it.item_name AS item_name,aas.assets_code,aas.amc_available ,aas.date_of_purchased,
        aas.name,aas.warrenty_expired_date,aas.insurance_date,aas.insurance,aas.warrenty_available,aas.expired_date,aas.asset_cost,aas.status, 
        aas.asset_serialno,aas.model,aas.year,aas.asset_supplier,aas.asset_condition,empn.employee_id AS owner_of_asset,aas.transaction_date,aas.decommission_approved_by,
        aas.service_tenure,aas.insurance_provided_by,aas.asset_invoice_no,aas.item_id,aas.grn_id,aas.no_of_units,aas.units_of_measurements,aas.last_checkin,aas.last_checkout,aas.amc_reason,
        aas.department,aas.employee_id,aas.maintenance_duedate,aas.asset_id,aas.plant,unc.unit_name AS plantName,assi.employee_id,empd.employee_name,empd.department_id,dep.dept_name,aas.service_status,aas.service_type,aas.frequency_of_service,
        locc.location_id,lo.location_id ,loc.location_name ,aas.asset_type ,aas.month,aas.day,datediff(date(now()),aas.date_of_purchased) as assetAge,aas.asset_mode,aas.amc_provider,aas.insurance_reference_number
        FROM ` + appSettings.assets_db + `.assets aas 
        LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
        LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id 
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN `+ appSettings.assets_db + `.asset_assignment assi ON assi.asset_id = aas.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.employee_details empd ON empd.employee_id = assi.employee_id
        LEFT JOIN `+ appSettings.masters_db + `.employee_details empn ON empn.employee_id = aas.owner_of_asset
        LEFT JOIN `+ appSettings.masters_db + `.departments dep ON dep.dept_id = empd.department_id
        WHERE aas.asset_id >0 `;
        if (req.assetCode) {
            getEntities = getEntities + 'and aas.assets_code = "' + req.assetCode + '"'
        }
        if (req.status) {
            getEntities = getEntities + 'and aas.status = "' + req.status + '"'
        }
        if (req.amcAvailable) {
            getEntities = getEntities + 'and aas.amc_available = "' + req.amcAvailable + '"'
        }
        if (req.warrentyAvailable) {
            getEntities = getEntities + 'and aas.warrenty_available = "' + req.warrentyAvailable + '"'
        }
        if (req.insuranceAvailable) {
            getEntities = getEntities + 'and aas.insurance = "' + req.insuranceAvailable + '"'
        }
        if (req.fromDate) {
            getEntities = getEntities + 'and aas.date_of_purchased BETWEEN "' + req.fromDate + '" AND "' + req.toDate + '"'
        }
        if (req.plant) {
            getEntities = getEntities + 'and unc.unit_name = "' + req.plant + '"'
        }
        if (req.location) {
            getEntities = getEntities + 'and loc.location_name = "' + req.location + '"'
        }
        if (req.assetType) {
            getEntities = getEntities + 'and aas.asset_type = "' + req.assetType + '"'
        }
        if (req.department) {
            getEntities = getEntities + 'and dep.dept_name = "' + req.department + '" and aas.status = "' + AssetStatusEnum.Running + '"'
        }
        if (req.assetCategory) {
            getEntities = getEntities + 'and isc.item_sub_category = "' + req.assetCategory + '"'
        }
        if (req.employeeId) {
            getEntities = getEntities + 'and assi.employee_id = "' + req.employeeId + '" and aas.status = "' + AssetStatusEnum.Running + '"'
        }
        if (req.warrantyStartDate) {
            getEntities = getEntities + 'and aas.warrenty_expired_date BETWEEN "' + req.warrantyStartDate + '" AND "' + req.warrantyEndDate + '"'
        }
        if (req.insuranceStartDate) {
            getEntities = getEntities + 'and aas.insurance_date BETWEEN "' + req.insuranceStartDate + '" AND "' + req.insuranceEndDate + '"'
        }
        if (req.plant && req.location) {
            getEntities = getEntities + 'and unc.unit_name = "' + req.plant + '" and loc.location_name = "' + req.location + '"'
        }
        if (req.plantId > 0 && req.plantId != 5) {
            getEntities = getEntities + 'and aas.plant = ' + req.plantId
        }
        if (req.assetCost != undefined) {
            if (req.assetCost == '0-25,000') {
                getEntities = getEntities + ' and aas.asset_cost between 0 and 25000'
            }
            if (req.assetCost == '25,000-50,000') {
                getEntities = getEntities + ' and aas.asset_cost between 25000 and 50000'
            }
            if (req.assetCost == '50,000-1 lak') {
                getEntities = getEntities + ' and aas.asset_cost between 50000 and 100000'
            }
            if (req.assetCost == 'above 1 lak') {
                getEntities = getEntities + ' and aas.asset_cost > 100000'
            }
        }
        if (req.aging != undefined) {
            if (req.aging != undefined) {
                if (req.aging == '0-50') {
                    getEntities = getEntities + ' having assetAge < 50 '
                }
                if (req.aging == '0-90') {
                    getEntities = getEntities + ' having assetAge between 0 and 90'
                }
                if (req.aging == '0-180') {
                    getEntities = getEntities + ' having assetAge between 0 and 180'
                }
                if (req.aging == '0-365') {
                    getEntities = getEntities + ' having assetAge between 0 and 365'
                }
                if (req.aging == '0-1095') {
                    getEntities = getEntities + ' having assetAge between 0 and 1095'
                }
                if (req.aging == '0-1825') {
                    getEntities = getEntities + '  having assetAge between 0 and 1825'
                }
                if (req.aging == 'above 1825') {
                    getEntities = getEntities + '  having assetAge > 1825'
                }
            }
        }
        if (req.assetMode) {
            getEntities = getEntities + ' and aas.asset_mode = "' + req.assetMode + '"'
        }
        if (req.assetCost != undefined) {
            getEntities = getEntities + ` ORDER BY CAST(aas.asset_cost AS UNSIGNED) ASC `
        } else if (req.insuranceStartDate) {
            getEntities = getEntities + ` ORDER BY aas.insurance_date ASC `
        } else if (req.warrantyStartDate) {
            getEntities = getEntities + ` ORDER BY aas.warrenty_expired_date ASC `
        } else if (req.fromDate) {
            getEntities = getEntities + ` ORDER BY aas.date_of_purchased ASC `
        } else if (req.aging != undefined) {
            getEntities = getEntities + ` ORDER BY assetAge ASC`
        } else {
            getEntities = getEntities + ` ORDER BY it.item_name ASC `
        }
            const count = getEntities.length
            console.log(count,'CCCCCCCCCCCcccccccccccccccccccccccccc')
        // Add pagination clauses: LIMIT and OFFSET
            getEntities += ` LIMIT ${limit} OFFSET ${offset}`;
        const assetdata: {
            asset_category: number, assets_name: number, assets_code: string, amc_available: string, date_of_purchased: Date,
            name: string, warrenty_expired_date: Date, insurance_date: Date, insurance: string, warrenty_available: string,
            expired_date: Date, asset_cost: number, status: AssetStatusEnum, asset_serialno: string, asset_condition: string, invoice: string, model: string,
            asset_supplier: string, item_id: number, grn_id: number, no_of_units: number, year: Date, units_of_measurements: string, last_checkin: Date, last_checkout: Date, amc_reason: string,
            asset_invoice_no: string, owner_of_asset: string, department: string, employee_id: number, maintenance_duedate: Date, transaction_date: Date, decommission_approved_by: string,
            service_tenure: string, insurance_provided_by: string, plant: number, asset_id: number, location_name: string, asset_type: string, employee_name: string, dept_name: string, item_sub_category: string, item_name: string, plantName: string, service_status: string, service_type: string, frequency_of_service: string, month: any, day: any, assetAge: any, asset_mode: string, amc_provider: string, insurance_reference_number: string
        }[] = await manager.query(getEntities)
        const response = [];
        assetdata.forEach(data => {
            response.push(new AssetGridDto(data.asset_id, data.assets_name, data.assets_code, data.asset_serialno, data.item_id, data.grn_id,
                data.no_of_units, data.insurance, data.insurance_date, null, data.model, data.year,
                data.asset_supplier, data.asset_invoice_no, data.expired_date, data.asset_cost, data.date_of_purchased, data.asset_category, data.status, data.asset_condition, data.amc_available, data.name,
                null, data.owner_of_asset, data.units_of_measurements, data.location_name, data.last_checkin, data.last_checkout, data.warrenty_available, data.warrenty_expired_date,
                data.employee_id, data.department, data.maintenance_duedate, data.transaction_date, null, true, data.item_name, null, 1, data.decommission_approved_by,
                data.service_tenure, data.insurance_provided_by, data.plant, data.amc_reason, data.item_sub_category, data.asset_type, data.employee_name, data.dept_name, data.service_status, data.service_type, data.amc_provider, data.frequency_of_service, data.month, data.day, null, data.plantName, null, null, null, null, data.asset_mode, data.assetAge, data.insurance_reference_number))
        })
        
        const pagination = new PaginationReq(page, limit, count)
        const responseObj: PaginatedResponse = new PaginatedResponse(pagination, response)
        
        return new CommonResponse(true, 1, 'Data retrieved successfully', responseObj)
    }

    // async getByAssetsData(req: AssetByStatus): Promise<CommonResponse> {
    //     const manager = getManager();
    //     const page = req?.page || 1;
    //     const limit = req?.limit || 20;
    //     const offset = (page - 1) * limit;
    
    //     let baseQuery = `
    //         SELECT 
    //             aas.asset_id AS assetId,aas.assets_name AS assetsName, aas.assets_code AS assetsCode, aas.date_of_purchased AS dateOfPurchased, aas.asset_cost AS assetCost, 
    //             aas.status, aas.asset_serialno AS assetSerialNo, aas.warrenty_expired_date AS warrentyExpiredDate, aas.insurance_date AS insuranceDate,unc.unit_name AS plant,
    //             loc.location_name AS currentLocation,it.item_name AS itemName, isc.item_sub_category AS assetCategory
    //         FROM ${appSettings.assets_db}.assets aas
    //         LEFT JOIN ${appSettings.masters_db}.unitcodes unc ON unc.unit_code_id = aas.plant
    //         LEFT JOIN ${appSettings.assets_db}.asset_location_mapping lo ON lo.asset_id = aas.asset_id
    //         LEFT JOIN ${appSettings.assets_db}.location loc ON loc.location_id = lo.location_id
    //         LEFT JOIN ${appSettings.masters_db}.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
    //         LEFT JOIN ${appSettings.masters_db}.items it ON it.item_id = aas.assets_name
    //         WHERE aas.asset_id > 0`;
    
    //     // Add filters
    //     if (req?.assetCode) { baseQuery += ` AND aas.assets_code = '${req.assetCode}'`};
    //     if (req?.plant){ baseQuery += ` AND unc.unit_name = '${req.plant}'`};
    //     if (req?.location){ baseQuery += ` AND loc.location_name = '${req.location}'`};
    //     if (req?.assetCategory) { baseQuery += ` AND isc.item_sub_category = '${req.assetCategory}'`};
    
    //     // Count total records (without LIMIT/OFFSET)
    //     const countQuery = `SELECT COUNT(*) as totalCount FROM (${baseQuery}) as countQuery`;
    
    //     // Paginate the query
    //     const paginatedQuery = baseQuery + ` LIMIT ${limit} OFFSET ${offset}`;
    
    //     // Run both queries
    //     const [countResult, assetData] = await Promise.all([
    //         manager.query(countQuery),
    //         manager.query(paginatedQuery)
    //     ]);
    
    //     const totalRecords = countResult[0].totalCount;
        
    //     // Prepare the response
    //     const pagination = new PaginationReq(page, limit, totalRecords);
    //     const responseObj: PaginatedResponse = new PaginatedResponse(pagination, assetData);
    
    //     return new CommonResponse(true, 1, 'Data retrieved successfully', responseObj);
    // }
    async getByAssetsData(req: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        const page = req?.page || 1;
        const limit = req?.limit || 20;
        const offset = (page - 1) * limit;
    
        // Base query to retrieve assets data
        let baseQuery = `
            SELECT 
                aas.asset_id AS assetId, aas.assets_name AS assetsName, aas.assets_code AS assetsCode, 
                aas.date_of_purchased AS dateOfPurchased, aas.asset_cost AS assetCost, 
                aas.status, aas.asset_serialno AS assetSerialNo, aas.warrenty_expired_date AS warrentyExpiredDate, 
                aas.insurance_date AS insuranceDate, unc.unit_name AS plant,
                loc.location_name AS currentLocation, it.item_name AS itemName, 
                isc.item_sub_category AS assetCategory
            FROM ${appSettings.assets_db}.assets aas
            LEFT JOIN ${appSettings.masters_db}.unitcodes unc ON unc.unit_code_id = aas.plant
            LEFT JOIN ${appSettings.assets_db}.asset_location_mapping lo ON lo.asset_id = aas.asset_id
            LEFT JOIN ${appSettings.assets_db}.location loc ON loc.location_id = lo.location_id
            LEFT JOIN ${appSettings.masters_db}.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
            LEFT JOIN ${appSettings.masters_db}.items it ON it.item_id = aas.assets_name
            WHERE aas.asset_id > 0`;
    
        // Add filters (search filters)
        let hasFilters = false;
    
        if (req?.assetCode) { 
            baseQuery += ` AND aas.assets_code = '${req.assetCode}'`;
            hasFilters = true;
        }
        if (req?.plant) { 
            baseQuery += ` AND unc.unit_name = '${req.plant}'`;
            hasFilters = true;
        }
        if (req?.location) { 
            baseQuery += ` AND loc.location_name = '${req.location}'`;
            hasFilters = true;
        }
        if (req?.assetCategory) { 
            baseQuery += ` AND isc.item_sub_category = '${req.assetCategory}'`;
            hasFilters = true;
        }
    
        // Count total records (without LIMIT/OFFSET)
        const countQuery = `SELECT COUNT(*) as totalCount FROM (${baseQuery}) as countQuery`;
    
        // If no filters are applied, apply pagination
        let paginatedQuery = baseQuery;
        if (!hasFilters) {
            paginatedQuery += ` LIMIT ${limit} OFFSET ${offset}`;
        }
    
        // Run both queries
        const [countResult, assetData] = await Promise.all([
            manager.query(countQuery),
            manager.query(paginatedQuery)
        ]);
    
        const totalRecords = countResult[0].totalCount;
        
        // Prepare the response with pagination
        const pagination = new PaginationReq(page, limit, totalRecords);
        const responseObj: PaginatedResponse = new PaginatedResponse(pagination, assetData);
    
        return new CommonResponse(true, 1, 'Data retrieved successfully', responseObj);
    }
    
    async getAssetsCodeData(): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let query = `SELECT assets_code AS assetsCode FROM shahi_assets.assets`;

            const results = await manager.query(query);  

            if (results.length > 0) {
                return new CommonResponse(true, 1, 'Data retrieved successfully', results);
            } else {
                return new CommonResponse(false, 0, 'No data found');
            }
        } catch (error) {
            throw error;
        }
    }



    async activateOrDeactivate(req: AssetsRequest): Promise<CommonResponse> {
        try {
            const Exists = await this.getAssetsById(req.assetId);
            if (Exists) {
                if (req.versionFlag !== Exists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current Asset information.Refresh and try again');
                } else {

                    const Status = await this.repo.update(
                        { assetId: req.assetId },
                        { isActive: req.isActive, updatedUser: req.updatedUser });

                    if (Exists.isActive) {
                        if (Status.affected) {
                            return new CommonResponse(true, 1, 'Asset Deactivated Sucessfully');
                        } else {
                            throw new ErrorResponse(10111, 'Asset is already deactivated');
                        }
                    } else {
                        if (Status.affected) {

                            return new CommonResponse(true, 2, 'Asset Activated Sucessfully');
                        } else {
                            throw new ErrorResponse(10112, 'asset is already activated');
                        }
                    }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }


    async getAssetsById(assetId: number): Promise<Assets> {
        const Response = await this.repo.findOne({
            where: { assetId: assetId },
        });
        if (Response) {
            return Response;
        } else {
            return null;
        }
    }

    async getByAssetCode(assetCode: AssetByCode): Promise<CommonResponse> {
        const getData = [];
      
        // Fetch asset_id based on assetCode
        const assetObject: { asset_id: number } = await this.repo.createQueryBuilder('assets')
          .select('asset_id')
          .where(`assets_code = '${assetCode.assetsCode}'`)
          .getRawOne();
      
        // Check if asset code exists
        if (!assetObject) {
          return new CommonResponse(false, 99898, 'Asset Code not found');
        }
      
        const assetCodeStatus = Number(assetObject.asset_id);
      
        const manager = getManager();
        let qry = `WITH RankedServices AS (
          SELECT 
              asset_id,
              asset_service_date,
              asset_serve_id AS assetServeId,
              STATUS,
              ROW_NUMBER() OVER (PARTITION BY asset_id, STATUS ORDER BY asset_service_date DESC) AS rn
          FROM 
              shahi_assets.asset_service 
          WHERE 
              asset_id = ${assetCodeStatus} AND (STATUS = 'APPROVED' OR STATUS = 'OPEN')
      ),
      ServiceDates AS (
          SELECT 
              asset_id,
              MAX(CASE WHEN STATUS = 'APPROVED' AND rn = 1 THEN asset_service_date END) AS lastApprovedServiceDate,
              MAX(CASE WHEN STATUS = 'OPEN' AND rn = 1 THEN asset_service_date END) AS newOpenServiceDate,
              MAX(CASE WHEN STATUS = 'OPEN' AND rn = 1 THEN assetServeId END) AS assetServiceId         FROM 
              RankedServices
          GROUP BY 
              asset_id
      )
      SELECT 
          u.unit_name as plantName,
          aas.asset_id,
          aas.assets_code AS assetsCode,
          aas.asset_serialno AS assetSerialNo, 
          it.item_name AS assetName,
          its.item_sub_category AS assetCategory,
          lo.location_id,
          loc.location_name,
          unc.unit_name as plant,
          emp.employee_name, 
          sd.lastApprovedServiceDate, 
          sd.newOpenServiceDate,
          sd.assetServiceId
      FROM 
          ${appSettings.assets_db}.assets aas 
      LEFT JOIN 
          ${appSettings.assets_db}.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
      LEFT JOIN 
          ${appSettings.assets_db}.location loc ON loc.location_id = lo.location_id 
      LEFT JOIN 
          ${appSettings.masters_db}.items it ON it.item_id = aas.assets_name 
      LEFT JOIN 
          ${appSettings.masters_db}.item_sub_categories its ON its.item_sub_category_id = aas.asset_category 
      LEFT JOIN 
          ${appSettings.masters_db}.unitcodes unc ON unc.unit_code_id = aas.plant
      LEFT JOIN 
          ${appSettings.masters_db}.employee_details emp ON emp.employee_id = aas.owner_of_asset 
      LEFT JOIN 
          ${appSettings.masters_db}.unitcodes u ON u.unit_code_id = aas.plant
      LEFT JOIN 
          ServiceDates sd ON sd.asset_id = aas.asset_id		
      WHERE 
          aas.asset_id = ${assetCodeStatus}`;
      
        // Check if the plant is provided in the request, and add it as a condition
        if (assetCode?.plant) {
          qry += ` AND aas.plant = '${assetCode.plant}'`;
        }
      
        qry += ` ORDER BY it.item_name ASC`;
      
        // Execute the query
        const data = await manager.query(qry);
      
        // Check if the data is found and whether it is related to the given plant
        if (data && data.length > 0) {
          // If the plant is provided in the request and no matching data is found, return an error
          if (assetCode?.plant !== assetCode.plant) {
            return new CommonResponse(false, 99999, `Asset Code does not belong to the provided plant`);
          }
      
          // Push the data and return success
          getData.push(data);
      
          return new CommonResponse(true, 1, 'Data Retrieved', getData);
        } else {
          // If no data found, return an error
          return new CommonResponse(false, 99898, 'Asset Code not found or not related to the provided plant');
        }
      }
      

      async getByAssetCodeHistory(assetCode: AssetByCode): Promise<CommonResponse> {
        const getData = [];
        const assetObject: { asset_id: number } = await this.repo.createQueryBuilder('assets')
            .select('asset_id')
            .where(`assets_code = '${assetCode.assetsCode}'`)
            .getRawOne();
        const assetCodeStatus = Number(assetObject.asset_id)
        const Response = await this.repo.findOne({ where: { assetId: assetCodeStatus } });
        const manager = getManager();
        const qry = `SELECT u.unit_name as plantName,aas.asset_id, it.item_name AS assetname,its.item_sub_category AS assetCategory,lo.location_id ,loc.location_name,unc.unit_name as plant,emp.employee_name 
        FROM ` + appSettings.assets_db + `.assets aas 
        LEFT JOIN ` + appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
        LEFT JOIN ` + appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
        LEFT JOIN ` + appSettings.masters_db + `.items it ON it.item_id = aas.assets_name 
        LEFT JOIN ` + appSettings.masters_db + `.item_sub_categories its ON its.item_sub_category_id = aas.asset_category 
        LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
        LEFT JOIN `+ appSettings.masters_db + `.employee_details emp ON emp.employee_id = aas.owner_of_asset Left join ` + appSettings.masters_db + `.unitcodes u on u.unit_code_id=aas.plant 
        WHERE aas.asset_id = ${assetCodeStatus}
        ORDER BY it.item_name ASC `
        const data = await manager.query(qry)
        getData.push(Response)
        getData.push(data)

        if (Response) {
            return new CommonResponse(true, 1, 'Data Retrieved', getData)
        }
        else {
            return new CommonResponse(false, 99898, 'Asset Code not found')
        }
    }



    async getAllAssetsEligileForCheckIn(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT isc.item_sub_category AS asset_category, it.item_name AS assets_name,aas.assets_code,aas.amc_available ,aas.date_of_purchased,
        aas.name,aas.warrenty_expired_date,aas.insurance_date,aas.insurance,aas.warrenty_available,aas.expired_date,aas.asset_cost,aas.status, 
        aas.asset_serialno,aas.model,aas.year,aas.asset_supplier,aas.asset_condition,aas.owner_of_asset,aas.transaction_date,aas.decommission_approved_by,
        aas.service_tenure,aas.insurance_provided_by,aas.asset_invoice_no,aas.item_id,aas.grn_id,aas.no_of_units,aas.units_of_measurements,aas.last_checkin,aas.last_checkout,aas.amc_reason,it.item_name,
        aas.department,aas.employee_id,aas.maintenance_duedate,aas.asset_id,unc.unit_name AS plant,aas.asset_type,DATEDIFF(DATE(NOW()),aas.date_of_purchased) AS assetAge,aas.asset_mode,
        locc.location_id,lo.location_id ,loc.location_name FROM ` + appSettings.assets_db + `.assets aas 
        LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
        LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id 
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        WHERE aas.status = '${AssetStatusEnum.Idle}' `
        if (req.assetCode) {
            getEntities = getEntities + 'and aas.assets_code = "' + req.assetCode + '"'
        }
        // if (req.plantId) {
        //     getEntities = getEntities + 'and aas.plant = ' + req.plantId + ''
        // }
        if (req.location) {
            getEntities = getEntities + 'and loc.location_name = "' + req.location + '"'
        }
        if (req.assetType) {
            getEntities = getEntities + 'and aas.asset_type = "' + req.assetType + '"'
        }
        // if(req.department){
        //     getEntities = getEntities + 'and dep.dept_name = "' + req.department +'"'
        // }
        if (req.assetCategory) {
            getEntities = getEntities + 'and isc.item_sub_category = "' + req.assetCategory + '"'
        }
        if (req.employeeId) {
            getEntities = getEntities + 'and assi.employee_id = ' + req.employeeId + ' and aas.status = "' + AssetStatusEnum.Running + '"'
        }
        if (req.plantId && req.location) {
            getEntities = getEntities + 'and aas.plant = ' + req.plantId + ' and loc.location_name = "' + req.location + '"'
        }
        if (req.plantId && req.assetCode) {
            getEntities = getEntities + 'and aas.plant = ' + req.plantId + ' and aas.assets_code= "' + req.assetCode + '"'
        }
        if (req.plantId > 0 && req.plantId != 5) {
            getEntities = getEntities + 'and aas.plant = ' + req.plantId + ''
        }
        getEntities = getEntities + ` ORDER BY it.item_name ASC `

        const assetdata: {
            asset_category: string, assets_name: number, assets_code: string, amc_available: string, date_of_purchased: Date,
            name: string, warrenty_expired_date: Date, insurance_date: Date, insurance: string, warrenty_available: string,
            expired_date: Date, asset_cost: number, status: AssetStatusEnum, asset_serialno: string, asset_condition: string, invoice: string, model: string,
            asset_supplier: string, item_id: number, grn_id: number, no_of_units: number, year: Date, units_of_measurements: string, last_checkin: Date, last_checkout: Date, amc_reason: string,
            asset_invoice_no: string, owner_of_asset: string, department: string, employee_id: number, maintenance_duedate: Date, transaction_date: Date, decommission_approved_by: string,
            service_tenure: string, insurance_provided_by: string, plant: string, asset_id: number, location_name: string, asset_type: string, assetAge: any, item_name: string, asset_mode: string
        }[] = await manager.query(getEntities)

        const response = [];
        assetdata.forEach(data => {
            response.push(new AssetDto(data.asset_id, data.assets_name, data.assets_code, data.asset_serialno, data.item_id, data.grn_id,
                data.no_of_units, data.insurance, data.insurance_date, null, data.model, data.year,
                data.asset_supplier, data.asset_invoice_no, data.expired_date, data.asset_cost, data.date_of_purchased, data.asset_category, data.status, data.asset_condition, data.amc_available, data.name,
                null, data.owner_of_asset, data.units_of_measurements, data.location_name, data.last_checkin, data.last_checkout, data.warrenty_available, data.warrenty_expired_date,
                data.employee_id, data.department, data.maintenance_duedate, data.transaction_date, null, true, data.item_name, null, 1, data.decommission_approved_by,
                data.service_tenure, data.insurance_provided_by, data.plant, data.amc_reason, data.asset_category, data.asset_type, null, null, null, null, null, null, null, null, null, null, null, null, null, null, data.asset_mode, data.assetAge))
        })
        return new CommonResponse(true, 1, 'Data retrieved successfully', response)
    }


    async assetsCheckInMonthWiseCount(): Promise<CommonResponse> {
        const data = [];
        try {
            const manager = getManager()
            const query = `SELECT SUM(IF(MONTH(check_in) = 1,1,0)) AS jan ,SUM(IF(MONTH(check_in) = 2,1,0)) AS feb,SUM(IF(MONTH(check_in) = 3,1,0)) AS mar,
          SUM(IF(MONTH(check_in) = 4,1,0)) AS apr , SUM(IF(MONTH(check_in) = 5,1,0)) AS may ,
          SUM(IF(MONTH(check_in) = 6,1,0)) AS jun , SUM(IF(MONTH(check_in) = 7,1,0)) AS july ,
          SUM(IF(MONTH(check_in) = 8,1,0)) AS aug , SUM(IF(MONTH(check_in) = 9,1,0)) AS sep,
          SUM(IF(MONTH(check_in) = 10,1,0)) AS octo , SUM(IF(MONTH(check_in) = 11,1,0)) AS nov ,
          SUM(IF(MONTH(check_in) = 12,1,0)) AS decm  FROM ` + appSettings.assets_db + `.asset_assignment_transactions `
            const dropData = await manager.query(query);
            data.push(dropData)
            const query1 = `SELECT SUM(IF(MONTH(check_out) = 1,1,0)) AS jan ,SUM(IF(MONTH(check_out) = 2,1,0)) AS feb,SUM(IF(MONTH(check_out) = 3,1,0)) AS mar,
          SUM(IF(MONTH(check_out) = 4,1,0)) AS apr , SUM(IF(MONTH(check_out) = 5,1,0)) AS may ,
          SUM(IF(MONTH(check_out) = 6,1,0)) AS jun , SUM(IF(MONTH(check_out) = 7,1,0)) AS july ,
          SUM(IF(MONTH(check_out) = 8,1,0)) AS aug , SUM(IF(MONTH(check_out) = 9,1,0)) AS sep,
          SUM(IF(MONTH(check_out) = 10,1,0)) AS octo , SUM(IF(MONTH(check_out) = 11,1,0)) AS nov ,
          SUM(IF(MONTH(check_out) = 12,1,0)) AS decm  FROM ` + appSettings.assets_db + `.asset_assignment_transactions `
            const dropData1 = await manager.query(query1);
            data.push(dropData1)
            if (dropData) {
                return new CommonResponse(true, 11608, 'Month Count Retrived Successsfully', data)
            } else {
                return new CommonResponse(true, 11608, 'Something went wrong')
            }
        }
        catch (error) {
            return error
        }

    }



    async assetsCount(): Promise<CommonResponse> {
        const data = [];
        try {

            const manager = getManager()
            const query = `SELECT COUNT(assets_code) AS no_of_assets FROM ` + appSettings.assets_db + `.assets`
            const dropData = await manager.query(query);
            data.push(dropData);
            const query1 = `SELECT COUNT(check_in) AS today_checkins FROM ` + appSettings.assets_db + `.asset_assignment  WHERE check_in = Date(now())`
            const dropData1 = await manager.query(query1);
            data.push(dropData1);
            const query2 = `SELECT COUNT(check_out) AS today_checkouts FROM ` + appSettings.assets_db + `.asset_assignment  WHERE check_out = Date(now())`
            const dropData2 = await manager.query(query2);
            data.push(dropData2);
            const query3 = `SELECT COUNT(assets_code) AS undermaintenance_assets,SUM(SUBSTRING_INDEX(asset_cost,'.',1)) AS undermaintainance_cost,aas.asset_type FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.masters_db + `.items it ON it.item_id = aas.assets_name WHERE STATUS='UNDERMAINTENANCE' GROUP BY aas.asset_type`
            const dropData3 = await manager.query(query3);
            data.push(dropData3);
            const query4 = `SELECT COUNT(asset_id) AS damaged_assets,SUM(SUBSTRING_INDEX(asset_cost,'.',1)) AS asset_cost,aas.asset_type FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.masters_db + `.items it ON it.item_id = aas.assets_name WHERE STATUS = 'DAMAGED' GROUP BY aas.asset_type`
            const dropData4 = await manager.query(query4);
            data.push(dropData4);
            const query5 = `SELECT COUNT(location_id) AS locations_count FROM ` + appSettings.assets_db + `.location`
            const dropData5 = await manager.query(query5);
            data.push(dropData5);
            const query6 = `SELECT COUNT(asset_id) AS checkin_assets,SUM(SUBSTRING_INDEX(asset_cost,'.',1)) AS checkin_cost,aas.asset_type FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.masters_db + `.items it ON it.item_id = aas.assets_name WHERE STATUS='Running' GROUP BY aas.asset_type`
            const dropData6 = await manager.query(query6);
            data.push(dropData6);
            const query7 = `SELECT COUNT(asset_id) AS instock_assets,SUM(SUBSTRING_INDEX(asset_cost,'.',1)) AS instock_cost,aas.asset_type FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.masters_db + `.items it ON it.item_id = aas.assets_name WHERE STATUS='Idle' GROUP BY aas.asset_type`;
            const dropData7 = await manager.query(query7);
            data.push(dropData7);
            const query8 = `SELECT COUNT(asset_id) AS total_assets,SUM(SUBSTRING_INDEX(asset_cost,'.',1)) AS asset_cost,aas.asset_type FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.masters_db + `.items it ON it.item_id = aas.assets_name GROUP BY aas.asset_type`
            const dropData8 = await manager.query(query8);
            data.push(dropData8);
            const query9 = `SELECT COUNT(asset_id) AS decommisioned_assets,SUM(SUBSTRING_INDEX(asset_cost,'.',1)) AS decommisioned_cost,aas.asset_type FROM ` + appSettings.assets_db + `.assets aas  LEFT JOIN ` + appSettings.masters_db + `.items it ON it.item_id = aas.assets_name WHERE STATUS = '${AssetStatusEnum.Retired}' GROUP BY aas.asset_type`
            const dropData9 = await manager.query(query9);
            data.push(dropData9);


            if (data) {
                return new CommonResponse(true, 11608, "Assets retrieved successfully", data)
            } else {
                return new CommonResponse(true, 11608, "Something went wrong")
            }
        }
        catch (error) {
            return error
        }
    }


    async assetsStatusCount(): Promise<CommonResponse> {
        try {
            const manager = getManager()
            const query = ` SELECT COUNT(asset_id) AS assets ,status FROM ` + appSettings.assets_db + `.assets 
          GROUP BY status `
            const dropData = await manager.query(query);
            if (dropData) {
                return new CommonResponse(true, 11608, "Assets retrieved successfully", dropData)
            } else {
                return new CommonResponse(true, 11608, "Something went wrong")
            }
        }
        catch (error) {
            return error
        }
    }



    async getAssetSummaryReport() {
        try {
            const manager = getManager()
            let assetsQuery = `SELECT COUNT(asset_id) FROM assets WHERE DATE(created_at)=DATE_SUB(CURDATE(), INTERVAL 1 DAY)`
            let checkInQuery = `SELECT COUNT(check_in) FROM asset_assignment WHERE DATE(created_at)=DATE_SUB(CURDATE(), INTERVAL 1 DAY`
            let checkOutQuery = `SELECT COUNT(check_out) FROM asset_assignment WHERE DATE(created_at)=DATE_SUB(CURDATE(), INTERVAL 1 DAY`
            let maintainanceQuery = `SELECT COUNT(asset_maintainance_id) FROM asset_maintainance WHERE DATE(created_at)=DATE_SUB(CURDATE(), INTERVAL 1 DAY)`
            const assetsData = await manager.query(assetsQuery);
            const checkInData = await manager.query(checkInQuery);
            const checkOutData = await manager.query(checkOutQuery);
            const maintainanceData = await manager.query(maintainanceQuery);
            const time = moment().subtract(1, "days").format('MMMM Do, YYYY');
            const nowTime = moment().subtract(0, "days").format('MMMM Do, YYYY')
            const parameters = [
                { "type": "text", "text": assetsData.length > 0 ? assetsData : "No Data" },
                { "type": "text", "text": checkInData.length > 0 ? checkInData : "No Data" },
                { "type": "text", "text": checkOutData.length > 0 ? checkOutData : "No Data" },
                { "type": "text", "text": maintainanceData.length > 0 ? maintainanceData : "No Data" }
            ];

        } catch (err) {
            return new ErrorResponse(11108, "Error while sending message")
        }
    }


    @Cron('0 19 * * *')
    async getAssetReport() {
        try {
            const manager = getManager()
            let totalAssets = `SELECT COUNT(assets_name) as totalassets FROM assets`;
            let workingAssets = `SELECT COUNT(assets_name) as workingassets FROM assets WHERE STATUS IN ('Idle','Running')`;
            let underMaintainanceAssets = `SELECT COUNT(assets_name) as maintainanceassets FROM assets WHERE STATUS IN ('UNDERMAINTENANCE')`;
            let damagedAssets = `SELECT COUNT(assets_name) as damagedassets FROM assets WHERE STATUS IN ('DAMAGED')`;
            const assets = await manager.query(totalAssets);
            const workingAssetsData = await manager.query(workingAssets);
            const underMaintainanceAssetsData = await manager.query(underMaintainanceAssets);
            const damagedAssetsData = await manager.query(damagedAssets);
            const parameters = [
                { "type": "text", "text": moment().format('DD-MM-YYYY') },
                { "type": "text", "text": assets ? assets[0].totalassets : "No Data" },
                { "type": "text", "text": workingAssetsData ? workingAssetsData[0].workingassets : "No Data" },
                { "type": "text", "text": damagedAssetsData ? damagedAssetsData[0].damagedassets : "No Data" },
                { "type": "text", "text": underMaintainanceAssetsData ? underMaintainanceAssetsData[0].maintainanceassets : "No Data" },

            ];
            for (const contact of whatsApp.contacts) {
                let statusFlag = true
                const req = await new MessageParameters(contact, 'asset_report', parameters, "en_us")
                const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
                if (!messageStatus.status) {
                    statusFlag = false
                } else {
                    const whatsapplogDto = new WhatsAppLogDto(contact, 'asset_report', 'Brandix_assets', GlobalVariableValues.assetmanagementcompanyId, GlobalVariableValues.assetManagementmoduleId)
                    await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
                }
            }


        } catch (err) {
            return new CommonResponse(false, 11108, "Error while sending message")
        }
    }




    async assetMonthwiseReport(): Promise<CommonResponse> {
        const data = [];
        try {
            const manager = getManager()
            const query = `SELECT SUM(IF(MONTH(created_at) = 1,1,0)) AS jan ,SUM(IF(MONTH(created_at) = 2,1,0)) AS feb,SUM(IF(MONTH(created_at) = 3,1,0)) AS mar,
          SUM(IF(MONTH(created_at) = 4,1,0)) AS apr , SUM(IF(MONTH(created_at) = 5,1,0)) AS may ,
          SUM(IF(MONTH(created_at) = 6,1,0)) AS jun , SUM(IF(MONTH(created_at) = 7,1,0)) AS july ,
          SUM(IF(MONTH(created_at) = 8,1,0)) AS aug , SUM(IF(MONTH(created_at) = 9,1,0)) AS sep,
          SUM(IF(MONTH(created_at) = 10,1,0)) AS octo , SUM(IF(MONTH(created_at) = 11,1,0)) AS nov ,
          SUM(IF(MONTH(created_at) = 12,1,0)) AS decm  FROM ` + appSettings.assets_db + `.assets `
            const dropData = await manager.query(query);
            data.push(dropData)
            if (dropData) {
                return new CommonResponse(true, 11608, 'Month Count Retrived Successsfully', data)
            } else {
                return new CommonResponse(true, 11608, 'Something went wrong')
            }
        }
        catch (error) {
            return error
        }
    }


    async assetsTopWarrenty(): Promise<CommonResponse> {
        const data = [];
        try {
            const manager = getManager();
            const qry = `SELECT aas.assets_code,aas.warrenty_expired_date , it.item_name AS asset_name ,u.unit_name AS unit,DATEDIFF(aas.warrenty_expired_date,DATE(NOW())) AS aging FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.masters_db + `.items it ON it.item_id = aas.assets_name LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id = aas.plant WHERE aas.warrenty_expired_date IS NOT NULL AND aas.warrenty_expired_date>DATE(NOW()) ORDER BY warrenty_expired_date ASC LIMIT 5`

            const dropData = await manager.query(qry)
            data.push(dropData)

            if (dropData) {

                return new CommonResponse(true, 1, ' Data retrievd successfully', data)
            } else {
                return new CommonResponse(false, 99898, 'Something went wrong')
            }
        } catch (error) {
            return error
        }
    }


    async assetsTopInsurance(): Promise<CommonResponse> {
        const data = [];
        try {
            const manager = getManager();
            const qry = `SELECT aas.assets_code,aas.insurance_date , it.item_name AS asset_name,u.unit_name AS unit,DATEDIFF(aas.insurance_date,DATE(NOW())) AS aging FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.masters_db + `.items it ON it.item_id = aas.assets_name LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id = aas.plant WHERE aas.insurance_date IS NOT NULL AND aas.insurance_date>DATE(NOW()) ORDER BY insurance_date ASC LIMIT 5`
            const dropData = await manager.query(qry)
            data.push(dropData)

            if (dropData) {

                return new CommonResponse(true, 1, ' Data retrievd successfully', data)
            } else {
                return new CommonResponse(false, 99898, 'Something went wrong')
            }
        } catch (error) {
            return error
        }
    }


    async getRaciReport(req: AssetRACIReport): Promise<CommonResponse> {
        const data = [];
        try {
            const manager = getManager();
            const page = req?.page || 1;
            const limit = req?.limit || 20;
            const offset = (page - 1) * limit;
    
            let getEntities = `
                SELECT aas.asset_id, it.item_name AS assets_name, aas.assets_code, aas.status,
                       em.employee_name AS responsible, em.employee_name AS accountable,
                       aas.asset_supplier AS consulted, em.reporting_manager AS informed,
                       lo.location_id, loc.location_name, aas.date_of_purchased, unc.unit_name AS plant,
                       aas.asset_serialno
                FROM ${appSettings.assets_db}.assets aas 
                LEFT JOIN ${appSettings.assets_db}.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
                LEFT JOIN ${appSettings.assets_db}.location loc ON loc.location_id = lo.location_id 
                LEFT JOIN ${appSettings.masters_db}.employee_details em ON em.employee_id = aas.employee_id 
                LEFT JOIN ${appSettings.masters_db}.items it ON it.item_id = aas.assets_name 
                LEFT JOIN ${appSettings.masters_db}.unitcodes unc ON unc.unit_code_id = aas.plant
                WHERE aas.asset_id > 0 `;
            let hasFilters = false;
            if (req.assetsCode) {
                getEntities += ` AND aas.assets_code = "${req.assetsCode}" `;
                hasFilters = true;
            }
            if (req.employeeId) {
                getEntities += ` AND em.employee_id = "${req.employeeId}" `;
                hasFilters = true;
            }
            if (req.assetSupplier) {
                getEntities += ` AND aas.asset_supplier = "${req.assetSupplier}" `;
                hasFilters = true;
            }
            if (req.plant) {
                getEntities += ` AND aas.plant = "${req.plant}" `;
                hasFilters = true;
            }
            if (req.location) {
                getEntities += ` AND loc.location_name = "${req.location}" `;
                hasFilters = true;
            }
    
            // Count total records for pagination
            const totalRecordsQuery = `
                SELECT COUNT(*) as total 
                FROM ${appSettings.assets_db}.assets aas 
                LEFT JOIN ${appSettings.assets_db}.location loc ON loc.location_id = aas.asset_id 
                WHERE aas.asset_id > 0 `;
    
            const totalRecordsResult = await manager.query(totalRecordsQuery);
            const totalRecords = totalRecordsResult[0]?.total || 0;
    
            // Add pagination if filters are not applied
            getEntities += ` ORDER BY it.item_name ASC `;
            if (!hasFilters) {
            getEntities += ` LIMIT ${limit} OFFSET ${offset} `;
            }
    
            // Query to get paginated data
            const dropData = await manager.query(getEntities);
            data.push({
                paginatedData: dropData,
                pagination: {
                    total: totalRecords,
                    current: page,
                    pageSize: limit,
                }
            });
    
            return new CommonResponse(true, 1, 'Data retrieved', data);
        } catch (error) {
            return new CommonResponse(false, 0, 'Error retrieving data', []);
        }
    }
    


    async getAllRaciReport(): Promise<CommonResponse> {
        const data = [];
        try {
            const manager = getManager()
            const qry = `SELECT aas.asset_id,it.item_name AS assets_name ,aas.assets_code,aas.status ,em.employee_name AS responsible,emp.employee_name AS accountable ,aas.asset_supplier AS consulted,em.reporting_manager AS informed,lo.location_id ,loc.location_name ,aas.date_of_purchased,unc.unit_name AS plant,aas.asset_type,isc.item_sub_category AS asset_category
            FROM ` + appSettings.assets_db + `.assets aas 
            LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
            LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
            LEFT JOIN `+ appSettings.masters_db + `.employee_details em ON em.employee_id = aas.employee_id 
            LEFT JOIN `+ appSettings.masters_db + `.employee_details emp ON emp.employee_id = aas.owner_of_asset 
            LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name 
            LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
            LEFT JOIN `+ appSettings.masters_db + `.unitcodes unc ON unc.unit_code_id = aas.plant `
            const dropData = await manager.query(qry)
            data.push(dropData)

            return new CommonResponse(true, 1, 'Data retrieved', data)
        } catch (error) {
            return error
        }
    }


    async assetsDamagedCost(): Promise<CommonResponse> {
        const data = [];
        try {
            const manager = getManager();
            const qry = ` SELECT it.item_sub_category AS asset_category,SUM(aas.asset_cost) AS cost_of_assets,COUNT(aas.asset_category) AS quantity,u.unit_name AS unit FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.masters_db + `.item_sub_categories it ON it.item_sub_category_id = aas.asset_category LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id = aas.plant WHERE STATUS = 'DAMAGED' GROUP BY asset_category `
            const dropData = await manager.query(qry)
            data.push(dropData)
            return new CommonResponse(true, 1, 'Data retrieved', data)
        } catch (error) {
            return error
        }
    }

    async departmentWiseCount(): Promise<CommonResponse> {
        const data = [];
        try {
            const manager = getManager()
            const qry = `SELECT COUNT(aas.asset_id) AS asset_count,d.dept_id,d.dept_name,GROUP_CONCAT(em.employee_name) AS employee_name FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.masters_db + `.employee_details em ON em.employee_id = aas.employee_id LEFT JOIN ` + appSettings.masters_db + `.departments d ON d.dept_id = em.department_id WHERE aas.employee_id IS NOT NULL GROUP BY d.dept_id `
            const dropData = await manager.query(qry)
            data.push(dropData)
            return new CommonResponse(true, 1, 'Data retrieved', data)
        } catch (error) {
            return error
        }
    }


    async getExpiredAssets(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT isc.item_sub_category AS asset_category, it.item_name AS assets_name,aas.assets_code AS assetsCode,aas.amc_available ,aas.date_of_purchased,
        aas.name,aas.warrenty_expired_date,aas.insurance_date,aas.insurance,aas.warrenty_available,aas.expired_date,aas.asset_cost,aas.status, 
        aas.asset_serialno,aas.model,aas.year,aas.asset_supplier,aas.asset_condition,emp.employee_name AS owner_of_asset,aas.transaction_date,
        aas.service_tenure,aas.insurance_provided_by,aas.asset_invoice_no,aas.item_id,aas.grn_id,aas.no_of_units,aas.units_of_measurements,aas.last_checkin,aas.last_checkout,aas.amc_reason,
        aas.department,aas.employee_id,aas.maintenance_duedate,aas.asset_id,unc.unit_name AS plant,aas.asset_type,assi.employee_id,empd.employee_name,empd.department_id,dep.dept_name,aas.service_type,aas.service_status,aas.amc_provider,
        locc.location_id,lo.location_id ,loc.location_name,empdet.employee_name AS decommission_approved_by,aas.updated_at,datediff(date(now()),expired_date) as aging,aas.asset_mode FROM ` + appSettings.assets_db + `.assets aas 
        LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
        LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id 
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN `+ appSettings.masters_db + `.employee_details emp ON emp.employee_id = aas.owner_of_asset
        LEFT JOIN `+ appSettings.assets_db + `.asset_assignment assi ON assi.asset_id = aas.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.employee_details empd ON empd.employee_id = assi.employee_id
        LEFT JOIN `+ appSettings.masters_db + `.departments dep ON dep.dept_id = empd.department_id
        LEFT JOIN `+ appSettings.masters_db + `.employee_details empdet ON empdet.employee_id = aas.decommission_approved_by
        WHERE aas.status != '${AssetStatusEnum.Retired}' and aas.expired_Date < DATE(NOW())  `
        if (req.assetCode) {
            getEntities = getEntities + 'and aas.assets_code = "' + req.assetCode + '"'
        }
        if (req.plant) {
            getEntities = getEntities + 'and unc.unit_name = "' + req.plant + '"'
        }
        if (req.location) {
            getEntities = getEntities + 'and loc.location_name = "' + req.location + '"'
        }
        if (req.assetCategory) {
            getEntities = getEntities + 'and isc.item_sub_category = "' + req.assetCategory + '"'
        }
        if (req.plant && req.location) {
            getEntities = getEntities + 'and unc.unit_name = "' + req.plant + '" and loc.location_name = "' + req.location + '"'
        }
        if (req.plantId > 0 && req.plantId != 5) {
            getEntities = getEntities + 'and aas.plant = ' + req.plantId
        }
        if (req.assetType) {
            getEntities = getEntities + ' and aas.asset_type = "' + req.assetType + '"'
        }

        if (req.aging != undefined) {
            if (req.aging == '1000') {
                getEntities = getEntities + ' having aging < 1000 '
            }
            if (req.aging == '1001-2000') {
                getEntities = getEntities + ' having aging between 1001 and 2000'
            }
            if (req.aging == '2001-3000') {
                getEntities = getEntities + ' having aging between 2001 and 3000'
            }
            if (req.aging == 'above 3000') {
                getEntities = getEntities + ' having aging > 3000'
            }
        }
        if (req.aging != undefined) {
            getEntities = getEntities + ``
        } else {
            getEntities = getEntities + ""
            // `ORDER BY aging DESC `
        }

        const data = await manager.query(getEntities)
        if (data) {
            return new CommonResponse(true, 11608, 'Data Retrieved Successfully', data)
        } else {
            return new CommonResponse(true, 11608, 'Somethig Went Wrong')
        }
    }




    async assetDecommission(req: AssetsDto): Promise<CommonResponse> {
        try {
            const entity = await this.repo.findOne({ where: { assetsCode: req.assetsCode } })
            const manager = getManager()
            if (entity.status == 'Idle') {
                if (entity) {
                    const convertedEntity = await this.repo.update({ assetId: entity.assetId }, { status: AssetStatusEnum.Retired, decommissionApprovedBy: req.decommissionApprovedBy })
                    const assetTransDto = new AssetTransactionDto();
                    assetTransDto.decommissionApprovedBy = req.decommissionApprovedBy;
                    assetTransDto.assetId = entity.assetId;
                    assetTransDto.status = AssetStatusEnum.Retired;
                    const assetTransEntity = this.assetTransactionAdapter.convertAssetTransactionDtoToEntity(assetTransDto)
                    const assetTransctionSave = await this.assetTransactionRepo.save(assetTransEntity)
                    let qry = `SELECT a.asset_id , a.assets_code AS AssetCode , it.item_name AS assetName,asset_cost AS assetCost,decommission_approved_by , emp.employee_name AS approvedBy FROM ` + appSettings.assets_db + `.assets a LEFT JOIN ` + appSettings.masters_db + `.items it ON it.item_id = a.assets_name LEFT JOIN ` + appSettings.masters_db + `.employee_details emp ON emp.employee_id = a.decommission_approved_by WHERE a.asset_id = ${entity.assetId}`;
                    const data = await manager.query(qry)
                    const parameters = [
                        { "type": "text", "text": moment().format('DD-MM-YYYY') },
                        { "type": "text", "text": data[0].assetName ? data[0].assetName : "No Data" },
                        { "type": "text", "text": data[0].AssetCode ? data[0].AssetCode : "No Data" },
                        { "type": "text", "text": data[0].assetCost ? Number(Number(data[0].assetCost).toFixed(0)).toLocaleString('en-IN') : "No Data" },
                        { "type": "text", "text": data[0].approvedBy ? data[0].approvedBy : "No Data" },
                    ];
                    for (const contact of whatsApp.contacts) {
                        let statusFlag = true
                        const req = await new MessageParameters(contact, 'asset_decommission', parameters, "en_us")
                        const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
                        if (!messageStatus.status) {
                            statusFlag = false
                        }
                        else {
                            const testdata = 'INSERT INTO ' + appSettings.whatsapp_db + '.whatsapp_logs (contact_no,template_name,project_name,company_id,module_id) VALUES("' + contact + '","asset_decommission","Brandix_assets",' + GlobalVariableValues.companyId + ',' + GlobalVariableValues.assetManagementmoduleId + ')'
                            const result = await manager.query(testdata)
                            const res = new CommonResponse(true, 1111, "Data retreived sucesssfuly", result)
                        }

                    }
                    return new CommonResponse(true, 1, 'Updated successfully')
                }

            } else {
                return new CommonResponse(false, 9989, 'You Cannot Retire the Asset')

            }
        } catch (err) {
            throw err;
        }
        // if (entity) {
        //     const convertedEntity = await this.repo.update({ assetId: entity.assetId }, { status: AssetStatusEnum.RETIRED, decommissionApprovedBy: req.decommissionApprovedBy })
        //     const assetTransDto = new AssetTransactionDto();
        //     assetTransDto.decommissionApprovedBy = req.decommissionApprovedBy;
        //     assetTransDto.assetId = entity.assetId;
        //     assetTransDto.status = AssetStatusEnum.RETIRED;
        //     const assetTransEntity = this.assetTransactionAdapter.convertAssetTransactionDtoToEntity(assetTransDto)
        //     const assetTransctionSave = await this.assetTransactionRepo.save(assetTransEntity)
        //     return new CommonResponse(true, 1, 'Updated successfully')
        // } else {
        //     return new CommonResponse(false, 99899, 'No data found')
        // }

    }


    async assetCodeSearch(assetCode: AssetByCode): Promise<CommonResponse> {
        const getDto: AssetsDto[] = [];
        const assetObject: { asset_id: number } = await this.repo.createQueryBuilder('assets')
            .select('asset_id')
            .where(`assets_code = '${assetCode.assetsCode}'`)
            .getRawOne();
        const assetCodeStatus = Number(assetObject.asset_id)
        const Response = await this.repo.findOne({ where: { assetId: assetCodeStatus, status: AssetStatusEnum.Idle } });
        if (Response) {
            const convertedDto: AssetsDto = this.adapter.convertAssetEntitytoDto(Response)
            const manager = getManager();
            const qry = `SELECT aas.asset_id, it.item_name AS assetname,its.item_sub_category AS assetCategory,lo.location_id ,loc.location_name FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_location_id = aas.asset_id LEFT JOIN ` + appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id LEFT JOIN ` + appSettings.masters_db + `.items it ON it.item_id = aas.assets_name LEFT JOIN ` + appSettings.masters_db + `.item_sub_categories its ON its.item_sub_category_id = aas.asset_category WHERE aas.asset_id = ${assetCodeStatus} ORDER BY it.item_name ASC`
            const data: { item_name: string, item_sub_category: string, location_name: string } = await manager.query(qry)
            convertedDto.itemName = data[0].assetname;
            convertedDto.itemSubCategoryName = data[0].assetCategory;
            convertedDto.currentLocationName = data[0].location_name;
            convertedDto.currentLocation = data[0].location_name;
            getDto.push(convertedDto);

            return new CommonResponse(true, 1, 'Data retrieved successfully', getDto)

        }
        else {
            return new CommonResponse(false, 99898, 'Asset Code not found')
        }
    }


    async getAbstractReport(req?:any): Promise<CommonResponse> {
        const manager = getManager();
        let qry = `SELECT aas.asset_category,it.item_sub_category,itt.item_name AS itemName,SUM( IF(aas.STATUS='Idle', 1 , 0)) AS Instock,
        SUM( IF(aas.STATUS='Running', 1 , 0)) AS checkin,
        SUM( IF(aas.STATUS='UNDERMAINTENANCE', 1 , 0)) AS undermaintainance ,
        SUM( IF(aas.STATUS='DAMAGED', 1 , 0)) AS damaged,
        SUM( IF(aas.STATUS='Retired', 1 , 0)) AS decommissioned,
        SUM( IF(aas.STATUS='Service', 1 , 0)) AS service,
        SUM( IF(aas.STATUS='Intransit', 1 , 0)) AS intransit,
        SUM( IF(aas.STATUS='Sold', 1 , 0)) AS sold,
        COUNT(asset_category) AS total
        FROM shahi_assets.assets aas
        LEFT JOIN shahi_asset_master.item_sub_categories it ON it.item_sub_category_id = aas.asset_category
        LEFT JOIN shahi_asset_master.items itt ON itt.item_id = aas.assets_name where 1=1`
        if(req?.plant){
            qry += ` AND aas.plant = '${req.plant}'`;
        }
         qry += ` GROUP BY aas.assets_name`
        const data = await manager.query(qry);
        return new CommonResponse(true, 1, 'Data retrieevd Successfully', data)
    }

    async getDetailsByAbstract(req: AbstractDetails): Promise<CommonResponse> {
        const manager = getManager();
        let qry = `SELECT isc.item_sub_category AS asset_category, aas.assets_name,aas.assets_code,aas.amc_available ,aas.date_of_purchased,
        aas.name,aas.warrenty_expired_date,aas.insurance_date,aas.insurance,aas.warrenty_available,aas.expired_date,aas.asset_cost,aas.status, 
        aas.asset_serialno,aas.model,aas.year,aas.asset_supplier,aas.asset_condition,emp.employee_name AS owner_of_asset,aas.transaction_date,aas.decommission_approved_by,
        aas.service_tenure,aas.insurance_provided_by,aas.asset_invoice_no,aas.item_id,aas.grn_id,aas.no_of_units,aas.units_of_measurements,aas.last_checkin,aas.last_checkout,aas.amc_reason,
        aas.department,aas.employee_id,aas.maintenance_duedate,aas.asset_id,unc.unit_name AS plant,aas.asset_type,
        locc.location_id,lo.location_id ,loc.location_name,aas.status,it.item_name FROM `+ appSettings.assets_db + `.assets aas 
        LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
        LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id 
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN `+ appSettings.masters_db + `.employee_details emp ON emp.employee_id = aas.owner_of_asset
        WHERE it.item_name = '${req.assetName}' AND aas.status = '${req.status}'
        ORDER BY assets_name ASC`;
        const assetdata: {
            asset_category: string, assets_name: number, assets_code: string, amc_available: string, date_of_purchased: Date,
            name: string, warrenty_expired_date: Date, insurance_date: Date, insurance: string, warrenty_available: string,
            expired_date: Date, asset_cost: number, status: AssetStatusEnum, asset_serialno: string, asset_condition: string, invoice: string, model: string,
            asset_supplier: string, item_id: number, grn_id: number, no_of_units: number, year: Date, units_of_measurements: string, last_checkin: Date, last_checkout: Date, amc_reason: string,
            asset_invoice_no: string, owner_of_asset: string, department: string, employee_id: number, maintenance_duedate: Date, transaction_date: Date, decommission_approved_by: string,
            service_tenure: string, insurance_provided_by: string, plant: string, asset_id: number, location_name: string, asset_type: string, item_name: string
        }[] = await manager.query(qry)

        const response = [];
        assetdata.forEach(data => {
            response.push(new AssetDto(data.asset_id, data.assets_name, data.assets_code, data.asset_serialno, data.item_id, data.grn_id,
                data.no_of_units, data.insurance, data.insurance_date, null, data.model, data.year,
                data.asset_supplier, data.asset_invoice_no, data.expired_date, data.asset_cost, data.date_of_purchased, data.asset_category, data.status, data.asset_condition, data.amc_available, data.name,
                null, data.owner_of_asset, data.units_of_measurements, data.location_name, data.last_checkin, data.last_checkout, data.warrenty_available, data.warrenty_expired_date,
                data.employee_id, data.department, data.maintenance_duedate, data.transaction_date, null, true, data.item_name, null, 1, data.decommission_approved_by,
                data.service_tenure, data.insurance_provided_by, data.plant, data.amc_reason, data.asset_category, data.asset_type))
        })
        return new CommonResponse(true, 1, 'Data retrieved Successfully', response)
    }



    @Cron('0 18 * * *')
    async getAssetTransactionalReport(): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let assets = `SELECT COUNT(assets_name) AS assets FROM assets WHERE DATE(created_at)=DATE(NOW())`;
            let checkIn = `SELECT COUNT(asset_id) AS checkin FROM asset_assignment WHERE DATE(check_in) = DATE(NOW())`;
            let checkOut = `SELECT COUNT(asset_id) AS checkout FROM asset_assignment WHERE DATE(check_out) = DATE(NOW())`;
            let maintainance = `SELECT COUNT(asset_id) AS maintainance FROM asset_maintainance WHERE DATE(created_at) = DATE(NOW())`;
            let damaged = `SELECT COUNT( IF(STATUS='DAMAGED', 1 , 0)) AS damaged FROM assets WHERE DATE(updated_at) = DATE(NOW())`;
            let decommissioned = `SELECT COUNT( IF(STATUS='${AssetStatusEnum.Retired}', 1 , 0)) AS decommissioned FROM assets WHERE DATE(updated_at) = DATE(NOW())`;
            let warrenty = `SELECT COUNT(asset_id) AS warrenty_expired FROM assets WHERE DATE(warrenty_expired_date) = CURDATE()`;
            let insurance = `SELECT COUNT(asset_id) AS insurance_date FROM assets WHERE DATE(insurance_date) = CURDATE()`;
            const assetsProcured = await manager.query(assets);
            const todayCheckin = await manager.query(checkIn);
            const todayCheckout = await manager.query(checkOut);
            const todayMaintainance = await manager.query(maintainance);
            const todayDamaged = await manager.query(damaged);
            const todayDecommissioned = await manager.query(decommissioned);
            const warrentyExpired = await manager.query(warrenty);
            const insuranceExpired = await manager.query(insurance);
            const parameters = [
                { "type": "text", "text": moment().format('DD-MM-YYYY') },
                { "type": "text", "text": assetsProcured ? assetsProcured[0].assets : "No Data" },
                { "type": "text", "text": todayCheckin ? todayCheckin[0].checkin : "No Data" },
                { "type": "text", "text": todayCheckout ? todayCheckout[0].checkout : "No Data" },
                { "type": "text", "text": todayMaintainance ? todayMaintainance[0].maintainance : "No Data" },
                { "type": "text", "text": todayDamaged ? todayDamaged[0].damaged : "No Data" },
                { "type": "text", "text": todayDecommissioned ? todayDecommissioned[0].decommissioned : "No Data" },
                { "type": "text", "text": warrentyExpired ? warrentyExpired[0].warrenty_expired : "No Data" },
                { "type": "text", "text": insuranceExpired ? insuranceExpired[0].insurance_date : "No Data" },
            ];
            for (const contact of whatsApp.contacts) {
                let statusFlag = true
                const req = await new MessageParameters(contact, 'asset_transactional_report', parameters, "en_us")
                const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
                if (!messageStatus.status) {
                    statusFlag = false
                } else {
                    const whatsapplogDto = new WhatsAppLogDto(contact, 'asset_transactional_report', 'Brandix_assets', GlobalVariableValues.assetmanagementcompanyId, GlobalVariableValues.assetManagementmoduleId)
                    await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
                }
            }

        } catch (err) {
            return new CommonResponse(false, 11108, "Error while sending message")
        }
    }

    async getTotalAbstract(req: AbstractDetails): Promise<CommonResponse> {
        const manager = getManager();
        const qry = `SELECT isc.item_sub_category AS asset_category, aas.assets_name,aas.assets_code,aas.amc_available ,aas.date_of_purchased,
        aas.name,aas.warrenty_expired_date,aas.insurance_date,aas.insurance,aas.warrenty_available,aas.expired_date,aas.asset_cost,aas.status, 
        aas.asset_serialno,aas.model,aas.year,aas.asset_supplier,aas.asset_condition,emp.employee_name AS owner_of_asset,aas.transaction_date,aas.decommission_approved_by,it.item_name,
        aas.service_tenure,aas.insurance_provided_by,aas.asset_invoice_no,aas.item_id,aas.grn_id,aas.no_of_units,aas.units_of_measurements,aas.last_checkin,aas.last_checkout,aas.amc_reason,
        aas.department,aas.employee_id,aas.maintenance_duedate,aas.asset_id,unc.unit_name AS plant,aas.asset_type,
        locc.location_id,lo.location_id ,loc.location_name,aas.status FROM `+ appSettings.assets_db + `.assets aas 
        LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
        LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id 
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN `+ appSettings.masters_db + `.employee_details emp ON emp.employee_id = aas.owner_of_asset
        WHERE it.item_name = '${req.assetName}'
        ORDER BY assets_name ASC`;
        const assetdata: {
            asset_category: string, assets_name: number, assets_code: string, amc_available: string, date_of_purchased: Date,
            name: string, warrenty_expired_date: Date, insurance_date: Date, insurance: string, warrenty_available: string,
            expired_date: Date, asset_cost: number, status: AssetStatusEnum, asset_serialno: string, asset_condition: string, invoice: string, model: string,
            asset_supplier: string, item_id: number, grn_id: number, no_of_units: number, year: Date, units_of_measurements: string, last_checkin: Date, last_checkout: Date, amc_reason: string,
            asset_invoice_no: string, owner_of_asset: string, department: string, employee_id: number, maintenance_duedate: Date, transaction_date: Date, decommission_approved_by: string,
            service_tenure: string, insurance_provided_by: string, plant: string, asset_id: number, location_name: string, asset_type: string, item_name: string
        }[] = await manager.query(qry)

        const response = [];
        assetdata.forEach(data => {
            response.push(new AssetDto(data.asset_id, data.assets_name, data.assets_code, data.asset_serialno, data.item_id, data.grn_id,
                data.no_of_units, data.insurance, data.insurance_date, null, data.model, data.year,
                data.asset_supplier, data.asset_invoice_no, data.expired_date, data.asset_cost, data.date_of_purchased, data.asset_category, data.status, data.asset_condition, data.amc_available, data.name,
                null, data.owner_of_asset, data.units_of_measurements, data.location_name, data.last_checkin, data.last_checkout, data.warrenty_available, data.warrenty_expired_date,
                data.employee_id, data.department, data.maintenance_duedate, data.transaction_date, null, true, data.item_name, null, 1, data.decommission_approved_by,
                data.service_tenure, data.insurance_provided_by, data.plant, data.amc_reason, data.asset_category, data.asset_type))
        })
        return new CommonResponse(true, 1, 'Data retrieved Successfully', response)
    }

    async historyReport(req: AssetByStatus): Promise<CommonResponse> {
        const data = [];
        try {
            const manager = getManager()
            const query = `SELECT aas.assets_name,it.item_name,aas.asset_serialno,aas.name,aas.assets_code,aas.insurance_date,aas.model,aas.year,aas.expired_date,aas.asset_cost,aas.date_of_purchased,aas.asset_category,its.item_sub_category,aas.status,aas.warrenty_expired_date,aas.owner_of_asset,em.employee_name,loc.location_name
            FROM `+ appSettings.assets_db + `.assets aas 
            LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name 
            LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories its ON its.item_sub_category_id = aas.asset_category 
            LEFT JOIN `+ appSettings.masters_db + `.employee_details em ON em.employee_id = aas.owner_of_asset 
            LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
            LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
            LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id 
            WHERE aas.assets_code = '${req.assetCode}' OR aas.created_at BETWEEN '${req.fromDate}' AND '${req.toDate}'`
            const dropData = await manager.query(query)
            data.push(dropData);
            const locationQuery = `SELECT aas.asset_category,aas.assets_name,it.item_name,isc.item_sub_category,ass.asset_location_transaction_id,ass.asset_id,ass.asset_location_id,ass.location_id,loc.location_name,aas.assets_code 
            FROM `+ appSettings.assets_db + `.asset_location_transactions ass 
            LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = ass.location_id 
            LEFT JOIN `+ appSettings.assets_db + `.assets aas ON aas.assets_name = ass.asset_id 
            LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name 
            LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
            WHERE aas.assets_code = '${req.assetCode}' OR ass.created_at BETWEEN '${req.fromDate}' AND '${req.toDate}'`
            const dropData1 = await manager.query(locationQuery)
            data.push(dropData1)
            const assignmentQuery = `SELECT aas.assets_name,it.item_name,assign.asset_assignment_id,assign.asset_id,assign.employee_id,assign.check_in,assign.checkin_reason,assign.check_out,assign.checkout_reason,em.employee_name,em.mobile_no
            FROM `+ appSettings.assets_db + `.asset_assignment_transactions assign 
            LEFT JOIN `+ appSettings.assets_db + `.assets aas ON aas.assets_name = assign.asset_id 
            LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name 
            LEFT JOIN `+ appSettings.masters_db + `.employee_details em ON em.employee_id = assign.employee_id 
            WHERE aas.assets_code = '${req.assetCode}' OR assign.created_at BETWEEN '${req.fromDate}' AND '${req.toDate}' ORDER BY DATE(NOW())`
            const dropData2 = await manager.query(assignmentQuery)
            data.push(dropData2)
            const maintainanceQuery = `SELECT aas.assets_code,aas.owner_of_asset,aas.assets_name,am.asset_maintainance_id,am.asset_id,am.maintainance_type,am.cost_of_repair,am.damage_reason,am.created_at,am.updated_at,it.item_name,em.employee_name
            FROM `+ appSettings.assets_db + `.asset_maintainance_transactions am 
            LEFT JOIN `+ appSettings.assets_db + `.assets aas ON aas.asset_id = am.asset_id 
            LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name 
            LEFT JOIN `+ appSettings.masters_db + `.employee_details em ON em.employee_id = aas.owner_of_asset
            WHERE aas.assets_code = '${req.assetCode}' OR am.created_at BETWEEN '${req.fromDate}' AND '${req.toDate}'`
            const dropData3 = await manager.query(maintainanceQuery)
            data.push(dropData3)
            if (data) {
                return new CommonResponse(true, 11608, 'Data Retrieved Successfully', data)
            } else {
                return new CommonResponse(true, 11608, 'Somethig Went Wrong')
            }
        } catch (error) {
            return error;
        }
    }

    async createAssetService(createDto: AssetServiceDto | any): Promise<CommonResponse> {
        const transactionManager = new GenericTransactionManager
        try {
            await transactionManager.startTransaction()
            const manager = getManager()
            let plannedResult
            let unplannedResult
            if (createDto.serviceType == 'planned') {
                plannedResult = await this.createPlannedServiceEntries(createDto, transactionManager)

            } else {
                console.log(createDto, 'createDto')
                const entity = this.assetServiceAdapter.convertDtoToEntity(createDto);
                unplannedResult = await transactionManager.getCustomRepository(AssetServiceRepository).save(entity)
                for (const id of createDto.assetId) {
                    const assetCheck = await this.repo.findOne({ where: { assetId: id } })
                    if (assetCheck) {
                        const assetServiceDate = await this.repo.update({ assetId: assetCheck.assetId }, { assetServiceDate: createDto.assetServiceDate, status: AssetStatusEnum.Service })
                        const assetTransDto = new AssetTransactionDto();
                        assetTransDto.assetId = assetCheck.assetId;
                        assetTransDto.assetServiceDate = createDto.assetServiceDate;
                        assetTransDto.serviceName = createDto.serviceName;
                        assetTransDto.status = AssetStatusEnum.Service;
                        const assetTransEntity = this.assetTransactionAdapter.convertAssetTransactionDtoToEntity(assetTransDto)
                        const assetTransSave = await transactionManager.getRepository(AssetTransaction).save(assetTransEntity)
                    }
                }

                // whatsapp message trigger 

            }
            console.log(plannedResult, 'planned result')
            console.log(unplannedResult)
            await transactionManager.completeTransaction()
            if (createDto.serviceType == 'planned') {

                const todaysServices = `select asr.service_name as serviceName,asr.asset_service_date as serviceDate,a.model,asr.asset_service_date as serviceDate,asr.phone_number as phoneNumber,asr.service_owner as serviceOwner,i.item_name as itemName,a.assets_code as assetCode,asr.service_owner as serviceOwner,asr.remarks,asr.asset_serve_id as serviceId from ${appSettings.assets_db}.asset_service asr
                left join ${appSettings.assets_db}.assets a on a.asset_id = asr.asset_id
                left join ${appSettings.masters_db}.items i  on i.item_id = a.assets_name
                where asr.asset_serve_id = ${plannedResult.data.assetServeId}`
                const data = await manager.query(todaysServices)
                const msgText = `*${data[0].serviceOwner}*, \\n \\n*${data[0].serviceName}* - A ${createDto.frequencyOfService} recurring service for the asset *${data[0].itemName} - ${data[0].assetCode}* is scheduled between *${moment(createDto.startDate).format('MMMM Do YYYY')}* and *${moment(createDto.endDate).format('MMMM Do YYYY')}* \\nService status : *OPEN* \\nService note : ${data[0].remarks}\\n`
                const waParameters = [{ type: 'text', text: msgText }]
                for (const contact of whatsApp.contacts) {
                    const msgParameters = new MessageParameters(contact, 'service_notify', waParameters, 'en_us', data[0].serviceId)
                    const sendMessage = await this.wpService.sendMessageWithButtonParamsThroughFbApi(msgParameters)
                }
            } else {
                const todaysServices = `select asr.service_name as serviceName,asr.asset_service_date as serviceDate,a.model,asr.asset_service_date as serviceDate,asr.phone_number as phoneNumber,asr.service_owner as serviceOwner,i.item_name as itemName,a.assets_code as assetCode,asr.service_owner as serviceOwner,asr.remarks,asr.asset_serve_id as serviceId from ${appSettings.assets_db}.asset_service asr
                left join ${appSettings.assets_db}.assets a on a.asset_id = asr.asset_id
                left join ${appSettings.masters_db}.items i  on i.item_id = a.assets_name
                where asr.asset_serve_id = ${unplannedResult[0].assetServeId}`
                const data = await manager.query(todaysServices)
                const msgText = `*${data[0].serviceOwner}*, \\n \\n*${data[0].serviceName}* - service for the asset *${data[0].itemName} - ${data[0].assetCode}* is scheduled on *${moment(data[0].serviceDate).format('MMMM Do YYYY')}* \\nService status : *OPEN* \\nService note : ${data[0].remarks}\\n`
                const waParameters = [{ type: 'text', text: msgText }]
                for (const contact of whatsApp.contacts) {
                    const msgParameters = new MessageParameters(contact, 'service_notify', waParameters, 'en_us', data[0].serviceId)
                    const sendMessage = await this.wpService.sendMessageWithButtonParamsThroughFbApi(msgParameters)
                }
            }
            return new CommonResponse(true, 11608, 'Successfully Created')
        } catch (err) {
            console.log(err)
            await transactionManager.releaseTransaction()
            throw err

        }
    }


    async getAllAssetsDataById(req?: AssetsId): Promise<CommonResponse> {
        const manager = getManager();
        const query = `SELECT isc.item_sub_category AS assetCategory, it.item_name AS assetName,aas.assets_code AS assetsCode,aas.amc_available ,aas.date_of_purchased AS dateOfPurchased,
        aas.name,aas.warrenty_expired_date,aas.insurance_date,aas.insurance,aas.warrenty_available,aas.expired_date,aas.asset_cost AS assetCost,aas.status, 
        aas.asset_serialno,aas.model,aas.year,aas.asset_supplier,aas.asset_condition,emp.employee_name AS owner_of_asset,aas.transaction_date,aas.decommission_approved_by,DATE_ADD( aas.date_of_purchased,INTERVAL aas.service_tenure DAY ) AS actAssetServiceDate,
        aas.service_tenure AS serviceTenure,aas.insurance_provided_by,aas.asset_invoice_no,aas.item_id,aas.grn_id,aas.no_of_units,aas.units_of_measurements,aas.last_checkin,aas.last_checkout,aas.amc_reason,
        aas.department,aas.employee_id,aas.maintenance_duedate,aas.asset_id AS assetId,unc.unit_name AS plant,
        TIMESTAMPDIFF(YEAR,aas.date_of_purchased,DATE(NOW())) AS yeardiff,
        locc.location_id,lo.location_id ,loc.location_name,aas.asset_category as assetCategoryId FROM ` + appSettings.assets_db + `.assets aas 
        LEFT JOIN `+ appSettings.masters_db + `.unitcodes unc ON unc.unit_code_id = aas.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_location_id = aas.asset_id 
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
        LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id 
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN `+ appSettings.masters_db + `.employee_details emp ON emp.employee_id = aas.owner_of_asset
        where aas.asset_id > 0 AND aas.asset_id = '${req?.assetId}'
        ORDER BY date_of_purchased DESC`;
        const data = await manager.query(query)
        if (data) {
            return new CommonResponse(true, 11608, 'Data Retrieved Successfully', data)
        } else {
            return new CommonResponse(true, 11608, 'Somethig Went Wrong')
        }
    }

    async getAsssetForCategory(req?: AssetsCatagoryByIdDto): Promise<CommonResponse> {
        const manager = getManager()
        let query;
        query = `select a.assets_name as assetName,a.assets_code as assetCode,a.asset_id as assetId,i.item_name as itemName,concat(i.item_name,'-',a.assets_code) as name from ${appSettings.assets_db}.assets a 
        left join ${appSettings.masters_db}.items i on i.item_id = a.assets_name
         where a.asset_id > 0  `
        if (req.unitId != 5) {
            query = query + ` and plant = ${req.unitId}`
        }
        if (req.assetsCatagoryId) {
            query = query + ` and a.asset_category = ${req.assetsCatagoryId}`
        }
        if (req.departmentId) {
            query = query + ` and a.department = ${req.departmentId}`
        }
        const data = await manager.query(query)
        if (data && data.length) return new CommonResponse(true, 11608, 'Data Retrieved Successfully', data)
        return new CommonResponse(false, 11608, 'Data not found')
    }

    async getAssetServiceReportdata(req?: AssetServiceRportReq): Promise<CommonResponse> {
        const manager = getManager();
        let query;
        query = 'SELECT asr.asset_service_date AS actualserviceDate,asr.service_name AS serviceName,asr.status AS serviceStatus,DATE_ADD( a.created_at,INTERVAL a.service_tenure DAY ) AS serviceDate,isc.item_sub_category AS categoryName,DATE(warrenty_expired_date) AS warantyExpiredDate,i.item_name AS assetName,ed.employee_name AS assetOwner,uc.unit_name AS plantName,asset_cost AS assetCost,isc.item_sub_category AS assetCategory,l.location_name AS locationName,assets_name AS assetId,assets_code AS assetCode,DATE(expired_date) AS expiredDate,DATE(asr.act_asset_service_date) AS actuallassetServiceDate,a.plant AS plantId,DATE(insurance_date) AS insuranceDate,asset_cost AS assetCose,DATE(date_of_purchased) AS purchasedDate ,a.asset_type AS assetType FROM  ' + appSettings.assets_db + '.asset_service asr  LEFT JOIN ' + appSettings.assets_db + '.assets a ON a.asset_id=asr.asset_id LEFT  JOIN ' + appSettings.assets_db + '.asset_location_mapping al ON a.asset_id=al.asset_id LEFT JOIN ' + appSettings.assets_db + '.location l ON l.location_id = al.location_id LEFT JOIN ' + appSettings.masters_db + '.unitcodes uc ON uc.unit_code_id=a.plant  LEFT JOIN ' + appSettings.masters_db + '.employee_details ed ON ed.employee_id=a.owner_of_asset LEFT JOIN ' + appSettings.masters_db + '.items i ON i.item_id=a.assets_name left join ' + appSettings.masters_db + '.item_sub_categories isc on isc.item_sub_category_id=a.asset_category WHERE a.asset_id >0 '

        if (req.assetCode) {
            query = query + ' and a.assets_code = "' + req.assetCode + '"'
        }
        if (req.plant && req.plant != 5) {
            query = query + ' and a.plant = ' + req.plant + ''
        }
        if (req.location) {
            query = query + ' and l.location_id =' + req.location + ''
        }
        if (req.assetCategory) {
            query = query + ' and a.asset_category=' + req.assetCategory + ''
        }
        if (req.assetCategory && req.assetCode && req.location && req.plant) {
            query = query + ' and a.assets_code = "' + req.assetCode + '" and a.plant = ' + req.plant + ' and l.location_id =' + req.location + ' and a.asset_category=' + req.assetCategory + ''
        }
        if (req.plant && req.assetCode) {
            query = query + ' and a.plant = ' + req.plant + ' and a.assets_code = "' + req.assetCode + '"'
        }
        if (req.plant && req.assetCode && req.location) {
            query = query + ' and a.plant = ' + req.plant + ' and a.assets_code = "' + req.assetCode + '" and l.location_id =' + req.location + ''
        }
        const result = await manager.query(query)
        if (result.length > 0) {
            return new CommonResponse(true, 11608, 'Data Retrived Sucessfullyy.....', result)
        } else {
            return new CommonResponse(false, 11608, 'No data Foun', result)
        }
    }
    async getcategorydropdown(): Promise<CommonResponse> {
        const manager = getManager();
        const Query = 'SELECT asset_category_id AS assetCategoryId,category_name AS categoryName FROM `asset_category`';
        const result = await manager.query(Query);
        if (result.length > 0) {
            return new CommonResponse(true, 11608, 'Data Retrived Sucessfullyy.....', result)
        }
        else {
            return new CommonResponse(false, 11608, 'No data Foun', result)
        }

    }
    async getLocationdropdown(): Promise<CommonResponse> {
        const manager = getManager();
        const Query = ' SELECT location_id locationId,location_name AS locationName FROM `location`';
        const result = await manager.query(Query);
        if (result.length > 0) {
            return new CommonResponse(true, 11608, 'Data Retrived Sucessfullyy.....', result)
        }
        else {
            return new CommonResponse(false, 11608, 'No data Foun', result)
        }

    }

    async assetHistoryInformation(req: AssetByCode): Promise<CommonResponse> {
        const assetLocationMappingObj: { asset_id: number, asset_location_id: number } = await this.locationMapRepo.createQueryBuilder('asset_loc')
            .select('assets.asset_id, asset_location_id')
            .leftJoin('asset_loc.assetsId', 'assets')
            .where(`assets.assets_code = '${req.assetsCode}'`)
            .getRawOne();
        const actAssetId = Number(assetLocationMappingObj.asset_id);
        const manager = getManager();
        const query = `SELECT * FROM (SELECT asset_id ,created_at ,STATUS FROM ` + appSettings.assets_db + `.assets 
        UNION ALL SELECT asset_id , created_at ,STATUS FROM ` + appSettings.assets_db + `.asset_location_transactions 
        UNION ALL SELECT asset_id , created_at,STATUS FROM ` + appSettings.assets_db + `.asset_assignment_transactions 
        UNION ALL SELECT asset_id , created_at,STATUS FROM ` + appSettings.assets_db + `.asset_maintainance_transactions UNION ALL
        SELECT asset_id , created_at,service_name AS STATUS FROM ` + appSettings.assets_db + `.asset_service) AS asset 
        WHERE asset_id = '${actAssetId}' ORDER BY created_at`
        const data: { asset_id: number, deptName: string, employeeName: string, costOfRepair: string, created_at: string, STATUS: string }[] = await manager.query(query)
        const dataToSent = []
        for (const assetData of data) {
            const assetRemDataQuery = `SELECT aas.asset_id ,d.dept_name,em.employee_name,am.cost_of_repair FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.assets_db + `.asset_maintainance_transactions am ON am.asset_maintainance_transactions_id = aas.asset_id LEFT JOIN ` + appSettings.masters_db + `.employee_details em ON em.employee_id = aas.employee_id LEFT JOIN ` + appSettings.masters_db + `.departments d ON d.dept_id = em.department_id  WHERE aas.asset_id = '${assetData.asset_id}' LIMIT 1`;
            const assetRemData: any[] = await manager.query(assetRemDataQuery)
            assetData.deptName = assetRemData['dept_name'];
            assetData.employeeName = assetRemData['employee_name'];
            assetData.costOfRepair = assetRemData['cost_of_repair'];
            dataToSent.push({
                assetId: assetData.asset_id,
                createdAt: assetData.created_at,
                status: assetData.STATUS,
                deptName: assetRemData[0].dept_name,
                employeeName: assetRemData[0].employee_name,
                costOfRepair: assetRemData[0].cost_of_repair
            })
        }
        if (dataToSent.length) {
            return new CommonResponse(true, 11608, 'Data Retrieved Successfully', dataToSent)
        } else {
            return new CommonResponse(true, 11608, 'Somethig Went Wrong')
        }
    }

    async getDecommissioneddAssetsReport(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT isc.item_sub_category AS asset_category, it.item_name AS assets_name,aas.assets_code AS assetsCode,aas.amc_available ,aas.date_of_purchased,
        aas.name,aas.warrenty_expired_date,aas.insurance_date,aas.insurance,aas.warrenty_available,aas.expired_date,aas.asset_cost,aas.status, 
        aas.asset_serialno,aas.model,aas.year,aas.asset_supplier,aas.asset_condition,emp.employee_name AS owner_of_asset,aas.transaction_date,
        aas.service_tenure,aas.insurance_provided_by,aas.asset_invoice_no,aas.assets_name as item_id,aas.grn_id,aas.no_of_units,aas.units_of_measurements,aas.last_checkin,aas.last_checkout,aas.amc_reason,
        aas.department,aas.employee_id,aas.maintenance_duedate,aas.asset_id,unc.unit_name AS plant,aas.asset_type,assi.employee_id,empd.employee_name,empd.department_id,dep.dept_name,aas.service_type,aas.service_status,aas.amc_provider,
        locc.location_id,lo.location_id ,loc.location_name,empdet.employee_name AS decommission_approved_by,aas.updated_at,datediff(date(now()),date_of_purchased) as aging,aas.asset_mode FROM ` + appSettings.assets_db + `.assets aas 
        LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
        LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id 
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN `+ appSettings.masters_db + `.employee_details emp ON emp.employee_id = aas.owner_of_asset
        LEFT JOIN `+ appSettings.assets_db + `.asset_assignment assi ON assi.asset_id = aas.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.employee_details empd ON empd.employee_id = assi.employee_id
        LEFT JOIN `+ appSettings.masters_db + `.departments dep ON dep.dept_id = empd.department_id
        LEFT JOIN `+ appSettings.masters_db + `.employee_details empdet ON empdet.employee_id = aas.decommission_approved_by
        WHERE aas.status = '${AssetStatusEnum.Retired}'`
        if (req.assetCode) {
            getEntities = getEntities + 'and aas.assets_code = "' + req.assetCode + '"'
        }
        // if(req.plant){
        //     getEntities = getEntities + 'and unc.unit_name = "' + req.plant +'"'
        // }
        if (req.location) {
            getEntities = getEntities + 'and loc.location_name = "' + req.location + '"'
        }
        if (req.assetCategory) {
            getEntities = getEntities + 'and isc.item_sub_category = "' + req.assetCategory + '"'
        }
        if (req.assetType) {
            getEntities = getEntities + ' and aas.asset_type = "' + req.assetType + '"'
        }
        if (req.fromDate) {
            getEntities = getEntities + 'and aas.updated_at BETWEEN "' + req.fromDate + '" AND "' + req.toDate + '"'
        }
        // if(req.plant && req.location){
        //     getEntities = getEntities + 'and unc.unit_name = "' + req.plant +'" and loc.location_name = "' + req.location +'"'
        // }
        if (req.plantId > 0 && req.plantId != 5) {
            getEntities = getEntities + 'and aas.plant = ' + req.plantId
        }
        if (req.employeeId) {
            getEntities = getEntities + 'and assi.employee_id = "' + req.employeeId + '"'
        }
        if (req.department) {
            getEntities = getEntities + 'and dep.dept_name = "' + req.department + '"'
        }
        if (req.fromDate) {
            getEntities = getEntities + ` ORDER BY aas.updated_at ASC `
        } else {
            getEntities = getEntities + ` ORDER BY it.item_name ASC `
        }

        const data = await manager.query(getEntities)
        if (data) {
            return new CommonResponse(true, 11608, 'Data Retrieved Successfully', data)
        } else {
            return new CommonResponse(true, 11608, 'Somethig Went Wrong')
        }
    }

    async getDecommissioneddAssetsReportDropdown(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT isc.item_sub_category AS asset_category, it.item_name AS assets_name,aas.assets_code AS assetsCode,aas.amc_available ,aas.date_of_purchased,
        aas.name,aas.warrenty_expired_date,aas.insurance_date,aas.insurance,aas.warrenty_available,aas.expired_date,aas.asset_cost,aas.status, 
        aas.asset_serialno,aas.model,aas.year,aas.asset_supplier,aas.asset_condition,emp.employee_name AS owner_of_asset,aas.transaction_date,
        aas.service_tenure,aas.insurance_provided_by,aas.asset_invoice_no,aas.item_id,aas.grn_id,aas.no_of_units,aas.units_of_measurements,aas.last_checkin,aas.last_checkout,aas.amc_reason,
        aas.department,aas.employee_id,aas.maintenance_duedate,aas.asset_id,unc.unit_name AS plant,aas.asset_type,assi.employee_id,empd.employee_name,empd.department_id,dep.dept_name,aas.service_type,aas.service_status,aas.amc_provider,
        locc.location_id,lo.location_id ,loc.location_name,empdet.employee_name AS decommission_approved_by,aas.updated_at FROM ` + appSettings.assets_db + `.assets aas 
        LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
        LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id 
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN `+ appSettings.masters_db + `.employee_details emp ON emp.employee_id = aas.owner_of_asset
        LEFT JOIN `+ appSettings.assets_db + `.asset_assignment assi ON assi.asset_id = aas.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.employee_details empd ON empd.employee_id = assi.employee_id
        LEFT JOIN `+ appSettings.masters_db + `.departments dep ON dep.dept_id = empd.department_id
        LEFT JOIN `+ appSettings.masters_db + `.employee_details empdet ON empdet.employee_id = aas.decommission_approved_by
        WHERE aas.status = '${AssetStatusEnum.Retired}' `
        if (req.plantId > 0 && req.plantId != 5) {
            getEntities = getEntities + 'and aas.plant = ' + req.plantId
        }
        getEntities = getEntities + ` ORDER BY it.item_name ASC `

        const data = await manager.query(getEntities)
        if (data) {
            return new CommonResponse(true, 11608, 'Data Retrieved Successfully', data)
        } else {
            return new CommonResponse(true, 11608, 'Somethig Went Wrong')
        }
    }

    async assetsTopServices(): Promise<CommonResponse> {
        const data = [];
        try {
            const manager = getManager();
            const qry = `SELECT aa.assets_code,aas.asset_service_date , it.item_name AS asset_name,a.plant,u.unit_name AS unit,DATEDIFF(aas.asset_service_date,DATE(NOW())) AS aging FROM ` + appSettings.assets_db + `.asset_service aas LEFT JOIN ` + appSettings.assets_db + `.assets aa ON aa.asset_id = aas.asset_id LEFT JOIN ` + appSettings.masters_db + `.items it ON it.item_id = aa.assets_name LEFT JOIN ` + appSettings.assets_db + `.assets a ON a.asset_id = aas.asset_id LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id = a.plant WHERE aas.asset_service_date IS NOT NULL AND aas.asset_service_date >DATE(NOW()) ORDER BY asset_service_date ASC LIMIT 5`
            const dropData = await manager.query(qry)
            data.push(dropData)

            if (dropData) {

                return new CommonResponse(true, 1, ' Data retrievd successfully', data)
            } else {
                return new CommonResponse(false, 99898, 'Something went wrong')
            }
        } catch (error) {
            return error
        }
    }

    async getAssetCodesDropDown(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let Query = 'SELECT i.item_name AS assetName,assets_name AS assetId,assets_code AS assetsCode,CONCAT(i.item_name,"-",assets_code) AS concateditemName FROM ' + appSettings.assets_db + `.assets a LEFT JOIN ` + appSettings.masters_db + `.items i ON a.assets_name=i.item_id WHERE STATUS IN ("Idle","Running") `;
        if (req.plant) {
            Query = Query + ' and a.plant = ' + req.plant
        }
        Query = Query + ` GROUP BY a.assets_code ORDER BY i.item_name ASC`
        const result = await manager.query(Query);
        if (result.length > 0) {
            return new CommonResponse(true, 11608, 'Data Retrived Sucessfullyy.....', result)
        }
        else {
            return new CommonResponse(false, 11608, 'No data Found', result)
        }

    }

    async getInstockAssetCodesDropDown(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let Query = 'SELECT i.item_name AS assetName,assets_name AS assetId,assets_code AS assetsCode,CONCAT(i.item_name,"-",assets_code) AS concateditemName FROM ' + appSettings.assets_db + `.assets a LEFT JOIN ` + appSettings.masters_db + `.items i ON a.assets_name=i.item_id WHERE STATUS IN ("Idle") `;
        if (req.plantId > 0 && req.plantId != 5) {
            Query = Query + 'and a.plant = ' + req.plantId
        }
        Query = Query + ` GROUP BY a.assets_code ORDER BY i.item_name ASC`
        const result = await manager.query(Query);
        if (result.length > 0) {
            return new CommonResponse(true, 11608, 'Data Retrived Sucessfullyy.....', result)
        }
        else {
            return new CommonResponse(false, 11608, 'No data Found', result)
        }
    }

    async getRentedAssetCodesDropDown(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let Query = 'SELECT i.item_name AS assetName,assets_name AS assetId,assets_code AS assetsCode,CONCAT(i.item_name,"-",assets_code) AS concateditemName FROM ' + appSettings.assets_db + `.assets a LEFT JOIN ` + appSettings.masters_db + `.items i ON a.assets_name=i.item_id WHERE asset_mode = 'rentedAsset' and status = '${AssetStatusEnum.Idle}' `;
        if (req.plantId > 0 && req.plantId != 5) {
            Query = Query + 'and a.plant = ' + req.plantId
        }
        Query = Query + ` GROUP BY a.assets_code ORDER BY i.item_name ASC`
        const result = await manager.query(Query);
        if (result.length > 0) {
            return new CommonResponse(true, 11608, 'Data Retrived Sucessfullyy.....', result)
        }
        else {
            return new CommonResponse(false, 11608, 'No data Found', result)
        }

    }

    // async updateAssetStatus(req: AssetByCode): Promise<CommonResponse> {
    //     try {
    //         let updateDate = {};

    //         // Update the appropriate dates based on the status
    //         if (req.status == ServiceStatusEnum.INPROGRESS) {
    //             updateDate = { startDate: new Date() };
    //         } else if (req.status == ServiceStatusEnum.COMPLETE) {
    //             updateDate = { completedDate: new Date() };
    //         } else if (req.status == ServiceStatusEnum.APPROVED) {
    //             updateDate = { assetServiceDate: new Date() };
    //         }

    //         const serviceText = req.status == ServiceStatusEnum.INPROGRESS 
    //             ? 'is started' 
    //             : req.status == ServiceStatusEnum.COMPLETE 
    //             ? 'is completed' 
    //             : 'is approved';

    //         // Update the asset service status and dates
    //         let updateStatus = await this.assetServiceRepo.update(
    //             { assetServeId: req.assetServiceId }, 
    //             { status: req.status, ...updateDate }
    //         );

    //         // If the status is COMPLETE, update the asset status to Idle and save the transaction
    //         if (req.status == ServiceStatusEnum.COMPLETE) {
    //             const assetUpdateStatus = await this.repo.update(
    //                 { assetId: Number(req.assetsCode) }, 
    //                 { status: AssetStatusEnum.Idle }
    //             );

    //             const assetTransDto = new AssetTransactionDto();
    //             assetTransDto.assetId = Number(req.assetsCode);
    //             assetTransDto.status = AssetStatusEnum.Idle;

    //             const assetTransEntity = this.assetTransactionAdapter.convertAssetTransactionDtoToEntity(assetTransDto);
    //             const assetTransSave = await this.assetTransactionRepo.save(assetTransEntity);
    //         }

    //         // Query to fetch the service details
    //         const manager = getManager();
    //         const todaysServices = `select asr.service_name as serviceName, asr.asset_service_date as serviceDate, a.model, asr.asset_service_date as serviceDate, asr.phone_number as phoneNumber, asr.service_owner as serviceOwner, i.item_name as itemName, a.assets_code as assetCode, asr.service_owner as serviceOwner, asr.remarks, asr.asset_serve_id as serviceId from ${appSettings.assets_db}.asset_service asr
    //             left join ${appSettings.assets_db}.assets a on a.asset_id = asr.asset_id
    //             left join ${appSettings.masters_db}.items i  on i.item_id = a.assets_name
    //             where asr.asset_serve_id = ${req.assetServiceId}`;

    //         const data = await manager.query(todaysServices);
    //         const msgText = `*${data[0].serviceOwner}*,\\n ${data[0].serviceName} - service ${serviceText} for the asset *${data[0].itemName} - ${data[0].assetCode}* \\n Service status : *${req.status}* \\n Service note : ${data[0].remarks}`;
    //         const waParameters = [{ type: 'text', text: msgText }];

    //         // Send notification to WhatsApp contacts
    //         for (const contact of whatsApp.contacts) {
    //             const msgParameters = new MessageParameters(contact, 'service_notify', waParameters, 'en_us', data[0].serviceId);
    //             const sendMessage = await this.wpService.sendMessageWithButtonParamsThroughFbApi(msgParameters);
    //         }

    //         // Check if the update was successful
    //         if (updateStatus.affected > 0) {
    //             return new CommonResponse(true, 1001, "Status updated Successfully.");
    //         } else {
    //             return new CommonResponse(false, 1010, "Something went wrong.");
    //         }
    //     } catch (error) {
    //         return error;
    //     }
    // }


    async updateAssetStatus(req: AssetByCode): Promise<CommonResponse> {
        try {
            let updateDate = {};

            if (req.status === ServiceStatusEnum.INPROGRESS) {
                updateDate = { startDate: new Date() };
            } else if (req.status === ServiceStatusEnum.COMPLETE) {
                updateDate = { completedDate: new Date() };
            } else if (req.status === ServiceStatusEnum.APPROVED) {
                updateDate = { assetServiceDate: new Date() };
                // Schedule next service or reschedule if already exists
                await this.scheduleNextService(req.assetsCode, req.assetsCode, ServiceStatusEnum.APPROVED);
            }

            const updateStatus = await this.assetServiceRepo.update(
                { assetServeId: req.assetServiceId },
                { status: req.status, ...updateDate }
            );

            // Check if the update was successful
            if (updateStatus.affected > 0) {
                if (req.status === ServiceStatusEnum.APPROVED) {
                    const assetService = await this.assetServiceRepo.findOne({ assetServeId: req.assetServiceId });
                if (!assetService) {
                    throw new Error(`Service with ID ${req.assetServiceId} not found`);
                }
                const assetTransaction = new AssetTransaction();
                assetTransaction.assetId = assetService.assetId;
                assetTransaction.assetsName = assetService.assetName; 
                assetTransaction.assetsCode = req.assetsCode; 
                assetTransaction.transactionDate = new Date();
                assetTransaction.serviceStatus = req.status;
                assetTransaction.createdAt = new Date();
                assetTransaction.createdUser = assetService.createdUser; 
                assetTransaction.updatedAt = new Date();
                assetTransaction.updatedUser = assetService.updatedUser; 
                assetTransaction.versionFlag = assetService.versionFlag;
                assetTransaction.assetServiceDate = assetService.assetServiceDate;
                assetTransaction.serviceType = assetService.serviceType; 
                assetTransaction.serviceName = assetService.serviceName;
                // assetTransaction.employeeId = assetService.serviceOwner;
                await this.assetTransactionRepo.save(assetTransaction);
                }
                return new CommonResponse(true, 1001, "Status updated Successfully.");
            } else {
                return new CommonResponse(false, 1010, "Something went wrong.");
            }
        } catch (error) {
            return new CommonResponse(false, 1010, error.message);
        }
    }

//     async scheduleNextService(assetId: any, assetsCode: string, status: ServiceStatusEnum) {
//         const manager = getManager();
//         const ninetyDaysLater = new Date();
//         ninetyDaysLater.setDate(ninetyDaysLater.getDate() + 90);

//         const query = `
//             SELECT emp.employee_name, emp.mobile_no, aa.assets_name 
//             FROM shahi_asset_master.employee_details emp
//             LEFT JOIN shahi_assets.location loc ON loc.location_head = emp.employee_id
//             LEFT JOIN shahi_assets.asset_location_mapping alc ON alc.location_id = loc.location_id
//             LEFT JOIN shahi_assets.assets aa ON aa.asset_id = alc.asset_id
//             WHERE alc.asset_id = ?`;

//         const result = await manager.query(query, [assetId]);

//         if (!result || result.length === 0) {
//             throw new Error("No employee found for the asset location.");
//         }

//         if (status === ServiceStatusEnum.APPROVED) {
//             const existingService = await this.assetServiceRepo.findOne({
//                 where: { assetId: assetId, status: ServiceStatusEnum.OPEN }
//             });

//             if (existingService) {
//                 await this.assetServiceRepo.delete({ assetServeId: existingService.assetServeId });
//             }

//             const assetServiceSchedule = await this.assetServiceRepo.save({
//                 assetId: assetId,
//                 assetName : result[0]?.assets_name,
//                 assetServiceDate: ninetyDaysLater,
//                 actAssetServiceDate: ninetyDaysLater,
//                 serviceProvider: 'In-House',
//                 serviceName: 'General',
//                 serviceOwner: result[0]?.employee_name,
//                 serviceType: 'Planned',
//                 status: ServiceStatusEnum.OPEN
//             });

//             const query1 = `WITH RECURSIVE checklist_split AS (
//     SELECT 
//         SUBSTRING_INDEX(ch.checklist_name, ',', 1) AS checklist_item,
//         SUBSTRING(ch.checklist_name, LENGTH(SUBSTRING_INDEX(ch.checklist_name, ',', 1)) + 2) AS remaining_items
//     FROM 
//         shahi_asset_master.asset_checklist ch
//     WHERE 
//         ch.is_active = '1' AND ch.asset_category_Id = '${result[0]?.assets_name}'
//     UNION ALL
//     SELECT 
//         SUBSTRING_INDEX(remaining_items, ',', 1),
//         SUBSTRING(remaining_items, LENGTH(SUBSTRING_INDEX(remaining_items, ',', 1)) + 2)
//     FROM 
//         checklist_split
//     WHERE 
//         remaining_items <> ''
// )
// SELECT checklist_item FROM checklist_split`;
//             const result1 = await manager.query(query1);

//             for (const checklistItem of result1) {
//                     const assetServiceChecklist = this.checklistRepo.create({
//                         assetService: assetServiceSchedule.assetServeId,
//                         checklist: checklistItem.checklist_item, // Save each checklist name individually
//                         checklistStatus: 'OPEN',
//                     });
    
//                     await this.checklistRepo.save(assetServiceChecklist);
                
//             }
//         }
//     }

async scheduleNextService(assetId: any, assetsCode: string, status: ServiceStatusEnum) {
    const manager = getManager();
    const ninetyDaysLater = new Date();
    ninetyDaysLater.setDate(ninetyDaysLater.getDate() + 90);

    try {
        // Fetch employee and asset details
        const query = `
            SELECT emp.employee_name, emp.mobile_no, aa.assets_name 
            FROM shahi_asset_master.employee_details emp
            LEFT JOIN shahi_assets.location loc ON loc.location_head = emp.employee_id
            LEFT JOIN shahi_assets.asset_location_mapping alc ON alc.location_id = loc.location_id
            LEFT JOIN shahi_assets.assets aa ON aa.asset_id = alc.asset_id
            WHERE alc.asset_id = ?`;

        const result = await manager.query(query, [assetId]);

        if (!result || result.length === 0) {
            throw new Error("No employee found for the asset location.");
        }

        if (status === ServiceStatusEnum.APPROVED) {
            // Check for existing open service
            const existingService = await this.assetServiceRepo.findOne({
                where: { assetId: assetId, status: ServiceStatusEnum.OPEN }
            });

            // Delete existing open service if found
            if (existingService) {
                await this.assetServiceRepo.delete({ assetServeId: existingService.assetServeId });
            }

            // Create a new service schedule
            const assetServiceSchedule = await this.assetServiceRepo.save({
                assetId: assetId,
                assetName: result[0]?.assets_name,
                assetServiceDate: ninetyDaysLater,
                actAssetServiceDate: ninetyDaysLater,
                serviceProvider: 'In-House',
                serviceName: 'General',
                serviceOwner: result[0]?.employee_name,
                serviceType: 'Planned',
                status: ServiceStatusEnum.OPEN
            });

            // Recursive CTE to split checklist items
            const query1 = `
                WITH RECURSIVE checklist_split AS (
                    SELECT 
                        SUBSTRING_INDEX(ch.checklist_name, ',', 1) AS checklist_item,
                        SUBSTRING(ch.checklist_name, LENGTH(SUBSTRING_INDEX(ch.checklist_name, ',', 1)) + 2) AS remaining_items
                    FROM 
                        shahi_asset_master.asset_checklist ch
                    WHERE 
                        ch.is_active = '1' AND ch.asset_category_Id = ?
                    UNION ALL
                    SELECT 
                        SUBSTRING_INDEX(remaining_items, ',', 1),
                        SUBSTRING(remaining_items, LENGTH(SUBSTRING_INDEX(remaining_items, ',', 1)) + 2)
                    FROM 
                        checklist_split
                    WHERE 
                        remaining_items <> ''
                )
                SELECT checklist_item FROM checklist_split`;

            const result1 = await manager.query(query1, [result[0]?.assets_name]);

            // Save each checklist item individually
            for (const checklistItem of result1) {
                const assetServiceChecklist = this.checklistRepo.create({
                    assetService: assetServiceSchedule.assetServeId,
                    checklist: checklistItem.checklist_item, // Save each checklist name individually
                    checklistStatus: 'Open',
                });

                await this.checklistRepo.save(assetServiceChecklist);
            }
        }
    } catch (error) {
        console.error("Error in scheduleNextService:", error);
        throw new Error("Service scheduling failed: " + error.message);
    }
}


    async underMaintainanceOnInternal(req: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let Query = 'SELECT COUNT(a.asset_id) AS COUNT,a.assets_code AS assetsCode,it.item_name AS assetName,u.unit_name AS unit FROM ' + appSettings.assets_db + '.`asset_maintainance` am LEFT JOIN ' + appSettings.assets_db + '.`assets` a ON a.asset_id = am.asset_id LEFT JOIN ' + appSettings.masters_db + '.items it ON it.item_id = a.assets_name LEFT JOIN ' + appSettings.assets_db + '.`asset_service` ass ON ass.asset_id = am.asset_id LEFT JOIN ' + appSettings.masters_db + '.`unitcodes` u ON u.unit_code_id = a.plant WHERE am.status = "UNDERMAINTENANCE" GROUP BY a.asset_id ORDER BY COUNT(a.asset_id) DESC LIMIT 5'
        // if (req.plantId > 0 && req.plantId != 5) {
        //     Query = Query + 'and a.plant = ' + req.plantId + ' LIMIT 5'
        // }
        // Query = Query + ` LIMIT 5`
        const result = await manager.query(Query);
        if (result.length > 0) {
            return new CommonResponse(true, 11608, 'Data Retrived Sucessfullyy.....', result)
        }
        else {
            return new CommonResponse(false, 11608, 'No data Found', result)
        }
    }

    async underMaintainanceOnVendor(req: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let Query = 'SELECT a.assets_code AS assetsCode,ass.asset_name AS assetName,a.asset_supplier AS assetSupplier,u.unit_name AS unit FROM ' + appSettings.assets_db + '.assets a LEFT JOIN `shahi_assets`.`asset_service` ass ON ass.asset_id = a.asset_id LEFT JOIN ' + appSettings.masters_db + '.unitcodes u ON u.unit_code_id = a.plant WHERE ass.asset_name IS NOT NULL'
        if (req.plantId > 0 && req.plantId != 5) {
            Query = Query + 'and a.plant = ' + req.plantId + ' LIMIT 5'
        }
        Query = Query + ` LIMIT 5`
        const result = await manager.query(Query);
        if (result.length > 0) {
            return new CommonResponse(true, 11608, 'Data Retrived Sucessfullyy.....', result)
        }
        else {
            return new CommonResponse(false, 11608, 'No data Found', result)
        }
    }

    async getPlantWiseAssets(): Promise<CommonResponse> {
        const manager = getManager();
        const qry = `SELECT aas.plant ,unc.unit_name AS plantname,SUM( IF(aas.STATUS='Idle', 1 , 0)) AS Instock,
        SUM( IF(aas.STATUS='Running', 1 , 0)) AS checkin,
        SUM( IF(aas.STATUS='UNDERMAINTENANCE', 1 , 0)) AS undermaintainance ,
        SUM( IF(aas.STATUS='DAMAGED', 1 , 0)) AS damaged,
        SUM( IF(aas.STATUS='${AssetStatusEnum.Retired}', 1 , 0)) AS decommissioned
        FROM `+ appSettings.assets_db + `.assets aas
        LEFT JOIN `+ appSettings.masters_db + `.unitcodes unc ON unc.unit_code_id = aas.plant
        GROUP BY plant`
        const data = await manager.query(qry);
        return new CommonResponse(true, 1, 'Data retrieevd Successfully', data)
    }

    async getpurchasedbutnotAssigned(): Promise<CommonResponse> {
        const manager = getManager();
        const query = 'SELECT last_checkin,plant,unit_name AS plantName,COUNT(asset_id) AS totalassets FROM ' + appSettings.assets_db + '.`assets` a LEFT JOIN ' + appSettings.masters_db + '.unitcodes u ON u.unit_code_id=a.plant WHERE STATUS="Idle" GROUP BY plant'
        const data = await manager.query(query)
        if (data) {
            return new CommonResponse(true, 1000, 'Data retrived sucessfully', data)
        } else {
            return new CommonResponse(false, 1000, 'no data found')

        }
    }

    async getPurchasedDetailsUnused(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT location_name AS locationName,isc.item_sub_category AS asetCategoryName,u.unit_name AS plant,i.item_name AS assetName,assets_name AS assetId,assets_code AS assetCode,DATE(date_of_purchased) AS purchaseddate,STATUS AS STATUS, aas.plant AS plantId ,aas.asset_type, asset_condition AS assetCondition,DATEDIFF(DATE(NOW()),date_of_purchased) AS aging 
        FROM ` + appSettings.assets_db + `.assets aas 
        LEFT JOIN ` + appSettings.masters_db + `.items i ON aas.assets_name = i.item_id 
        LEFT JOIN ` + appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category 
        LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id=aas.plant 
        LEFT JOIN ` + appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN ` + appSettings.assets_db + `.asset_location_mapping al ON al.asset_id=aas.asset_id 
        LEFT JOIN ` + appSettings.assets_db + `.location l ON l.location_id=al.location_id WHERE STATUS="Idle" `
        if (req.plantId && req.plantId != 5) {
            getEntities = getEntities + 'and aas.plant = ' + req.plantId
        }
        if (req.assetCode) {
            getEntities = getEntities + 'and assets_code = "' + req.assetCode + '"'
        }
        if (req.plant) {
            getEntities = getEntities + 'and aas.plant = "' + req.plant + '"'
        }
        if (req.location) {
            getEntities = getEntities + 'and location_name = "' + req.location + '"'
        }
        if (req.assetCategory) {
            getEntities = getEntities + 'and isc.item_sub_category = "' + req.assetCategory + '"'
        }

        if (req.assetType) {
            getEntities = getEntities + ' and aas.asset_type = "' + req.assetType + '"'
        }
        if (req.aging != undefined) {
            if (req.aging == '50') {
                getEntities = getEntities + ' having aging < 50 '
            }
            if (req.aging == '51-300') {
                getEntities = getEntities + ' having aging between 51 and 300'
            }
            if (req.aging == '301-900') {
                getEntities = getEntities + ' having aging between 301 and 900'
            }
            if (req.aging == '901-1500') {
                getEntities = getEntities + ' having aging between 901 and 1500'
            }
            if (req.aging == '1501-2125') {
                getEntities = getEntities + ' having aging between 1096 and 2125'
            }
            if (req.aging == '2125-3000') {
                getEntities = getEntities + '  having aging between 2125 and 3000'
            }
            if (req.aging == '3000-3600') {
                getEntities = getEntities + '  having aging between 3000 and 3600'
            }
            if (req.aging == '3600-4200') {
                getEntities = getEntities + '  having aging between 3600 and 4200'
            }
            if (req.aging == 'above 4200') {
                getEntities = getEntities + ' having aging > 4200'
            }
        }
        if (req.aging != undefined) {
            getEntities = getEntities + ` ORDER BY aging ASC`
        } else {
            getEntities = getEntities + ` ORDER BY i.item_name ASC`
        }
        const result = await manager.query(getEntities)
        if (result) {
            return new CommonResponse(true, 1, 'Data retrieved', result)

        } else {
            return new CommonResponse(false, 1, 'Data not found')

        }
    }

    async getAssignedforRent(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT a.asset_mode AS assetMode, a.status AS STATUS,a.assets_code AS assetCode,a.assets_name AS assetId,a.plant AS plantId ,uc.unit_name AS plant ,l.location_id AS locationId ,i.item_name AS assetName ,l.location_name AS locationName,DATE (a.date_of_purchased) AS date_of_purchased,i.asset_type AS assetType,a.rental_cost AS rentalCost,ic.item_sub_category AS assetCategory ,a.asset_condition AS asset_condition,a.month AS MONTH , a.day AS DAY , 
        a.asset_rent_period AS asset_rent_period , a.asset_rent_tenure_type AS asset_rent_tenure_type , a.rental_cost_type AS rental_cost_type ,
   a.rental_cost AS rental_cost,
IF (a.asset_rent_tenure_type ='Days' AND a.rental_cost_type != 'totalRent' , 1*a.rental_cost*a.asset_rent_period,
IF (a.asset_rent_tenure_type ='Month' AND a.rental_cost_type != 'totalRent', 30*a.rental_cost*a.asset_rent_period,
IF (a.asset_rent_tenure_type ='Year' AND a.rental_cost_type = 'perMonth',  12*a.rental_cost*a.asset_rent_period ,
IF (a.asset_rent_tenure_type ='Year' AND a.rental_cost_type = 'perDay',  365*a.rental_cost*a.asset_rent_period ,a.rental_cost)))) AS result,
  CASE
  WHEN a.asset_rent_tenure_type ='Days' THEN DATEDIFF(DATE_ADD(a.date_of_purchased, INTERVAL a.asset_rent_period DAY), NOW())
  WHEN a.asset_rent_tenure_type ='Month' THEN DATEDIFF(DATE_ADD(a.date_of_purchased, INTERVAL a.asset_rent_period MONTH), NOW())
  WHEN a.asset_rent_tenure_type ='Year' THEN DATEDIFF(DATE_ADD(a.date_of_purchased, INTERVAL a.asset_rent_period YEAR), NOW())
  ELSE NULL
  
  END AS days_between, 
 CASE
        WHEN a.asset_rent_tenure_type = 'Days' THEN DATE(DATE_ADD(a.date_of_purchased, INTERVAL a.asset_rent_period DAY))
        WHEN a.asset_rent_tenure_type = 'Month' THEN DATE(DATE_ADD(a.date_of_purchased, INTERVAL a.asset_rent_period MONTH))
        WHEN a.asset_rent_tenure_type = 'Year' THEN DATE(DATE_ADD(a.date_of_purchased, INTERVAL a.asset_rent_period YEAR))
    END AS end_date
         FROM   ` + appSettings.assets_db + ` .assets a 
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories ic ON ic.item_sub_category_id = a.asset_category
        LEFT JOIN ` + appSettings.assets_db + `.asset_location_mapping lm ON lm.asset_id = a.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.items i ON i.item_id = a.assets_name 
        LEFT JOIN `+ appSettings.assets_db + `.location l ON l.location_id = lm.location_id 
        LEFT JOIN `+ appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = a.plant
        LEFT JOIN `+ appSettings.masters_db + `.employee_details empd ON empd.employee_id = a.employee_id
        LEFT JOIN `+ appSettings.masters_db + `.departments dep ON dep.dept_id = empd.department_id
        WHERE asset_mode = 'rentedAsset'AND STATUS='Idle'`
        if (req.plantId > 0 && req.plantId != 5) {
            getEntities = getEntities + ' and a.plant = ' + req.plantId
        }
        if (req.assetCode) {
            getEntities = getEntities + 'and a.assets_code = "' + req.assetCode + '"'
        }
        if (req.plant) {
            getEntities = getEntities + 'and uc.unit_name = "' + req.plant + '"'
        }
        if (req.assetCategory) {
            getEntities = getEntities + 'and ic.item_sub_category = "' + req.assetCategory + '"'
        }
        if (req.result != undefined) {
            if (req.result == '300') {
                getEntities = getEntities + ' having result < 300 '
            }
            if (req.result == '301-5000') {
                getEntities = getEntities + ' having result between 300 and 5000'
            }
            if (req.result == '5001-50000') {
                getEntities = getEntities + ' having result between 5000 and 50000'
            }
            if (req.result == '50001-100000') {
                getEntities = getEntities + ' having result between 50001 and 100000'
            }
            if (req.result == '100001-200000') {
                getEntities = getEntities + ' having result between 100001 and 200000'
            }
            if (req.result == '200001-500000') {
                getEntities = getEntities + '  having result between 200001 and 500000'
            }
            if (req.result == '500001-100000') {
                getEntities = getEntities + '  having aging between 500001 and 100000'
            }
            if (req.result == 'above 1000000') {
                getEntities = getEntities + ' having result > 1000000'
            }
        }

        // getEntities = getEntities + ` GROUP BY a.assets_code `
        if (req.days_between != undefined) {
            if (req.days_between == '50') {
                getEntities = getEntities + ' having days_between < 50 '
            }
            if (req.days_between == '0-90') {
                getEntities = getEntities + ' having days_between between 0 and 90'
            }
            if (req.days_between == '0-180') {
                getEntities = getEntities + ' having days_between between 0 and 180'
            }
            if (req.days_between == '0-365') {
                getEntities = getEntities + ' having days_between between 0 and 365'
            }
            if (req.days_between == '0-1095') {
                getEntities = getEntities + ' having days_between between 0 and 1095'
            }
            if (req.days_between == '0-1825') {
                getEntities = getEntities + '  having days_between between 0 and 1825'
            }
            if (req.days_between == 'above 1825') {
                getEntities = getEntities + '  having days_between > 1825'
            }
            // if (req.days_between == '3600-4200') {
            //     getEntities = getEntities + '  having days_between between 3600 and 4200'
            // }
            // if (req.days_between == 'above 4200') {
            //     getEntities = getEntities + ' having days_between > 4200'
            // }
        }
        if (req.result != undefined) {
            getEntities = getEntities + ` ORDER BY result ASC`
        }
        else if (req.days_between != undefined) {
            getEntities = getEntities + ` ORDER BY days_between ASC`
        } else {
            getEntities = getEntities + ` ORDER BY i.item_name ASC`
        }

        const response = await manager.query(getEntities);
        return new CommonResponse(true, 1, 'Data retrieved', response)
    }


    async createPlannedServiceEntries(req: Assets | AssetServiceDto | any, transactionManager: GenericTransactionManager): Promise<CommonResponse> {
        try {
            let dates: string[]
            var startDate = moment(req.startDate)
            var endDate = moment(req.endDate)
            const months = endDate.diff(startDate, 'months')
            switch (req.frequencyOfService) {
                case ServiceFrequency.Weekly:
                    dates = await this.assetServiceHelper.getDaysForWeeklyFrequency(req.day, 7, req.startDate, req.endDate)
                    break;
                case ServiceFrequency.FortWeekly:
                    dates = await this.assetServiceHelper.getDaysForWeeklyFrequency(req.day, 14, req.startDate, req.endDate)
                    break;
                case ServiceFrequency.Weekend:
                    dates = await this.assetServiceHelper.getThirdAndFourthSundaysBetweenDates(req.startDate, req.endDate)
                    break;
                case ServiceFrequency.Monthly:
                    const today = moment().date(Number(req.day)).format("YYYY-MM-DD")
                    dates = await this.assetServiceHelper.getMonthlyDates(new Date(today), months)
                    break;
                case ServiceFrequency.QuarterYearly:
                    dates = await this.assetServiceHelper.getQuarterlyDates(req.month, 4)
                    break;
                case ServiceFrequency.HalfYearly:
                    dates = await this.assetServiceHelper.getHalfyearlyDates(req.month, 2)
                    break;
                case ServiceFrequency.Yearly:
                    dates = await this.assetServiceHelper.getYearlyDates(req.month, 1)
                    break;
                case ServiceFrequency.Daily:
                    dates = await this.assetServiceHelper.getDailyFrequency(req.startDate, req.endDate)

            }

            const flag = new Set()
            let createService
            let plannedResult
            const assetsArr: AssetService[] = []
            for (const date of dates) {
                for (const assetVal of req.assetId) {

                    const jsDate = moment(date, "DD-MM-YYYY").format("YYYY-MM-DD")
                    const assetServiceDto = new AssetServiceDto()
                    assetServiceDto.actAssetServiceDate = new Date()
                    assetServiceDto.assetCategory = req.assetCategory;
                    assetServiceDto.assetId = assetVal;
                    assetServiceDto.assetName = req.assetName;
                    assetServiceDto.frequencyOfService = req.frequencyOfService;
                    assetServiceDto.dateOfPurchased = req.dateOfPurchased;
                    assetServiceDto.createdUser = req.createdUser;
                    assetServiceDto.status = ServiceStatusEnum.OPEN;
                    assetServiceDto.assetServiceDate = new Date(date)
                    assetServiceDto.actAssetServiceDate = new Date(date)
                    assetServiceDto.serviceName = req.serviceName
                    assetServiceDto.serviceType = req.serviceType
                    assetServiceDto.month = req.month
                    assetServiceDto.day = req.day
                    assetServiceDto.phoneNumber = req.phoneNumber
                    assetServiceDto.remarks = req.remarks;
                    assetServiceDto.serviceOwner = req.serviceOwner;
                    assetServiceDto.serviceProvider = req.serviceProvider;
                    const checkListEntity: AssetServiceChecklistDto[] = []
                    for (const element of req.assetServiceChecklist) {
                        const assetServiceChecklistEnt = new AssetServiceChecklist()
                        assetServiceChecklistEnt.checklist = element.checklist
                        assetServiceChecklistEnt.checklistStatus = element.checklistStatus
                        assetServiceChecklistEnt.createdUser = element.createdUser;
                        checkListEntity.push(assetServiceChecklistEnt)
                    }
                    assetServiceDto.assetServiceChecklist = checkListEntity;
                    console.log(assetServiceDto, 'assetServiceDto')
                    createService = await transactionManager.getCustomRepository(AssetServiceRepository).save(assetServiceDto)
                    console.log(createService, 'createService');
                    if (!createService) {
                        flag.add(false)
                        throw new ErrorResponse(1111, 'Error while creating')
                    }
                }
            }
            return new CommonResponse(true, 1111, 'Service created sucessfully', createService)
        } catch {
            await transactionManager.releaseTransaction()
        }
    }


    async getAgeWiseAssets(): Promise<CommonResponse> {
        const manager = getManager();
        const query = `SELECT plant,unit_name AS plantName,COUNT(asset_id) AS purchasedButNotAssigned,SUM(IF(date_of_purchased >= DATE_FORMAT(DATE_SUB(CURDATE(), INTERVAL 3 MONTH), '%Y-%m-01'), 1, 0)) AS last3months ,SUM(IF(date_of_purchased < DATE_FORMAT(DATE_SUB(CURDATE(), INTERVAL 3 MONTH), '%Y-%m-01') AND date_of_purchased > DATE_FORMAT(DATE_SUB(CURDATE(), INTERVAL 6 MONTH), '%Y-%m-01'), 1, 0)) AS threeTo6months,SUM(IF(date_of_purchased < DATE_FORMAT(DATE_SUB(CURDATE(), INTERVAL 6 MONTH), '%Y-%m-01') AND date_of_purchased > DATE_FORMAT(DATE_SUB(CURDATE(), INTERVAL 12 MONTH), '%Y-%m-01'), 1, 0)) AS sixTo12months ,SUM(IF(date_of_purchased < DATE_FORMAT(DATE_SUB(CURDATE(), INTERVAL 12 MONTH), '%Y-%m-01'), 1, 0)) AS yearbefore FROM ` + appSettings.assets_db + `.assets a LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id=a.plant WHERE STATUS = "Idle" GROUP BY plant`
        const data = await manager.query(query)

        if (data) {
            return new CommonResponse(true, 1000, 'Data retrived sucessfully', data)
        } else {
            return new CommonResponse(false, 1000, 'no data found')

        }
    }

    async getSkippedAssetsCount(): Promise<CommonResponse> {
        const manager = getManager();
        const query = `SELECT SUM(IF(aas.status ='OPEN',1,0)) AS assets ,a.plant,u.unit_name AS plantName FROM ` + appSettings.assets_db + `.asset_service aas LEFT JOIN ` + appSettings.assets_db + `.assets a ON aas.asset_id = a.asset_id LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id = a.plant WHERE DATE(aas.asset_service_date) <= DATE(NOW()) GROUP BY a.plant`
        const data = await manager.query(query)
        if (data) {
            return new CommonResponse(true, 1000, 'Data retrived sucessfully', data)
        } else {
            return new CommonResponse(false, 1000, 'no data found')

        }
    }

    async updateServiceRemarks(req: UpdateRemarksDto): Promise<CommonResponse> {
        const updateRemarks = await this.assetServiceRepo.update({ assetServeId: req.assetServiceId }, { remarks: req.remarks })
        const manager = getManager()
        const todaysServices = `select asr.service_name as serviceName,asr.asset_service_date as serviceDate,a.model,asr.asset_service_date as serviceDate,asr.phone_number as phoneNumber,asr.service_owner as serviceOwner,i.item_name as itemName,a.assets_code as assetCode,asr.service_owner as serviceOwner,asr.remarks,asr.asset_serve_id as serviceId,asr.status from ${appSettings.assets_db}.asset_service asr
        left join ${appSettings.assets_db}.assets a on a.asset_id = asr.asset_id
        left join ${appSettings.masters_db}.items i  on i.item_id = a.assets_name
        where asr.asset_serve_id = ${req.assetServiceId}`
        const data = await manager.query(todaysServices)
        const msgText = `*${data[0].serviceOwner}*,\\n Service note is updated against the service -  ${data[0].serviceName}   for the asset *${data[0].itemName} - ${data[0].assetCode}* \\n Service status : *${data[0].status}* \\n Service note : ${data[0].remarks}`
        const waParameters = [{ type: 'text', text: msgText }]
        const msgParameters = new MessageParameters(('91' + data[0].phoneNumber), 'service_notify', waParameters, 'en_us', data[0].serviceId)
        const sendMessage = await this.wpService.sendMessageWithButtonParamsThroughFbApi(msgParameters)
        if (updateRemarks.affected) {
            return new CommonResponse(true, 1111, 'Remarks updated')
        } else {
            return new CommonResponse(false, 2321, "Failed to update")
        }
    }
    async getInsuranceAssets(req: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `
        SELECT aas.asset_category,isc.item_sub_category,aas.assets_name, it.item_name AS item_name,aas.assets_code,aas.amc_available ,aas.date_of_purchased,
        aas.name,aas.warrenty_expired_date,aas.insurance_date,aas.insurance,aas.warrenty_available,aas.expired_date,aas.asset_cost,aas.status, 
        aas.asset_serialno,aas.model,aas.year,aas.asset_supplier,aas.asset_condition,aas.owner_of_asset,aas.transaction_date,aas.decommission_approved_by,
        aas.service_tenure,aas.insurance_provided_by,aas.asset_invoice_no,aas.item_id,aas.grn_id,aas.no_of_units,aas.units_of_measurements,aas.last_checkin,aas.last_checkout,aas.amc_reason,
        aas.department,aas.employee_id,aas.maintenance_duedate,aas.asset_id,aas.plant,unc.unit_name AS plantName,assi.employee_id,empd.employee_name,empd.department_id,dep.dept_name,aas.service_status,aas.service_type,aas.frequency_of_service,
        locc.location_id,lo.location_id ,loc.location_name ,aas.insurance_reference_number,aas.asset_type ,aas.month,aas.day,datediff(aas.insurance_date,date(now())) as assetAge
        FROM ` + appSettings.assets_db + `.assets aas 
        LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
        LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id 
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN `+ appSettings.assets_db + `.asset_assignment assi ON assi.asset_id = aas.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.employee_details empd ON empd.employee_id = assi.employee_id
        LEFT JOIN `+ appSettings.masters_db + `.departments dep ON dep.dept_id = empd.department_id
        WHERE aas.asset_id >0 and insurance = 'yes' `;
        if (req.assetCode) {
            getEntities = getEntities + 'and aas.assets_code = "' + req.assetCode + '"'
        }
        if (req.location) {
            getEntities = getEntities + 'and loc.location_name = "' + req.location + '"'
        }
        if (req.assetCategory) {
            getEntities = getEntities + 'and isc.item_sub_category = "' + req.assetCategory + '"'
        }
        if (req.assetType) {
            getEntities = getEntities + ' and aas.asset_type = "' + req.assetType + '"'
        }
        if (req.plant && req.location) {
            getEntities = getEntities + 'and unc.unit_name = "' + req.plant + '" and loc.location_name = "' + req.location + '"'
        }
        if (req.plantId > 0 && req.plantId != 5) {
            getEntities = getEntities + 'and aas.plant = ' + req.plantId
        }
        getEntities = getEntities + ` ORDER BY it.item_name ASC`

        const assetdata = await manager.query(getEntities)

        return new CommonResponse(true, 1, 'Data retrieved successfully', assetdata)



    }
    async getInsuranceDropDownAssets(req: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `
        SELECT aas.asset_category,isc.item_sub_category,aas.assets_name, it.item_name AS item_name,aas.assets_code
        FROM ` + appSettings.assets_db + `.assets aas 
        LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
        LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id 
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN `+ appSettings.assets_db + `.asset_assignment assi ON assi.asset_id = aas.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.employee_details empd ON empd.employee_id = assi.employee_id
        LEFT JOIN `+ appSettings.masters_db + `.departments dep ON dep.dept_id = empd.department_id
        WHERE aas.asset_id >0 and insurance = 'yes' ORDER BY it.item_name ASC `;
        const assetdata = await manager.query(getEntities)
        return new CommonResponse(true, 1, 'Data retrieved successfully', assetdata)
    }

    async getWarrantyAssets(req: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `
    SELECT aas.asset_category,isc.item_sub_category,aas.assets_name, it.item_name AS item_name,aas.assets_code,aas.amc_available ,aas.date_of_purchased,
    aas.name,aas.warrenty_expired_date,aas.insurance_date,aas.insurance,aas.warrenty_available,aas.expired_date,aas.asset_cost,aas.status, 
    aas.asset_serialno,aas.model,aas.year,aas.asset_supplier,aas.asset_condition,aas.owner_of_asset,aas.transaction_date,aas.decommission_approved_by,
    aas.service_tenure,aas.insurance_provided_by,aas.asset_invoice_no,aas.item_id,aas.grn_id,aas.no_of_units,aas.units_of_measurements,aas.last_checkin,aas.last_checkout,aas.amc_reason,
    aas.department,aas.employee_id,aas.maintenance_duedate,aas.asset_id,aas.plant,unc.unit_name AS plantName,assi.employee_id,empd.employee_name,empd.department_id,dep.dept_name,aas.service_status,aas.service_type,aas.frequency_of_service,
    locc.location_id,lo.location_id ,loc.location_name ,aas.insurance_reference_number,aas.asset_type ,aas.month,aas.day,datediff(aas.warrenty_expired_date,date(now())) as assetAge
    FROM ` + appSettings.assets_db + `.assets aas 
    LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
    LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
    LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
    LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id 
    LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
    LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
    LEFT JOIN `+ appSettings.assets_db + `.asset_assignment assi ON assi.asset_id = aas.asset_id
    LEFT JOIN `+ appSettings.masters_db + `.employee_details empd ON empd.employee_id = assi.employee_id
    LEFT JOIN `+ appSettings.masters_db + `.departments dep ON dep.dept_id = empd.department_id
    WHERE aas.asset_id >0 and warrenty_available = 'yes' `;
        if (req.assetCode) {
            getEntities = getEntities + 'and aas.assets_code = "' + req.assetCode + '"'
        }
        if (req.location) {
            getEntities = getEntities + 'and loc.location_name = "' + req.location + '"'
        }
        if (req.assetCategory) {
            getEntities = getEntities + 'and isc.item_sub_category = "' + req.assetCategory + '"'
        }
        if (req.assetType) {
            getEntities = getEntities + ' and aas.asset_type = "' + req.assetType + '"'
        }
        if (req.plant && req.location) {
            getEntities = getEntities + 'and unc.unit_name = "' + req.plant + '" and loc.location_name = "' + req.location + '"'
        }
        if (req.plantId > 0 && req.plantId != 5) {
            getEntities = getEntities + 'and aas.plant = ' + req.plantId
        }

        const assetdata = await manager.query(getEntities)

        return new CommonResponse(true, 1, 'Data retrieved successfully', assetdata)
    }
    async getWarrantyDropDownAssets(req: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `
    SELECT aas.asset_category,isc.item_sub_category,aas.assets_name, it.item_name AS item_name,aas.assets_code
    FROM ` + appSettings.assets_db + `.assets aas 
    LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
    LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
    LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
    LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id 
    LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
    LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
    LEFT JOIN `+ appSettings.assets_db + `.asset_assignment assi ON assi.asset_id = aas.asset_id
    LEFT JOIN `+ appSettings.masters_db + `.employee_details empd ON empd.employee_id = assi.employee_id
    LEFT JOIN `+ appSettings.masters_db + `.departments dep ON dep.dept_id = empd.department_id
    WHERE aas.asset_id >0 and warrenty_available = 'yes'`;
        getEntities = getEntities + ` ORDER BY it.item_name ASC`
        const assetdata = await manager.query(getEntities)
        return new CommonResponse(true, 1, 'Data retrieved successfully', assetdata)
    }

    async sendServiceRemainder(): Promise<any> {
        const manager = getManager()
        const todaysServices = `select asr.service_name as serviceName,asr.asset_service_date as serviceDate,a.employee_id as employeeId,ed.employee_name as employeeName,a.model,asr.asset_service_date as serviceDate from ${appSettings.assets_db}.asset_service asr
    left join ${appSettings.assets_db}.assets a on a.asset_id = asr.asset_id
    left join ${appSettings.masters_db}.employee_details ed on ed.employee_id = a.employee_id
    where DATE(asr.asset_service_date) = Date(now())`
        const data = await manager.query(todaysServices)
        const waParameters = [{ type: 'text', text: 'A Naveen ' }, { type: 'text', text: ('service :' + data[0].serviceName) }, { type: 'text', text: data[0].model.trim() }, { type: 'text', text: moment(data[0].serviceDate).format("DD-MM-YYYY") }]
        const msgParameters = new MessageParameters('917036045967', 'service_update', waParameters, 'en_gb')
        const sendMessage = await this.wpService.sendMessageWithButtonThroughFbApi(msgParameters)
        return sendMessage

    }

    async getServiceDataForServiceId(req?: UpdateServiceRemarksDto): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT a.asset_id AS assetId,a.assets_name as assetName ,asr.service_name as serviceName, i.item_name AS assetName , a.assets_code AS assetCode ,ic.item_sub_category AS assetCategory , a.plant as plantId , uc.unit_name AS plant ,l.location_id as locationId , l.location_name AS locationName, i.asset_type AS assetType , a.service_tenure AS serviceTenure , a.created_at AS assetCreateDate ,asr.asset_service_date  AS serviceDate , a.status AS assetStatus , a.service_status AS serviceStatus,asr.status,asr.asset_serve_id as assetServiceId,asr.remarks,asr.service_name as serviceName,asr.service_provider as serviceProvider,asr.service_owner as serviceOwner,a.model,asr.phone_number as phoneNumber FROM ` + appSettings.assets_db + `.asset_service asr
    LEFT JOIN ${appSettings.assets_db}.assets a on a.asset_id = asr.asset_id
    LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories ic ON ic.item_sub_category_id = a.asset_category
    LEFT JOIN `+ appSettings.masters_db + `.items i ON i.item_id = a.assets_name 
    LEFT JOIN `+ appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = a.plant
    LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lm ON lm.asset_id = a.asset_id
    LEFT JOIN `+ appSettings.assets_db + `.location l ON l.location_id = lm.location_id 
    WHERE a.assets_name> 0 and  asr.asset_serve_id = ${req.assetServiceId}`

        const data = await manager.query(query)
        if (query?.length) {
            return new CommonResponse(true, 1111, 'Data Retried Successfully', data);
        } else {
            throw new ErrorResponse(9999, 'No Data Found');
        }
    }

    async topResponsible(): Promise<CommonResponse> {
        const data = [];
        try {
            const manager = getManager();
            const qry = `SELECT COUNT(aas.asset_id) AS numberOfAssets , em.employee_name AS responsible,u.unit_name AS unit ,d.dept_name AS department FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.masters_db + `.employee_details em ON em.employee_id = aas.employee_id LEFT JOIN ` + appSettings.masters_db + `.employee_details emp ON emp.employee_id = aas.owner_of_asset LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id = aas.plant LEFT JOIN ` + appSettings.masters_db + `.departments d ON d.dept_id = em.department_id WHERE em.employee_name IS NOT NULL GROUP BY em.employee_name ORDER BY COUNT(aas.asset_id) DESC LIMIT 5`
            const dropData = await manager.query(qry)
            data.push(dropData)

            if (dropData) {

                return new CommonResponse(true, 1, ' Data retrievd successfully', data)
            } else {
                return new CommonResponse(false, 99898, 'Something went wrong')
            }
        } catch (error) {
            return error
        }
    }

    async getInstockAssets(req: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT aas.asset_id,aas.assets_name,aas.asset_category,it.item_name,aas.status,aas.assets_code,it.item_id,aas.plant
        FROM `+ appSettings.assets_db + `.assets aas
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        WHERE aas.status = 'Idle'`
        if (req.plantId && req.plantId !== 5) {
            getEntities = getEntities + 'and aas.plant = "' + req.plantId + '"'
        }
        if (req.assetCategory) {
            getEntities = getEntities + 'and aas.asset_category = "' + req.assetCategory + '"'
        }
        const assetdata = await manager.query(getEntities)
        if (getEntities?.length) {
            return new CommonResponse(true, 1, 'Data retrieved successfully', assetdata)
        } else {
            throw new ErrorResponse(9999, 'No Data Found');
        }

    }
    async getExpRents(): Promise<CommonResponse> {
        const data = [];
        try {
            const manager = getManager();
            let month = `SELECT a.assets_code ,it.item_name AS assetName,u.unit_name AS unit, a.date_of_purchased,a.asset_rent_tenure_type , a.asset_rent_period, 
        DATE_FORMAT(DATE_ADD(a.date_of_purchased, INTERVAL a.asset_rent_period MONTH),'%Y-%m-%d') AS rentDate ,
        DATEDIFF(DATE_FORMAT(DATE_ADD(a.date_of_purchased, INTERVAL a.asset_rent_period MONTH),'%Y-%m-%d'),DATE(NOW())) AS aging
        FROM ` + appSettings.assets_db + `.assets a
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = a.assets_name
        LEFT JOIN `+ appSettings.masters_db + `.unitcodes u ON u.unit_code_id = a.plant
        WHERE asset_rent_tenure_type = 'Month' AND DATE_FORMAT(DATE_ADD(date_of_purchased, 
        INTERVAL a.asset_rent_period MONTH),'%Y-%m-%d') < DATE(NOW())`;
            const assetMonthdata = await manager.query(month)
            let days = `SELECT a.assets_code ,it.item_name AS assetName,u.unit_name AS unit, a.date_of_purchased,a.asset_rent_tenure_type , a.asset_rent_period, 
        DATE_FORMAT(DATE_ADD(a.date_of_purchased, INTERVAL a.asset_rent_period DAY),'%Y-%m-%d') AS rentDate ,
        DATEDIFF(DATE_FORMAT(DATE_ADD(a.date_of_purchased, INTERVAL a.asset_rent_period DAY),'%Y-%m-%d'),DATE(NOW())) AS aging
        FROM ` + appSettings.assets_db + `.assets a
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = a.assets_name
        LEFT JOIN `+ appSettings.masters_db + `.unitcodes u ON u.unit_code_id = a.plant
        WHERE asset_rent_tenure_type = 'Days' AND DATE_FORMAT(DATE_ADD(date_of_purchased, 
        INTERVAL a.asset_rent_period DAY),'%Y-%m-%d') < DATE(NOW())`;
            const assetDaydata = await manager.query(days)
            let year = `SELECT a.assets_code ,it.item_name AS assetName,u.unit_name AS unit, a.date_of_purchased,a.asset_rent_tenure_type , a.asset_rent_period, 
        DATE_FORMAT(DATE_ADD(a.date_of_purchased, INTERVAL a.asset_rent_period YEAR),'%Y-%m-%d') AS rentDate ,
        DATEDIFF(DATE_FORMAT(DATE_ADD(a.date_of_purchased, INTERVAL a.asset_rent_period YEAR),'%Y-%m-%d'),DATE(NOW())) AS aging
        FROM ` + appSettings.assets_db + `.assets a
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = a.assets_name
        LEFT JOIN `+ appSettings.masters_db + `.unitcodes u ON u.unit_code_id = a.plant
        WHERE asset_rent_tenure_type = 'Year' AND DATE_FORMAT(DATE_ADD(date_of_purchased, 
        INTERVAL a.asset_rent_period YEAR),'%Y-%m-%d') < DATE(NOW())`;
            const assetYeardata = await manager.query(year)
            //  data.push(assetMonthdata)
            //  data.push(assetDaydata)
            //  data.push(assetYeardata)
            const mergeArry = [...assetMonthdata, ...assetDaydata, ...assetYeardata]
            return new CommonResponse(true, 1, 'Data retrieved successfully', mergeArry)
        } catch (error) {
            return error
        }
    }

    async assetHistory(req: AssetByCode): Promise<CommonResponse> {
        const manager = getManager();
        let query = `SELECT asst.created_at AS transactionDate ,asst.status AS transactionType ,asst.service_name AS serviceName ,asst.maintenance_cost AS maintenanceCost ,em.employee_name AS employeeName,d.dept_name AS department ,loc.location_name AS location ,emp.employee_name AS Approved FROM ` + appSettings.assets_db + `.assets_transactions asst LEFT JOIN ` + appSettings.assets_db + `.assets aas ON aas.asset_id = asst.asset_id LEFT JOIN ` + appSettings.masters_db + `.employee_details em ON em.employee_id = asst.employee_id LEFT JOIN ` + appSettings.masters_db + `.employee_details emp ON emp.employee_id= asst.decommission_approved_by LEFT JOIN ` + appSettings.assets_db + `.location loc ON loc.location_id = asst.location_id LEFT JOIN ` + appSettings.masters_db + `.departments d ON d.dept_id = em.department_id WHERE aas.assets_code = '${req.assetsCode}'`
        if(req?.plant){
            query += ` AND aas.plant = '${req.plant}'`;
        } 
        query += ` ORDER BY asst.created_at`
        const data = await manager.query(query)
        if (data && data.length > 0) {
            return new CommonResponse(true, 1111, 'Data Retreived Successfully', data);
        } else {
            return new CommonResponse(false, 9999, `No Data Found for asset code ${req.assetsCode} in the specified plant ${req.plant || 'N/A'}`);
        }
    }

    async depreciaitionReport(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT aas.asset_id,aas.assets_code,aas.assets_name,aas.model,aas.asset_serialno,aas.date_of_purchased,aas.asset_cost,
        it.item_name,aas.plant,aas.asset_category,aas.asset_mode,aas.asset_type,aas.expired_date,aas.status,aas.asset_condition,
        aas.asset_invoice_no,aas.owner_of_asset,isc.item_sub_category,unc.unit_name,l.location_name,aas.asset_condition,
        DATEDIFF(DATE(NOW()),aas.date_of_purchased) AS assetAge,
        TIMESTAMPDIFF(YEAR,aas.date_of_purchased,DATE(NOW())) AS yeardiff,
        TIMESTAMPDIFF(YEAR,DATE(NOW()),aas.expired_date) AS remainingLife,
        TIMESTAMPDIFF(YEAR,aas.date_of_purchased,aas.expired_date) AS lifediff,
        ass.created_at as assetSaleDate,ass.asset_sale_cost
        FROM `+ appSettings.assets_db + `.assets aas
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.unitcodes unc ON unc.unit_code_id = aas.plant      
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lm ON lm.asset_id = aas.asset_id
        LEFT JOIN `+ appSettings.assets_db + `.location l ON l.location_id = lm.location_id 
        LEFT JOIN `+ appSettings.assets_db + `.assets_sale ass ON ass.asset_id = aas.asset_id
        WHERE aas.asset_id > 0 `
        if (req.assetCode) {
            getEntities = getEntities + 'and aas.assets_code = "' + req.assetCode + '"'
        }
        if (req.location) {
            getEntities = getEntities + 'and l.location_name = "' + req.location + '"'
        }
        if (req.assetCategory) {
            getEntities = getEntities + 'and isc.item_sub_category = "' + req.assetCategory + '"'
        }
        if (req.assetType) {
            getEntities = getEntities + ' and aas.asset_type = "' + req.assetType + '"'
        }
        if (req.plant && req.location) {
            getEntities = getEntities + 'and unc.unit_name = "' + req.plant + '" and l.location_name = "' + req.location + '"'
        }
        if (req.plantId > 0 && req.plantId != 5) {
            getEntities = getEntities + 'and aas.plant = ' + req.plantId
        }
        if (req.aging != undefined) {
            if (req.aging == '50') {
                getEntities = getEntities + ' having assetAge < 50 '
            }
            if (req.aging == '51-300') {
                getEntities = getEntities + ' having assetAge between 51 and 300'
            }
            if (req.aging == '301-900') {
                getEntities = getEntities + ' having assetAge between 301 and 900'
            }
            if (req.aging == '901-1500') {
                getEntities = getEntities + ' having assetAge between 901 and 1500'
            }
            if (req.aging == '1501-2125') {
                getEntities = getEntities + ' having assetAge between 1096 and 2125'
            }
            if (req.aging == '2125-3000') {
                getEntities = getEntities + '  having assetAge between 2125 and 3000'
            }
            if (req.aging == '3000-3600') {
                getEntities = getEntities + '  having assetAge between 3000 and 3600'
            }
            if (req.aging == '3600-4200') {
                getEntities = getEntities + '  having assetAge between 3600 and 4200'
            }
            if (req.aging == 'above 4200') {
                getEntities = getEntities + ' having assetAge > 4200'
            }
        }
        if (req.aging != undefined) {
            getEntities = getEntities + ' ORDER BY assetAge ASC'
        } else {
            getEntities = getEntities + ' ORDER BY it.item_name ASC'
        }


        const data = await manager.query(getEntities)
        if (getEntities?.length) {
            return new CommonResponse(true, 1111, 'Data Retreived Successfully', data);
        } else {
            throw new ErrorResponse(9999, 'No Data Found');
        }
    }

    async getRentedAssetsDetails(): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let rentedDetailQuery = `SELECT COUNT(asset_id) AS assets,SUM(SUBSTRING_INDEX(asset_cost,'.',1)) AS cost ,aas.status FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.masters_db + `.items it ON it.item_id = aas.assets_name WHERE aas.asset_mode = 'RentedAsset' GROUP BY STATUS`
            const data = await manager.query(rentedDetailQuery)
            if (rentedDetailQuery) {
                return new CommonResponse(true, 2222, 'Data Retreived Successfully', data)
            } else {
                throw new ErrorResponse(222, 'No Data Found')
            }
        } catch (error) {
            error
        }
    }
    async getAssignedforRentCatogry(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let Query = 'SELECT a.asset_category,isc.item_sub_category FROM ' + appSettings.assets_db + `.assets a LEFT JOIN ` + appSettings.masters_db + `.item_sub_categories isc ON a.asset_category=isc.item_sub_category_id WHERE asset_mode = 'rentedAsset' and status = '${AssetStatusEnum.Idle}' `;
        if (req.plantId > 0 && req.plantId != 5) {
            Query = Query + 'and a.plant = ' + req.plantId
        }
        Query = Query + ` GROUP BY a.asset_category ORDER BY isc.item_sub_category ASC`
        const result = await manager.query(Query);
        if (result.length > 0) {
            return new CommonResponse(true, 11608, 'Data Retrived Sucessfullyy.....', result)
        }
        else {
            return new CommonResponse(false, 11608, 'No data Found', result)
        }

    }
    async getpurchasedAssetCatogry(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let Query = 'SELECT a.asset_category,isc.item_sub_category FROM ' + appSettings.assets_db + `.assets a LEFT JOIN ` + appSettings.masters_db + `.item_sub_categories isc ON a.asset_category=isc.item_sub_category_id WHERE STATUS IN ("Idle") `;
        if (req.plantId > 0 && req.plantId != 5) {
            Query = Query + 'and a.plant = ' + req.plantId
        }
        Query = Query + ` GROUP BY a.assets_code ORDER BY i.item_name ASC`
        const result = await manager.query(Query);
        if (result.length > 0) {
            return new CommonResponse(true, 11608, 'Data Retrived Sucessfullyy.....', result)
        }
        else {
            return new CommonResponse(false, 11608, 'No data Found', result)
        }
    }
    async getTop5SaleAssets(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let Query = 'SELECT a.asset_id,a.assets_code,it.item_name AS assetName,asset_sale_cost,u.unit_name AS unit,ass.created_at AS saleDate FROM `shahi_assets`.`assets_sale` ass LEFT JOIN `shahi_assets`.`assets` a ON a.asset_id = ass.asset_sale_id  LEFT JOIN `shahi_asset_master`.unitcodes u ON u.unit_code_id = a.plant LEFT JOIN `shahi_asset_master`.items it ON it.item_id = a.assets_name ORDER BY asset_sale_cost*1 DESC LIMIT 5';
        if (req.plantId > 0 && req.plantId != 5) {
            Query = Query + 'and a.plant = ' + req.plantId + ''
        }
        const result = await manager.query(Query);
        if (result.length > 0) {
            return new CommonResponse(true, 11608, 'Data Retrived Sucessfullyy.....', result)
        }
        else {
            return new CommonResponse(false, 11608, 'No data Found', result)
        }


    }

    async getMonthwiseAssetsSale(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let Query = '   SELECT COUNT(*) AS totalCount,SUM(asset_sale_cost) AS totalCost,MONTHNAME(created_at) AS MONTH FROM  `shahi_assets`.`assets_sale` GROUP BY MONTH(created_at)';
        const result = await manager.query(Query);
        if (result.length > 0) {
            return new CommonResponse(true, 11608, 'Data Retrived Sucessfullyy.....', result)
        }
        else {
            return new CommonResponse(false, 11608, 'No data Found', result)
        }


    }
    async getAuditReportData(req?: AssetServiceRportReq): Promise<CommonResponse> {
        const manager = getManager();
        let query = 'SELECT l.location_name AS locationName,isc.item_sub_category AS categoryName,audit_type AS auditType,alm.asset_id AS assetId,DATE(audit_date) AS auditDate,a.assets_code AS assetsCode,audit_provider AS auditProvider,audit_name AS auditName,audit_owner AS auditOwner,assets_count AS assetsCount,working AS workingAssets,not_working AS notWorkingAssets,la.status,l.plant AS plant,u.unit_name AS unitName FROM `shahi_assets`.`location_audit` la LEFT JOIN `shahi_assets`.`location` l ON la.location_id = l.location_id LEFT JOIN `shahi_asset_master`.`unitcodes` u ON l.plant = u.unit_code_id LEFT JOIN `shahi_assets`.`asset_location_mapping` alm ON alm.location_id = l.location_id LEFT JOIN `shahi_assets`.`assets` a ON a.asset_id = alm.asset_id LEFT JOIN shahi_asset_master.item_sub_categories isc ON isc.item_sub_category_id=a.asset_category  WHERE a.asset_id >0';
        if (req.assetCode) {
            query = query + ' and a.assets_code = "' + req.assetCode + '"'
        }
        if (req.plant && req.plant != 5) {
            query = query + ' and l.plant = ' + req.plant + ''
        }
        if (req.location) {
            query = query + ' and l.location_id =' + req.location + ''
        }
        if (req.assetCategory) {
            query = query + ' and a.asset_category=' + req.assetCategory + ''
        }
        if (req.assetCategory && req.assetCode && req.location && req.plant) {
            query = query + ' and a.assets_code = "' + req.assetCode + '" and l.plant = ' + req.plant + ' and l.location_id =' + req.location + ' and a.asset_category=' + req.assetCategory + ''
        }
        if (req.plant && req.assetCode) {
            query = query + ' and l.plant = ' + req.plant + ' and a.assets_code = "' + req.assetCode + '"'
        }
        if (req.assetCategory && req.assetCode && req.plant) {
            query = query + ' and a.assets_code = "' + req.assetCode + '" and l.plant = ' + req.plant + ' and a.asset_category=' + req.assetCategory + ''
        }
        if (req.plant && req.assetCode && req.location) {
            query = query + ' and l.plant = ' + req.plant + ' and a.assets_code = "' + req.assetCode + '" and l.location_id =' + req.location + ''
        }
        if (req.plant && req.location) {
            query = query + ' and l.plant = ' + req.plant + ' and l.location_id = "' + req.location + '"'
        }
        const result = await manager.query(query);
        if (result.length > 0) {
            return new CommonResponse(true, 11608, 'Data Retrived Sucessfullyy.....', result)
        }
        else {
            return new CommonResponse(false, 11608, 'No data Found', result)
        }


    }

    async getAssetSaleReport(req?: AssetServiceRportReq): Promise<CommonResponse> {
        const manager = getManager();
        let query = 'SELECT a.asset_id,a.assets_code AS assetCode,it.item_name AS assetName,asset_sale_cost AS assetSaleCost,u.unit_name AS unit ,isc.item_sub_category AS assetCategory,a.plant AS plant,l.location_name AS locationName FROM `shahi_assets`.`assets_sale` ass LEFT JOIN `shahi_assets`.`assets` a ON a.asset_id = ass.asset_sale_id LEFT JOIN `shahi_asset_master`.unitcodes u ON u.unit_code_id = a.plant LEFT JOIN `shahi_asset_master`.items it ON it.item_id = a.assets_name LEFT JOIN shahi_asset_master.unitcodes uc ON uc.unit_code_id=a.plant LEFT JOIN shahi_asset_master.item_sub_categories isc ON isc.item_sub_category_id=a.asset_category LEFT  JOIN shahi_assets.asset_location_mapping al ON a.asset_id=al.asset_id LEFT JOIN shahi_assets.location l ON l.location_id = al.location_id WHERE a.asset_id >0';
        if (req.assetCode) {
            query = query + ' and a.assets_code = "' + req.assetCode + '"'
        }
        if (req.plant && req.plant != 5) {
            query = query + ' and a.plant = ' + req.plant + ''
        }
        if (req.location) {
            query = query + ' and l.location_id =' + req.location + ''
        }
        if (req.assetCategory) {
            query = query + ' and a.asset_category=' + req.assetCategory + ''
        }
        if (req.assetCategory && req.assetCode && req.location && req.plant) {
            query = query + ' and a.assets_code = "' + req.assetCode + '" and a.plant = ' + req.plant + ' and l.location_id =' + req.location + ' and a.asset_category=' + req.assetCategory + ''
        }
        if (req.plant && req.assetCode) {
            query = query + ' and a.plant = ' + req.plant + ' and a.assets_code = "' + req.assetCode + '"'
        }
        if (req.plant && req.assetCode && req.location) {
            query = query + ' and a.plant = ' + req.plant + ' and a.assets_code = "' + req.assetCode + '" and l.location_id =' + req.location + 'ORDER BY asset_sale_cost*1 DESC'
        }
        const result = await manager.query(query);
        if (result.length > 0) {
            return new CommonResponse(true, 11608, 'Data Retrived Sucessfullyy.....', result)
        }
        else {
            return new CommonResponse(false, 11608, 'No data Found', result)
        }


    }
    async getVmsReportData(req?: AssetServiceRportReq): Promise<CommonResponse> {
        const manager = getManager();
        let query = '  SELECT a.asset_id,assets_name,a.assets_code AS assetCode,isc.item_sub_category AS assetCategory,l.location_name AS locationName,asset_serialno,assets_code,STATUS,HOST,host_type AS hostType,host_address AS hostAddress,provisioned_space AS provisionedSpace,used_space AS usedSpace,compatibility,memory_size AS memorySize,CPU,nic,vm_ware_version_tool_status AS vmWareVersionTool,a.plant,uc.unit_name AS plantName FROM `shahi_assets`.`assets` a LEFT JOIN shahi_asset_master.item_sub_categories isc ON isc.item_sub_category_id=a.asset_category LEFT JOIN `shahi_assets`.`asset_location_mapping` alm ON  a.asset_id =alm.asset_id LEFT JOIN `shahi_assets`.`location` l ON l.location_id = alm.location_id LEFT JOIN shahi_asset_master.unitcodes uc ON uc.unit_code_id=a.plant WHERE host_type = "VM" ';
        if (req.assetCode) {
            query = query + ' and a.assets_code = "' + req.assetCode + '"'
        }
        if (req.plant && req.plant != 5) {
            query = query + ' and a.plant = ' + req.plant + ''
        }
        if (req.location) {
            query = query + ' and l.location_id =' + req.location + ''
        }
        if (req.assetCategory) {
            query = query + ' and a.asset_category=' + req.assetCategory + ''
        }
        if (req.assetCategory && req.assetCode && req.location && req.plant) {
            query = query + ' and a.assets_code = "' + req.assetCode + '" and a.plant = ' + req.plant + ' and l.location_id =' + req.location + ' and a.asset_category=' + req.assetCategory + ''
        }
        if (req.plant && req.assetCode) {
            query = query + ' and a.plant = ' + req.plant + ' and a.assets_code = "' + req.assetCode + '"'
        }
        if (req.plant && req.assetCode && req.location) {
            query = query + ' and a.plant = ' + req.plant + ' and a.assets_code = "' + req.assetCode + '" and l.location_id =' + req.location + ''
        }
        const result = await manager.query(query);
        if (result.length > 0) {
            return new CommonResponse(true, 11608, 'Data Retrived Sucessfullyy.....', result)
        }
        else {
            return new CommonResponse(false, 11608, 'No data Found', result)
        }


    }


    // @Cron('0 19 * * *')
    // async getServiceReport() {
    //     try {
    //         const manager = getManager();

    //         const serviceQuery = `
    //   SELECT 
    //     COUNT(asset_serve_id) AS services,
    //     SUM(CASE WHEN STATUS = 'OPEN' THEN 1 ELSE 0 END) AS skip,
    //     SUM(CASE WHEN STATUS = 'INPROGRESS' THEN 1 ELSE 0 END) AS inprogress,
    //     SUM(CASE WHEN STATUS = 'COMPLETED' THEN 1 ELSE 0 END) AS completed,
    //     SUM(CASE WHEN STATUS = 'APPROVED' THEN 1 ELSE 0 END) AS approved
    //   FROM ${appSettings.assets_db}.asset_service
    //   WHERE DATE(act_asset_service_date) = DATE(NOW())
    // `;

    //         const result = await manager.query(serviceQuery);

    //         if (result.length > 0) {
    //              const contactDetails = ['917036716813','917702255295','917702621117','918220385835','919008672528','918886643838'];
    //             //  const contactDetails = ['917036716813','917036784473'];
    //             let statusFlag = true;
    //             let errorMessage = "";

    //             const messageContent = `Service Report Alert \\n Services: ${result[0].services} \\n Skipped: ${result[0].skip} \\n In Progress: ${result[0].inprogress} \\n Completed: ${result[0].completed} \\n Approved: ${result[0].approved}`;

    //             const parameters = [
    //                 { "type": "text", "text": moment().format('YYYY-MM-DD') },
    //                 { "type": "text", "text": messageContent },
    //             ];

    //             for (const contact of contactDetails) {
    //                 let retries = 0;
    //                 let messageSent = false;

    //                 while (retries < 3 && !messageSent) {
    //                     try {
    //                         const whatsappRes = new MessageParameters(contact, 'vrs_alert', parameters, 'en_us');
    //                         console.log('Sending WhatsApp message with data:', JSON.stringify(whatsappRes));
    //                         const messageStatus = await this.wpService.sendMessageThroughFbApi(whatsappRes);
    //                         console.log(messageStatus, 'messageStatus');

    //                         if (messageStatus.status) {
    //                             messageSent = true;
    //                         } else {
    //                             retries++;
    //                             console.error(`Failed to send message to ${contact} (Attempt ${retries + 1}):`, messageStatus.internalMessage);
    //                         }
    //                     } catch (error) {
    //                         retries++;
    //                         console.error(`Error sending message to ${contact} (Attempt ${retries + 1}):`, error.message);
    //                     }
    //                 }

    //                 if (!messageSent) {
    //                     statusFlag = false;
    //                     errorMessage += `Failed to send message to ${contact} after 3 attempts.\n`;
    //                 }
    //             }

    //             return new CommonResponse(statusFlag, statusFlag ? 1 : 0, statusFlag ? 'Messages sent successfully' : `Failed to send some messages: ${errorMessage}`, result[0]);
    //         } else {
    //             return new CommonResponse(false, 0, 'No data found', null);
    //         }
    //     } catch (err) {
    //         console.error('Error while sending message', err);
    //         return new CommonResponse(false, 11108, "Error while sending message");
    //     }
    // }

    @Cron('0 19 * * *')
    async getServiceReport() {
        try {
            const manager = getManager();
    
            const serviceQuery = `
            SELECT 
            unc.unit_name AS unit,
            COUNT(ass.asset_serve_id) AS services,
            SUM(CASE WHEN ass.STATUS = 'OPEN' THEN 1 ELSE 0 END) AS Skipped,
            SUM(CASE WHEN ass.STATUS = 'INPROGRESS' THEN 1 ELSE 0 END) AS inprogress,
            SUM(CASE WHEN ass.STATUS = 'COMPLETED' THEN 1 ELSE 0 END) AS completed,
            SUM(CASE WHEN ass.STATUS = 'APPROVED' THEN 1 ELSE 0 END) AS approved
        FROM shahi_assets.asset_service ass
        LEFT JOIN shahi_assets.assets ss ON ss.asset_id = ass.asset_id
        LEFT JOIN shahi_asset_master.unitcodes unc ON unc.unit_code_id = ss.plant
        WHERE DATE(ass.act_asset_service_date) = DATE(NOW())
        GROUP BY ss.plant
            `;
    
            const result = await manager.query(serviceQuery);
    
            if (result.length > 0) {
                const contactDetails = ['917036716813','917702255295','917702621117','918220385835','919008672528','918886643838'];
                let statusFlag = true;
                let errorMessage = "";
    
                for (const unit of result) {
                    const messageContent = `Service Report for ${unit.unit} \\n Services: ${unit.services} \\n Skipped: ${unit.Skipped} \\n In Progress: ${unit.inprogress} \\n Completed: ${unit.completed} \\n Approved: ${unit.approved}`;
    
                    const parameters = [
                        { "type": "text", "text": moment().format('YYYY-MM-DD') },
                        { "type": "text", "text": messageContent },
                    ];
    
                    for (const contact of contactDetails) {
                        let retries = 0;
                        let messageSent = false;
    
                        while (retries < 3 && !messageSent) {
                            try {
                                const whatsappRes = new MessageParameters(contact, 'vrs_alert', parameters, 'en_us');
                                console.log('Sending WhatsApp message with data:', JSON.stringify(whatsappRes));
                                const messageStatus = await this.wpService.sendMessageThroughFbApi(whatsappRes);
                                console.log(messageStatus, 'messageStatus');
    
                                if (messageStatus.status) {
                                    messageSent = true;
                                } else {
                                    retries++;
                                    console.error(`Failed to send message to ${contact} (Attempt ${retries + 1}):`, messageStatus.internalMessage);
                                }
                            } catch (error) {
                                retries++;
                                console.error(`Error sending message to ${contact} (Attempt ${retries + 1}):`, error.message);
                            }
                        }
    
                        if (!messageSent) {
                            statusFlag = false;
                            errorMessage += `Failed to send message to ${contact} for Unit ${unit.unit_id} after 3 attempts.\n`;
                        }
                    }
                }
    
                return new CommonResponse(statusFlag, statusFlag ? 1 : 0, statusFlag ? 'Messages sent successfully' : `Failed to send some messages: ${errorMessage}`, result);
            } else {
                return new CommonResponse(false, 0, 'No data found', null);
            }
        } catch (err) {
            console.error('Error while sending message', err);
            return new CommonResponse(false, 11108, "Error while sending message");
        }
    }

    
    async getRevenuReport(): Promise<CommonResponse> {
        const data = [];
        try {
            const manager = getManager()
            let qry = `SELECT aas.asset_category AS assetCategory ,it.item_sub_category AS category, COUNT(aas.assets_name) AS assets,SUM(aas.asset_cost) AS purchaseCost,SUM(aas.asset_cost * POWER(0.95, YEAR(CURDATE()) - YEAR(aas.date_of_purchased))) AS currentCost FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.masters_db + `.item_sub_categories it ON it.item_sub_category_id = aas.asset_category WHERE aas.status != 'Sold'
            GROUP BY aas.asset_category ORDER BY SUM(aas.asset_cost)*1 DESC`;
            let qry1 = `SELECT aas.asset_category AS saleCategory ,it.item_sub_category AS saleSubCategory,COUNT(sa.asset_id) AS saleAssets,SUM(sa.asset_sale_cost) AS saleCost FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.masters_db + `.item_sub_categories it ON it.item_sub_category_id = aas.asset_category LEFT JOIN ` + appSettings.assets_db + `.assets_sale sa ON sa.asset_id = aas.asset_id GROUP BY aas.asset_category`;
            let qry2 = `SELECT aas.asset_category AS expiredCategory ,it.item_sub_category AS expiredSubCategory, COUNT(aas.assets_name) AS expiredAssets,SUM(aas.asset_cost) AS purchaseCost,SUM(aas.asset_cost * POWER(0.95, YEAR(CURDATE()) - YEAR(aas.date_of_purchased))) AS currentCost FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.masters_db + `.item_sub_categories it ON it.item_sub_category_id = aas.asset_category WHERE aas.expired_date < DATE(NOW()) GROUP BY aas.asset_category`;
            const query = await manager.query(qry);
            data.push(query)
            const query1 = await manager.query(qry1);
            data.push(query1)
            const query2 = await manager.query(qry2);
            data.push(query2)
            return new CommonResponse(true, 1, "Data Retrived Successfully", data);

        } catch (err) {
            return new CommonResponse(false, 11108, "Error while sending message")
        }

    }

    async updateServiceChecklist(req: UpdateChecklist): Promise<CommonResponse> {
        const updateChecklist = await this.checklistRepo.update({ assetServiceCheckListId: req.assetServiceChecklistId }, { condition: req.condition, reason: req.reason, checklistStatus: AssetStatusEnum.Completed })
        if (updateChecklist.affected) {
            return new CommonResponse(true, 1111, 'Checklist updated')
        } else {
            return new CommonResponse(false, 2321, "Failed to update")
        }
    }

    // async updateChecklist(req: UpdateChecklist[]): Promise<CommonResponse> {
    //     console.log(req, 'req')
    //     let flag = true;
    //     for (const id of req) {
    //         const updateChecklist = await this.checklistRepo.update({ assetServiceCheckListId: id.assetServiceChecklistId }, { condition: id.condition, reason: id.reason, checklistStatus: AssetStatusEnum.Completed })
    //         console.log(updateChecklist, 'updateChecklist')
    //         const updateServiceStatus = await this.assetServiceRepo.update({ assetServeId: id.assetServeId }, { status: ServiceStatusEnum.COMPLETE })
    //         if (updateChecklist.affected == 0) {
    //             flag = false;
    //             return new CommonResponse(false, 2321, "Failed to update")
    //         }
    //     }
    //     if (flag) {
    //         return new CommonResponse(true, 1111, 'Checklist updated')
    //     } else {
    //         return new CommonResponse(false, 2321, "Failed to update")
    //     }
    // }

    async updateChecklist(req: UpdateChecklist[]): Promise<CommonResponse> {
        console.log(req, 'req');
        let successCount = 0;
    
        for (const id of req) {
            try {
                const updateChecklist = await this.checklistRepo.update(
                    { assetServiceCheckListId: id.assetServiceChecklistId },
                    { condition: id.condition, reason: id.reason, checklistStatus: AssetStatusEnum.Completed }
                );
                console.log(updateChecklist, 'updateChecklist');
    
                if (updateChecklist.affected > 0) {
                    const updateServiceStatus = await this.assetServiceRepo.update(
                        { assetServeId: id.assetServeId },
                        { status: ServiceStatusEnum.COMPLETE }
                    );
                    if (updateServiceStatus.affected > 0) {
                        successCount++;
                    } else {
                        console.error(`Failed to update service status for assetServeId ${id.assetServeId}`);
                    }
                } else {
                    console.error(`Failed to update checklist for assetServiceCheckListId ${id.assetServiceChecklistId}`);
                }
            } catch (error) {
                console.error(`Error updating checklist or service status for assetServiceCheckListId ${id.assetServiceChecklistId}:`, error);
            }
        }
    
        if (successCount === req.length) {
            return new CommonResponse(true, 1111, 'All checklists updated successfully');
        } else if (successCount > 0) {
            return new CommonResponse(true, 1112, `${successCount} out of ${req.length} checklists updated successfully`);
        } else {
            return new CommonResponse(false, 2321, 'Failed to update checklists');
        }
    }


    async createChecklist(checklistData: ChecklistItem[]): Promise<any> {
        try {
          const newChecklists = checklistData.map((item) => {
            return this.checklistRepo.create({
              checklist: item.checklistItem,
              assetService: item.assetServeId,
              checklistStatus: item.isChecked ? 'Completed' : 'Open',
            });
          });
    
          // Save all checklists in one batch
          const savedChecklists = await this.checklistRepo.save(newChecklists);
          console.log('Checklist items saved successfully:', savedChecklists);
          return {
            status: true,
            message: 'Checklist items created successfully',
            data: savedChecklists,
          };
        } catch (error) {
          console.error('Error creating checklist items:', error);
          return {
            status: false,
            message: 'Error creating checklist items',
            error: error.message,
          };
        }
      }

    async getCurrentService(req?: AssetServiceReq): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT a.asset_id AS assetId,a.assets_name as assetName ,asr.service_name as serviceName, i.item_name AS assetName , a.assets_code AS assetCode ,ic.item_sub_category AS assetCategory , a.plant as plantId , uc.unit_name AS plant ,l.location_id as locationId , l.location_name AS locationName, i.asset_type AS assetType , a.service_tenure AS serviceTenure , a.created_at AS assetCreateDate ,asr.asset_service_date  AS serviceDate , a.status AS assetStatus , a.service_status AS serviceStatus,asr.status,asr.asset_serve_id as assetServiceId,asr.remarks,asr.service_name as serviceName,asr.service_provider as serviceProvider,asr.start_date as startDate,asr.completed_date as completedDate FROM ` + appSettings.assets_db + `.asset_service asr
        LEFT JOIN ${appSettings.assets_db}.assets a on a.asset_id = asr.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories ic ON ic.item_sub_category_id = a.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items i ON i.item_id = a.assets_name 
        LEFT JOIN `+ appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = a.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lm ON lm.asset_id = a.asset_id
        LEFT JOIN `+ appSettings.assets_db + `.location l ON l.location_id = lm.location_id 
        WHERE asr.asset_category = ${req.assetCategory} AND asr.status = 'OPEN' AND DATE(asr.asset_service_date) = DATE(NOW())`;
        const data = await manager.query(query)
        return new CommonResponse(true, 1, "Data Retrived Successfully", data);

    }

    // async getAssetChecklist(req?: AssetChecklistRequestDto): Promise<CommonResponse> {
    //     const manager = getManager()
    //     let query = `SELECT ac.asset_service_checklist_id, ac.checklist ,acc.sub_name AS subName, ass.asset_serve_id  FROM ` + appSettings.assets_db + `.asset_service_checklist ac LEFT JOIN ` + appSettings.assets_db + `.asset_service ass ON ass.asset_serve_id = ac.asset_serve_id LEFT JOIN ` + appSettings.assets_db + `.asset_checklist acc ON acc.checklist_name = ac.checklist WHERE ass.asset_serve_id = ${req.assetServeId}`;
    //     const data = await manager.query(query)
    //     return new CommonResponse(true, 1, "Data Retrived Successfully", data);

    // }


    async getAssetChecklist(req?: AssetChecklistRequestDto): Promise<CommonResponse> {
        const manager = getManager()
        let query = `WITH RECURSIVE split_checklist AS (
  SELECT 
    acc.asset_category_id,
    asv.asset_name,
    asv.asset_serve_id AS assetServeId,
    SUBSTRING_INDEX(acc.checklist_name, ',', 1) AS checklist_item,
    SUBSTRING(acc.checklist_name, LOCATE(',', acc.checklist_name) + 1) AS remaining
  FROM shahi_asset_master.asset_checklist acc
  JOIN shahi_assets.asset_service asv 
    ON acc.asset_category_id = asv.asset_name 
  WHERE asv.asset_serve_id = ${req.assetServeId}
  UNION ALL
  SELECT 
    asset_category_id,
    asset_name,
    assetServeId,
    SUBSTRING_INDEX(remaining, ',', 1) AS checklist_item,
    SUBSTRING(remaining, LOCATE(',', remaining) + 1) AS remaining
  FROM split_checklist
  WHERE remaining LIKE '%,%'
)
SELECT checklist_item AS checklistItem, asset_name AS assetName, assetServeId
FROM split_checklist`;
        const data = await manager.query(query)
        return new CommonResponse(true, 1, "Data Retrived Successfully", data);

    }

    async getLocationService(req?: AssetServiceReq): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT a.asset_id AS assetId,a.assets_name as assetName ,asr.service_name as serviceName, i.item_name AS assetName , a.assets_code AS assetCode ,ic.item_sub_category AS assetCategory , a.plant as plantId , uc.unit_name AS plant ,l.location_id as locationId , l.location_name AS locationName, i.asset_type AS assetType , a.service_tenure AS serviceTenure , a.created_at AS assetCreateDate ,asr.asset_service_date  AS serviceDate , a.status AS assetStatus , a.service_status AS serviceStatus,asr.status,asr.asset_serve_id as assetServiceId,asr.remarks,asr.service_name as serviceName,asr.service_provider as serviceProvider,asr.start_date as startDate,asr.completed_date as completedDate FROM ` + appSettings.assets_db + `.asset_service asr
        LEFT JOIN ${appSettings.assets_db}.assets a on a.asset_id = asr.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories ic ON ic.item_sub_category_id = a.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items i ON i.item_id = a.assets_name 
        LEFT JOIN `+ appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = a.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lm ON lm.asset_id = a.asset_id
        LEFT JOIN `+ appSettings.assets_db + `.location l ON l.location_id = lm.location_id 
        WHERE l.location_id = ${req.location} AND asr.status = 'OPEN' AND DATE(asr.asset_service_date) = DATE(NOW())`;
        const data = await manager.query(query)
        return new CommonResponse(true, 1, "Data Retrived Successfully", data);

    }

    async getChecklistReport(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT a.asset_id AS assetId,a.assets_name as assetName ,asr.service_name as serviceName, i.item_name AS assetName , a.assets_code AS assetCode ,ic.item_sub_category AS assetCategory , a.plant as plantId , uc.unit_name AS plant ,l.location_id as locationId , l.location_name AS locationName, i.asset_type AS assetType , a.service_tenure AS serviceTenure , a.created_at AS assetCreateDate ,asr.asset_service_date  AS serviceDate , a.status AS assetStatus , a.service_status AS serviceStatus,asr.status,asr.asset_serve_id as assetServiceId,asr.remarks,asr.service_name as serviceName,asr.service_provider as serviceProvider,asr.start_date as startDate,asr.completed_date as completedDate,acc.checklist,acc.condition,acc.reason,acc.checklist_status AS checklistStatus FROM ` + appSettings.assets_db + `.asset_service_checklist acc LEFT JOIN ` + appSettings.assets_db + `.asset_service asr ON asr.asset_serve_id = acc.asset_serve_id
        LEFT JOIN ${appSettings.assets_db}.assets a on a.asset_id = asr.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories ic ON ic.item_sub_category_id = a.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items i ON i.item_id = a.assets_name 
        LEFT JOIN `+ appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = a.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lm ON lm.asset_id = a.asset_id
        LEFT JOIN `+ appSettings.assets_db + `.location l ON l.location_id = lm.location_id WHERE acc.checklist_status = 'COMPLETED'`
        if (req.assetCode) {
            query = query + 'and a.assets_code = "' + req.assetCode + '"'
        }
        if (req.location) {
            query = query + 'and l.location_name = "' + req.location + '"'
        }
        if (req.assetCategory) {
            query = query + 'and ic.item_sub_category = "' + req.assetCategory + '"'
        }
        if (req.fromDate) {
            query = query + 'and asr.asset_service_date BETWEEN "' + req.fromDate + '" AND "' + req.toDate + '"'
        }
        if (req.plantId > 0 && req.plantId != 5) {
            query = query + 'and a.plant = ' + req.plantId
        } else {
            query = query + `ORDER BY asr.asset_service_date DESC `
        }

        const data = await manager.query(query)
        if (data) {
            return new CommonResponse(true, 11608, 'Data Retrieved Successfully', data)
        } else {
            return new CommonResponse(true, 11608, 'Somethig Went Wrong')
        }

    }

    async getCategoryWiseData(): Promise<CommonResponse> {
        try {
            const manager = getManager()
            const query = 'SELECT asset_category AS assetCategoryid,i.item_sub_category AS itemSubCategory,   COUNT(IF(amc_available = "Yes",1,NULL)) AS amcyesCount,COUNT(IF(amc_available = "No",1,NULL)) AS amcNOCount,COUNT(IF(amc_available = "N/A",1,NULL)) AS amcNACount, COUNT(IF(warrenty_available = "Yes",1,NULL)) AS warrentyYesCount,COUNT(IF(warrenty_available = "No",1,NULL)) AS warrentNOCount,COUNT(IF(warrenty_available = "N/A",1,NULL)) AS warrentyNACount,COUNT(IF(insurance = "Yes",1,NULL)) AS insuranceyesCount,COUNT(IF(insurance = "No",1,NULL)) AS insuranceNOCount,COUNT(IF(insurance = "N/A",1,NULL)) AS insuranceNACount,COUNT(IF(service_type = "REQUIRED",1,NULL)) AS reqCount, COUNT(IF(service_type = "NOT REQUIRED",1,NULL)) AS notReqCount,   COUNT(IF(service_type = "MISSED",1,NULL)) AS misCount FROM shahi_assets.assets a LEFT JOIN shahi_asset_master.item_sub_categories i ON i.item_sub_category_id=a.asset_category GROUP BY asset_category'
            const result = await manager.query(query)
            if (result) {
                return new CommonResponse(true, 1, 'Data retrived', result)
            }
        } catch (err) {
            throw err
        }
    }

    async AssetStatusWiseAbstract(): Promise<AssetStatusWiseAbstractInfoResp> {
        try {
            const manager = getManager();
            const query = `
                SELECT 
                    asset_type AS "assetType",
                    STATUS,
                    COUNT(asset_id) AS "totalAssets",
                    SUM(asset_cost) AS "assetCost",
                    COUNT(CASE WHEN YEAR(created_at) = YEAR(CURRENT_DATE) 
                                AND MONTH(created_at) <= MONTH(CURRENT_DATE) THEN asset_id END) AS "yearToDateAssets",
                    SUM(CASE WHEN YEAR(created_at) = YEAR(CURRENT_DATE) 
                              AND MONTH(created_at) <= MONTH(CURRENT_DATE) THEN asset_cost ELSE 0 END) AS "yearToDateAssetCost",
                    COUNT(CASE WHEN YEAR(created_at) = YEAR(CURRENT_DATE - INTERVAL 1 MONTH)
                                AND MONTH(created_at) <= MONTH(CURRENT_DATE - INTERVAL 1 MONTH) THEN asset_id END) AS "yearToLastMonthAssets",
                    SUM(CASE WHEN YEAR(created_at) = YEAR(CURRENT_DATE - INTERVAL 1 MONTH)
                              AND MONTH(created_at) <= MONTH(CURRENT_DATE - INTERVAL 1 MONTH) THEN asset_cost ELSE 0 END) AS "yearToLastMonthAssetCost"
                FROM 
                    assets
                GROUP BY 
                    asset_type, STATUS
            `;
            const results = await manager.query(query);

            const assetsDataMap = new Map();

            results.forEach(item => {
                const assetTypeInfo = assetsDataMap.get(item.assetType) || {
                    assetType: item.assetType,
                    assetTypeInfo: [],
                    yearToDateAssets: 0,
                    yearToDateAssetCost: 0,
                    yearToLastMonthAssets: 0,
                    yearToLastMonthAssetCost: 0
                };

                assetTypeInfo.assetTypeInfo.push(new AssetStatusInfoModel(
                    item.STATUS,
                    item.totalAssets,
                    item.assetCost
                ));

                assetTypeInfo.yearToDateAssets += parseInt(item.yearToDateAssets);
                assetTypeInfo.yearToDateAssetCost += parseInt(item.yearToDateAssetCost);
                assetTypeInfo.yearToLastMonthAssets += parseInt(item.yearToLastMonthAssets);
                assetTypeInfo.yearToLastMonthAssetCost += parseInt(item.yearToLastMonthAssetCost);

                assetsDataMap.set(item.assetType, assetTypeInfo);
            });

            const data = Array.from(assetsDataMap.values()).map(item => new AssetStatusTypeInfoModel(
                item.assetType,
                item.assetTypeInfo,
                item.yearToDateAssets,
                item.yearToDateAssetCost,
                item.yearToLastMonthAssets,
                item.yearToLastMonthAssetCost
            ));

            return new AssetStatusWiseAbstractInfoResp(true, 1, 'Data retrieved', data);
        } catch (err) {
            console.error('Error in AssetStatusWiseAbstract:', err);
            throw err;
        }
    }


    async AssetVendorDetails(): Promise<AssetVendorDetailsResponse> {
        try {
            const manager = getManager();
            const query = `SELECT 
            v.vendor_code AS vendorCode,
            v.vendor_name AS vendorName,
            COUNT(DISTINCT aa.asset_id) AS totalNoOfAssets,
            SUM(aa.asset_cost) AS assetsValue,
            COUNT(ass.asset_id) AS totalServicesCount,
            COUNT(CASE WHEN aa.status = 'Damaged' THEN 1 END) AS noOfDamagedAssets,
            COUNT(CASE 
                    WHEN ass.status = 'OPEN' AND ass.asset_service_date < CURRENT_DATE THEN 1 
                 END) AS skippedServicesCount,
            COUNT(CASE 
                    WHEN EXTRACT(YEAR FROM ass.asset_service_date) = EXTRACT(YEAR FROM CURRENT_DATE)
                        AND EXTRACT(MONTH FROM ass.asset_service_date) = EXTRACT(MONTH FROM CURRENT_DATE) THEN 1 
                 END) AS thisMonthServicesCount,
            COUNT(CASE 
                    WHEN EXTRACT(YEAR FROM ass.asset_service_date) = EXTRACT(YEAR FROM CURRENT_DATE)
                        AND EXTRACT(MONTH FROM ass.asset_service_date) = EXTRACT(MONTH FROM CURRENT_DATE)
                        AND ass.status = 'COMPLETED' THEN 1 
                 END) AS thisMonthCompletedServices
        FROM 
            shahi_asset_master.vendors v
        LEFT JOIN 
            shahi_assets.assets aa 
            ON aa.name = v.vendor_name
        LEFT JOIN 
            shahi_assets.asset_service ass 
            ON ass.asset_id = aa.asset_id
            GROUP BY 
            v.vendor_name, v.vendor_code`;
            const results = await manager.query(query);
            const data = results.map(item => new AssetVendorDetailsModel(
                item.vendorName,
                item.vendorCode,
                item.totalNoOfAssets,
                item.assetsValue,
                item.totalAmcValue,
                item.amcDue,
                item.totalServicesCount,
                item.skippedServicesCount,
                item.noOfDamagedAssets,
                item.thisMonthServicesCount,
                item.thisMonthCompletedServices
            ));
            return new AssetVendorDetailsResponse(true, 1, 'Data retrieved', data);
        } catch (err) {
            console.error('Error in AssetVendorDetails:', err);
            throw err;
        }
    }

    async serviceOwnerServices(): Promise<ServiceOwnerDetailsResponse> {
        try {
            const manager = getManager();
            const query = `
                SELECT COUNT(asset_serve_id) AS totalNoOfServices, 
                    COUNT(CASE WHEN STATUS = 'OPEN' AND asset_service_date < CURDATE() THEN asset_serve_id END) AS totalNoOfSkippedServices,
                    SUM(CASE WHEN DATEDIFF(asset_service_date, CURDATE()) BETWEEN 1 AND 30 THEN 1 ELSE 0 END) AS noOfServicesDueIn30Days,
                    SUM(CASE WHEN DATEDIFF(asset_service_date, CURDATE()) BETWEEN 31 AND 60 THEN 1 ELSE 0 END) AS noOfServicesDueIn60Days,
                    SUM(CASE WHEN DATEDIFF(asset_service_date, CURDATE()) BETWEEN 61 AND 90 THEN 1 ELSE 0 END) AS noOfServicesDueIn90Days,
                    service_owner AS ownerName
                FROM 
                    asset_service
                GROUP BY 
                    service_owner`;

            const results = await manager.query(query);

            const serviceOwnerDetailsArray: serviceOwnerDetails[] = results.map((result: any) => {
                const servicesList: ServiceListDetails[] = [new ServiceListDetails(
                    result.totalNoOfServices,
                    result.totalServicesValue,
                    result.totalNoOfSkippedServices,
                    result.noOfServicesDueIn30Days,
                    result.noOfServicesDueIn60Days,
                    result.noOfServicesDueIn90Days,
                    0,
                    0
                )];

                const responsible = new AssetCountValueModel(/* Pass appropriate values */);
                const accountable = new AssetCountValueModel(/* Pass appropriate values */);
                const consulted = new AssetCountValueModel(/* Pass appropriate values */);
                const informed = new AssetCountValueModel(/* Pass appropriate values */);

                return new serviceOwnerDetails(
                    result.ownerName,
                    servicesList,
                    responsible,
                    accountable,
                    consulted,
                    informed
                );
            });
            return new ServiceOwnerDetailsResponse(true, 1, 'Data retrieved', serviceOwnerDetailsArray);

        } catch (err) {
            console.error('Error in AssetVendorDetails:', err);
            throw err;
        }
    }

    async AssetCategoryWiseMaintenance(): Promise<AssetCategoryWiseMaintenanceResponse> {
        try {
            const manager = getManager();
            const query1 = `SELECT
            COUNT(aa.asset_id) AS assetsCount,
            SUM(aa.asset_cost) AS assetsValue,
            itt.item_sub_category AS assetCategory,
            SUM(CASE WHEN aa.insurance = 'Yes' THEN 1 ELSE 0 END) AS insuranceCount,
            SUM(CASE WHEN aa.warrenty_available = 'Yes' THEN 1 ELSE 0 END) AS warrantyCount,
            SUM(CASE WHEN aa.amc_available = 'Yes' THEN 1 ELSE 0 END) AS AMCCount
        FROM
            shahi_assets.assets aa
        LEFT JOIN
            shahi_asset_master.item_sub_categories itt ON itt.item_sub_category_id = aa.asset_category
        GROUP BY
            itt.item_sub_category`;
            const assetCategoryWiseMaintenanceData = await manager.query(query1);

            const query2 = `SELECT
            aa.assets_code AS assetsCode,
            aa.expired_date AS expiredDate,
            itt.item_sub_category AS assetCategory
        FROM
            shahi_assets.assets aa
        LEFT JOIN
            shahi_asset_master.item_sub_categories itt
            ON itt.item_sub_category_id = aa.asset_category
        INNER JOIN (
            SELECT 
                asset_category,
                MIN(expired_date) AS min_expired_date
            FROM
                shahi_assets.assets
            WHERE
                expired_date IS NOT NULL
            GROUP BY
                asset_category
        ) AS subquery
        ON aa.asset_category = subquery.asset_category AND aa.expired_date = subquery.min_expired_date
        ORDER BY
            aa.expired_date
        LIMIT 5;`;
            const top5ExpiredAssets = await manager.query(query2);

            const query3 = `SELECT 
            subquery.expireWithinDays,
            COUNT(*) AS assetsCount,
            SUM(subquery.asset_cost) AS assetsValue,
            subquery.assetCategory
        FROM (
            SELECT 
                CASE 
                    WHEN DATEDIFF(aa.expired_date, CURDATE()) < 30 THEN 30
                    WHEN DATEDIFF(aa.expired_date, CURDATE()) >= 30 AND DATEDIFF(aa.expired_date, CURDATE()) < 60 THEN 60
                    WHEN DATEDIFF(aa.expired_date, CURDATE()) >= 60 AND DATEDIFF(aa.expired_date, CURDATE()) < 90 THEN 90
                    ELSE NULL
                END AS expireWithinDays,
                aa.asset_cost,
                itt.item_sub_category AS assetCategory
            FROM 
                shahi_assets.assets aa
            LEFT JOIN 
                shahi_asset_master.item_sub_categories itt 
            ON 
                itt.item_sub_category_id = aa.asset_category
            WHERE 
                aa.expired_date IS NOT NULL
        ) AS subquery
        WHERE 
            subquery.expireWithinDays IS NOT NULL
        GROUP BY 
            subquery.expireWithinDays, subquery.assetCategory;`;
            const assetsExpiryDetails = await manager.query(query3);

            const query4 = `SELECT COUNT(dt.downtimeTreacking_id) AS affectedAssetsCount , dr.downtime_reason AS downTimeCause,itt.item_sub_category AS
            assetCategory FROM shahi_asset_master.downtime_tracking dt 
            LEFT JOIN shahi_asset_master.downtime_reason dr ON dr.downtimereason_id = dt.reason_id
            LEFT JOIN shahi_asset_master.item_sub_categories itt ON itt.item_sub_category_id = dt.asset_category_id
            GROUP BY dr.downtime_reason ,itt.item_sub_category`;
            const downtimeDetails = await manager.query(query4);

            const query5 = `SELECT 
            aa.assets_code AS assetCode, 
            dr.downtime_reason AS downTimeReason,
            dt.startTime AS downTimeStartedAt,
            itt.item_sub_category AS assetCategory
        FROM 
            shahi_asset_master.downtime_tracking dt 
        LEFT JOIN 
            shahi_asset_master.downtime_reason dr 
            ON dr.downtimereason_id = dt.reason_id
        LEFT JOIN 
            shahi_assets.assets aa 
            ON aa.asset_id = dt.asset_id
        LEFT JOIN 
            shahi_asset_master.item_sub_categories itt 
            ON itt.item_sub_category_id = dt.asset_category_id
        ORDER BY 
            dt.startTime DESC -- Assuming you want the latest records
        LIMIT 5`;
            const top5DowntimeAssets = await manager.query(query5);
            const finalResponse: AssetCategoryWiseMaintenanceDetail[] = [];

            for (const data of assetCategoryWiseMaintenanceData) {
                const assetCategory = data.assetCategory;
                const assetCount = data.assetsCount;
                const assetValue = data.assetsValue;

                const relatedDowntimeDetails = downtimeDetails.filter(
                    (d: any) => d.assetCategory === assetCategory
                ).map((d: any) => new DownTimeDetailsModel(d.downTimeCause, d.affectedAssetsCount));

                const relatedTop5DowntimeAssets = top5DowntimeAssets.filter(
                    (d: any) => d.assetCategory === assetCategory
                ).map(
                    (d: any) => new AssetDownTimeDetails(d.assetCode, d.downTimeReason, d.downTimeStartedAt)
                );

                const relatedAssetsExpiryDetails = assetsExpiryDetails.filter(
                    (e: any) => e.assetCategory === assetCategory
                ).map(
                    (e: any) => new AboutToExpireDetail(e.expireWithinDays, e.assetsCount, e.assetsValue)
                );

                const relatedTop5ExpiredAssets = top5ExpiredAssets.filter(
                    (e: any) => e.assetCategory === assetCategory
                ).map(
                    (e: any) => new AssetDetails(e.assetsCode, e.expiredDate, e.assetsValue)
                );

                const assetMaintenanceDetails: AssetMaintenanceInfoModel[] = [
                    new AssetMaintenanceInfoModel(
                        'INSURANCE', 'YEAR', 0, 0, 0, 0, 0, 0, 0,
                        relatedAssetsExpiryDetails, relatedTop5ExpiredAssets
                    ),
                    new AssetMaintenanceInfoModel(
                        'WARRANTY', 'YEAR', 0, 0, 0, 0, 0, 0, 0,
                        relatedAssetsExpiryDetails, relatedTop5ExpiredAssets
                    ),
                    new AssetMaintenanceInfoModel(
                        'AMC', 'YEAR', 0, 0, 0, 0, 0, 0, 0,
                        relatedAssetsExpiryDetails, relatedTop5ExpiredAssets
                    )
                ];

                finalResponse.push(new AssetCategoryWiseMaintenanceDetail(
                    assetCategory, assetCount, assetValue,
                    assetMaintenanceDetails, relatedDowntimeDetails, relatedTop5DowntimeAssets
                ));
            }

            return new AssetCategoryWiseMaintenanceResponse(true, 1, 'Data retrieved', finalResponse);
        } catch (err) {
            console.error('Error in AssetVendorDetails:', err);
            throw err;
        }
    }

    async getResponsibleAssets(): Promise<CommonResponse> {
        try {
            const manager = getManager()
            const query = `SELECT emp.employee_name AS employeeName,COUNT(aa.asset_id) AS countOfAssets,
            COUNT(CASE WHEN ass.STATUS = 'OPEN' AND ass.asset_service_date < CURDATE() AND ass.service_provider = 'In-House' THEN ass.asset_serve_id END) AS serviceSkippedAssets,
            COUNT(CASE WHEN ass.STATUS = 'OPEN' AND ass.asset_service_date < CURDATE() AND ass.service_provider = 'Out-Source' THEN ass.asset_serve_id END) AS amcExpiryAssets,COUNT(CASE WHEN aa.insurance = 'Yes' AND aa.insurance_date < CURDATE() AND aa.insurance_date != 'NULL' THEN aa.asset_id END) AS insuranceSkipped,COUNT(CASE WHEN aa.warrenty_available = 'Yes' AND aa.warrenty_expired_date < CURDATE() AND aa.warrenty_expired_date != 'NULL' THEN aa.asset_id END) AS warrentySkipped,COUNT(CASE WHEN aa.status = 'Idle' THEN aa.asset_id END) AS unassignedAssets
            FROM shahi_assets.assets aa LEFT JOIN shahi_asset_master.employee_details emp ON emp.employee_id = aa.owner_of_asset LEFT JOIN shahi_assets.asset_service ass ON ass.asset_id = aa.asset_id
            GROUP BY emp.employee_name ORDER BY countOfAssets DESC`;
            const result = await manager.query(query)
            if (result) {
                return new CommonResponse(true, 1, 'Data retrived', result)
            }
        } catch (err) {
            throw err
        }
    }
    async uploadInfo(dto: ServiceUploadDto): Promise<CommonResponse> {
        try {
            const entityData = new AssetServiceUpload()
            entityData.maintenanceName = dto.maintenanceName,
                entityData.fileName = dto.fileName,
                entityData.filePath = dto.filePath,
                entityData.serveId = dto.serveId
            const saveData = await this.uploadRepo.save(entityData)
            return new CommonResponse(true, 1, 'Upload successfully', saveData)
        } catch (err) {
            throw (err)
        }
    }

    async getChecklistByServeId(dto: ServiceUploadDto): Promise<CommonResponse> {
        try {
            const manager = getManager()
            const query = `SELECT checklist ,checklist_status AS checklistStatus,asset_serve_id AS assetServeId FROM asset_service_checklist
            WHERE asset_serve_id =${dto.serveId}`;
            const result = await manager.query(query)
            if (result) {
                return new CommonResponse(true, 1, 'Data retrived', result)
            }
        } catch (err) {
            throw err
        }
    }

    async getUnassignedAssetsVendors(): Promise<CommonResponse> {
        try {
            const manager = getManager();
            const query1 = `SELECT COUNT(vendor_name) AS vendors FROM shahi_asset_master.vendors`;
            const result1 = await manager.query(query1);
            const query2 = `SELECT COUNT(asset_serve_id) AS services FROM shahi_assets.asset_service`;
            const result2 = await manager.query(query2);
            const query3 = `SELECT * FROM shahi_asset_master.downtime_tracking WHERE startTime >= NOW() - INTERVAL 1 DAY`;
            const result3 = await manager.query(query3);
            const query4 = `
            SELECT 
              COUNT(CASE WHEN STATUS = 'Idle' AND created_at < CURDATE() - INTERVAL 30 DAY THEN asset_id END) AS UnassignedFor30,
              SUM(CASE WHEN STATUS = 'Idle' AND created_at < CURDATE() - INTERVAL 30 DAY THEN asset_cost END) AS assetsCostTo30,
              COUNT(CASE WHEN STATUS = 'Idle' AND created_at < CURDATE() - INTERVAL 60 DAY THEN asset_id END) AS UnassignedFor60,
              SUM(CASE WHEN STATUS = 'Idle' AND created_at < CURDATE() - INTERVAL 60 DAY THEN asset_cost END) AS assetsCostTo60,
              COUNT(CASE WHEN STATUS = 'Idle' AND created_at < CURDATE() - INTERVAL 90 DAY THEN asset_id END) AS UnassignedFor90,
              SUM(CASE WHEN STATUS = 'Idle' AND created_at < CURDATE() - INTERVAL 90 DAY THEN asset_cost END) AS assetsCostTo90
            FROM 
            shahi_assets.assets
            WHERE
              STATUS = 'Idle'`;
            const result4 = await manager.query(query4);
            const combinedResult = {
                vendorsCount: result1[0].vendors,
                servicesCount: result2[0].services,
                currentDowntime: result3,
                unassignedAssets: result4[0]
            };

            return new CommonResponse(true, 1, 'Data retrieved', combinedResult);
        } catch (err) {
            throw err;
        }
    }






    async getImagesByServeId(dto: ServiceUploadDto): Promise<CommonResponse> {
        try {
            const manager = getManager()
            const query = `SELECT maintenance_name AS maintenanceName ,file_path AS filePath ,serve_id AS serveId FROM asset_service_upload
            WHERE serve_id = ${dto.serveId}`;
            const result = await manager.query(query)
            if (result) {
                return new CommonResponse(true, 1, 'Data retrived', result)
            }
        } catch (err) {
            throw err
        }
    }
    async getMachineInwordDetails(req: MachineInwordDto): Promise<CommonResponse> {
        try {

            const manager = getManager()

            let query = `SELECT it.item_name AS machineDescription , aas.asset_serialno AS assetSerialNo , aas.model ,
            aas.assets_code AS barcode , aas.no_of_units AS noOfUnits , u.unit_name AS fromUnit ,att.dc_number AS dcNumber,att.transfer_date AS transferDate
            FROM shahi_assets.asset_transfer att
            LEFT JOIN shahi_assets.assets aas ON aas.asset_id = att.asset_id
            LEFT JOIN shahi_asset_master.unitcodes u ON u.unit_code_id = att.from_plant
            LEFT JOIN shahi_asset_master.items it ON it.item_id = aas.assets_name
            WHERE 1=1 `;
            if (req && req.machinedescription) {
                query += `AND it.item_name = '${req.machinedescription}'`
            }
            if (req && req.barcode) {
                query += `AND aas.assets_code = '${req.barcode}'`
            }
            if (req && req.transferStartDate && req.transferEndDate) {
                req.transferStartDate = moment(req.transferStartDate).format("YYYY-MM-DD")
                req.transferEndDate = moment(req.transferEndDate).format("YYYY-MM-DD")
                query += `AND att.transfer_date BETWEEN '${req.transferStartDate}' AND '${req.transferEndDate}' `
            }
            console.log(query, 'dateeeeeeeeeeeeeeeeeeeeee');

            const result = await manager.query(query)
            if (result) {
                return new CommonResponse(true, 1, 'Data retrived', result)
            }

        } catch (err) {
            throw err
        }
    }


    async getMachineBarcodeFilter(): Promise<CommonResponse> {
        try {
            const manager = getManager()
            let query = `SELECT  CONCAT(it.item_name,' ',aas.assets_code) AS machinedescriptionbarcode	,it.item_name as itemName
             FROM shahi_assets.asset_transfer att
             LEFT JOIN shahi_assets.assets aas ON aas.asset_id = att.asset_id
             LEFT JOIN shahi_asset_master.unitcodes u ON u.unit_code_id = att.from_plant
             LEFT JOIN shahi_asset_master.items it ON it.item_id = aas.assets_name`

            const result = await manager.query(query)
            if (result) {
                return new CommonResponse(true, 1, 'Data retrived', result)
            }

        } catch (err) {
            throw err
        }
    }

    async getKPIData(): Promise<CommonResponse> {
        try {
            const manager = getManager();

            const query1 = `
                SELECT 
                    DATE_FORMAT(updated_at, '%b') AS month_name,
                    YEAR(updated_at) AS year,
                    SUM(TIMESTAMPDIFF(MINUTE, startTime, endtime)) AS total_breakdown_minutes,
                    (SUM(TIMESTAMPDIFF(MINUTE, startTime, endtime)) / 12000) * 100 AS breakdown_percentage
                FROM 
                    shahi_asset_master.downtime_tracking
                GROUP BY 
                    YEAR(updated_at), MONTH(updated_at)
                ORDER BY 
                    YEAR(updated_at), MONTH(updated_at);`;

            const query2 = `
                SELECT 
                    DATE_FORMAT(updated_at, '%b') AS month_name,
                    YEAR(updated_at) AS year,
                    COUNT(CASE WHEN STATUS = 'APPROVED' THEN 1 END) AS approved_services,
                    COUNT(CASE WHEN STATUS IN ('OPEN', 'COMPLETED', 'INPROGRESS') THEN 1 END) AS other_services,
                    (COUNT(CASE WHEN STATUS = 'APPROVED' THEN 1 END) / 
                     COUNT(CASE WHEN STATUS IN ('OPEN', 'COMPLETED', 'INPROGRESS') THEN 1 END)) * 100 AS approval_percentage
                FROM 
                    shahi_assets.asset_service
                GROUP BY 
                    YEAR(updated_at), MONTH(updated_at)
                ORDER BY 
                    YEAR(updated_at), MONTH(updated_at);`;

            const [result1, result2] = await Promise.all([
                manager.query(query1),
                manager.query(query2)
            ]);

            const result = {
                downtimeData: result1,
                serviceData: result2
            };

            if (result) {
                return new CommonResponse(true, 1, 'Data retrieved', result);
            } else {
                return new CommonResponse(false, 0, 'No data found', null);
            }
        } catch (err) {
            throw new Error(`Error retrieving KPI data: ${err.message}`);
        }
    }

    // async getMessageService(): Promise<CommonResponse> {
    //     try {
    //         const manager = getManager();
    
    //         const query = `
    //             WITH RankedServices AS (
    //                 SELECT 
    //                     aas.asset_service_date AS assetServiceDate,
    //                     itt.item_name AS assetName, aa.assets_code AS assetsCode, aa.asset_supplier AS make,
    //                     loc.location_name AS location,
    //                     emp.mobile_no AS mobileNo,
    //                     aas.service_owner AS servicePerson,
    //                     ROW_NUMBER() OVER (PARTITION BY aas.service_owner ORDER BY aas.asset_service_date ASC) AS rn
    //                 FROM 
    //                     shahi_assets.asset_service aas
    //                 LEFT JOIN 
    //                     shahi_assets.assets aa ON aa.asset_id = aas.asset_id
    //                 LEFT JOIN 
    //                     shahi_assets.asset_location_mapping alm ON alm.asset_id = aas.asset_id
    //                 LEFT JOIN 
    //                     shahi_assets.location loc ON loc.location_id = alm.location_id
    //                 LEFT JOIN 
    //                     shahi_asset_master.items itt ON itt.item_id = aa.assets_name
    //                 LEFT JOIN 
    //                     shahi_asset_master.employee_details emp ON emp.employee_name = aas.service_owner
    //                 WHERE 
    //                     aas.status = 'OPEN' AND DATE(aas.asset_service_date) = CURDATE()
    //             )
    //             SELECT 
    //                 assetServiceDate, assetName, assetsCode, make, location, mobileNo, servicePerson
    //             FROM 
    //                 RankedServices`;
    
    //         const result = await manager.query(query);
    
    //         if (result.length > 0) {
    //             const contactDetails = whatsApp.contacts;
    //             const commonNumbers = ['9191216822236'];
    //             let statusFlag = true;
    
    //             for (const service of result) {
    //                 const messageContent = `Service Alert \\n Service Date: ${service.assetServiceDate ? moment(service.assetServiceDate).format('YYYY-MM-DD') : ' -'} \\n Asset Name: ${service.assetName ? service.assetName : ''} \\n Asset Code: ${service.assetsCode ? service.assetsCode : ''} \\n Make: ${service.make ? service.make : ''} \\n Location: ${service.location ? service.location : ''} \\n Service Person: ${service.servicePerson ? service.servicePerson : ''} \\n Mobile No: ${service.mobileNo ? service.mobileNo : ''} \\n Service is Requested`;
    
    //                 const parameters = [
    //                     { "type": "text", "text": moment().format('YYYY-MM-DD') },
    //                     { "type": "text", "text": messageContent },
    //                 ];
    
    //                 // Send message to the service specific mobile number
    //                 const contacts = ['917036716813',...commonNumbers];
    //                 for (const contact of contacts) {
    //                 const whatsappRes = new MessageParameters(contact, 'vrs_alert', parameters, 'en_us');
    //                 console.log('Sending WhatsApp message with data:', JSON.stringify(whatsappRes));
    //                 const messageStatus = await this.wpService.sendMessageThroughFbApi(whatsappRes);
    //                 console.log(messageStatus, 'messageStatus');
    
    //                 if (!messageStatus.status) {
    //                     statusFlag = false;
    //                     console.error(`Failed to send message to ${contact}:`, messageStatus.internalMessage);
    //                 }
    //             }
    
    //                 // Send message to common numbers
    //                 // for (const commonNumber of commonNumbers) {
    //                 //     const commonWhatsappRes = new MessageParameters(commonNumber, 'vrs_alert', parameters, 'en_us');
    //                 //     console.log('Sending WhatsApp message to common number with data:', JSON.stringify(commonWhatsappRes));
    //                 //     const commonMessageStatus = await this.wpService.sendMessageThroughFbApi(commonWhatsappRes);
    //                 //     console.log(commonMessageStatus, 'messageStatus');
    
    //                 //     if (!commonMessageStatus.status) {
    //                 //         statusFlag = false;
    //                 //         console.error(`Failed to send message to ${commonNumber}:`, commonMessageStatus.internalMessage);
    //                 //     }
    //                 // }
    //             }
    
    //             return new CommonResponse(statusFlag, statusFlag ? 1 : 0, statusFlag ? 'Messages sent successfully' : 'Failed to send some messages', result);
    //         } else {
    //             return new CommonResponse(false, 0, 'No data found', null);
    //         }
    //     } catch (err) {
    //         throw new Error(`Error retrieving KPI data: ${err.message}`);
    //     }
    // }

    async delay(ms: number): Promise<void> {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    

    // @Cron('0 7 * * *')
    // async getMessageService(): Promise<CommonResponse> {
    //     try {
    //         const manager = getManager();
    
    //         const query = `
    //             WITH RankedServices AS (
    //                 SELECT 
    //                     aas.asset_service_date AS assetServiceDate,
    //                     itt.item_name AS assetName, aa.assets_code AS assetsCode, aa.asset_supplier AS make,
    //                     loc.location_name AS location,
    //                     emp.mobile_no AS mobileNo,
    //                     aas.service_owner AS servicePerson,
    //                     ROW_NUMBER() OVER (PARTITION BY aas.service_owner ORDER BY aas.asset_service_date ASC) AS rn
    //                 FROM 
    //                     shahi_assets.asset_service aas
    //                 LEFT JOIN 
    //                     shahi_assets.assets aa ON aa.asset_id = aas.asset_id
    //                 LEFT JOIN 
    //                     shahi_assets.asset_location_mapping alm ON alm.asset_id = aas.asset_id
    //                 LEFT JOIN 
    //                     shahi_assets.location loc ON loc.location_id = alm.location_id
    //                 LEFT JOIN 
    //                     shahi_asset_master.items itt ON itt.item_id = aa.assets_name
    //                 LEFT JOIN 
    //                     shahi_asset_master.employee_details emp ON emp.employee_name = aas.service_owner
    //                 WHERE 
    //                     aas.status = 'OPEN' AND DATE(aas.asset_service_date) = CURDATE()
    //             )
    //             SELECT 
    //                 assetServiceDate, assetName, assetsCode, make, location, mobileNo, servicePerson
    //             FROM 
    //                 RankedServices`;
    
    //         const result = await manager.query(query);
    
    //         if (result.length > 0) {
    //             const commonNumbers = ['917036716813','917702255295','917702621117','918220385835','919008672528','918886643838'];
    //             let overallStatusFlag = true;
    
    //             for (const service of result) {
    //                 const messageContent = `Service Alert \\n Unit : 07 \\n Service Date: ${service.assetServiceDate ? moment(service.assetServiceDate).format('YYYY-MM-DD') : '-'} \\n Asset Name: ${service.assetName ? service.assetName : '-'} \\n Asset Code: ${service.assetsCode ? service.assetsCode : '-'} \\n Make: ${service.make ? service.make : '-'} \\n Location: ${service.location ? service.location : '-'} \\n Service Person: ${service.servicePerson ? service.servicePerson : '-'} \\n Mobile No: ${service.mobileNo ? service.mobileNo : '-'} \\n Service is Requested`;
    
    //                 const parameters = [
    //                     { "type": "text", "text": moment().format('YYYY-MM-DD') },
    //                     { "type": "text", "text": messageContent },
    //                 ];
    
    //                 const contacts = [service.mobileNo, ...commonNumbers];
    //                 for (const contact of contacts) {
    //                     if (!contact) {
    //                         console.error(`Invalid contact number: ${contact}`);
    //                         overallStatusFlag = false;
    //                         continue;
    //                     }
    //                     let statusFlag = await this.sendMessageWithRetry(contact, parameters);
    //                     overallStatusFlag = overallStatusFlag && statusFlag;
    //                     await this.delay(2000);
    //                 }
    //             }
    
    //             return new CommonResponse(overallStatusFlag, overallStatusFlag ? 1 : 0, overallStatusFlag ? 'Messages sent successfully' : 'Failed to send some messages', result);
    //         } else {
    //             return new CommonResponse(false, 0, 'No data found', null);
    //         }
    //     } catch (err) {
    //         throw new Error(`Error retrieving KPI data: ${err.message}`);
    //     }
    // }

@Cron('0 7 * * *')
async getMessageService(): Promise<CommonResponse> {
    try {
        const manager = getManager();
    
        const query = `
            WITH RankedServices AS (
                SELECT 
                    aas.asset_service_date AS assetServiceDate,
                    itt.item_name AS assetName, aa.assets_code AS assetsCode, aa.asset_supplier AS make,
                    loc.location_name AS location,
                    emp.mobile_no AS mobileNo,pp.unit_name AS unit,
                    aas.service_owner AS servicePerson,
                    ROW_NUMBER() OVER (PARTITION BY aas.service_owner ORDER BY aas.asset_service_date ASC) AS rn
                FROM 
                    shahi_assets.asset_service aas
                LEFT JOIN 
                    shahi_assets.assets aa ON aa.asset_id = aas.asset_id
                LEFT JOIN 
                    shahi_asset_master.unitcodes pp ON pp.unit_code_id = aa.plant
                LEFT JOIN 
                    shahi_assets.asset_location_mapping alm ON alm.asset_id = aas.asset_id
                LEFT JOIN 
                    shahi_assets.location loc ON loc.location_id = alm.location_id
                LEFT JOIN 
                    shahi_asset_master.items itt ON itt.item_id = aa.assets_name
                LEFT JOIN 
                    shahi_asset_master.employee_details emp ON emp.employee_name = aas.service_owner
                WHERE 
                    aas.status = 'OPEN' AND DATE(aas.asset_service_date) = CURDATE()
            )
            SELECT 
                assetServiceDate, assetName, assetsCode, make, location, mobileNo, servicePerson, unit
            FROM 
                RankedServices`;
    
        const result = await manager.query(query);
    
        if (result.length > 0) {
            const commonNumbers = ['917036716813','917702255295','917702621117','918220385835','919008672528','918886643838'];
            let overallStatusFlag = true;

            const unitHODNumbers: Record<string, string[]> = {
                Unit35: ['919060501099'], // HOD for Unit-35
                Unit37: ['919845090290'], // HOD for Unit-37
                Unit1: ['919980006746','918971254084','919945812400','919964106189','919036769403','919945267424'],
                Unit54: ['919738510461','919980450717','919980666816'],
                Unit45 : ['919448127288']
                // Add more units and their HODs as needed
            };

            type ServiceData = {
                assetServiceDate: string;
                assetName: string;
                assetsCode: string;
                make: string;
                location: string;
                unit: string;
            };
    
            type GroupedService = {
                servicePerson: string;
                mobileNo: string;
                unit: string;
                services: ServiceData[];
            };
    
            const groupedServices: Record<string, GroupedService> = result.reduce((acc, service) => {
                if (!acc[service.servicePerson]) {
                    acc[service.servicePerson] = {
                        servicePerson: service.servicePerson,
                        mobileNo: service.mobileNo, // Default mobile number if not found
                        unit: service.unit,
                        services: [],
                    };
                }

                // Check if this service already exists by comparing the asset code
                const serviceExists = acc[service.servicePerson].services.some(s => s.assetsCode === service.assetsCode);
                
                if (!serviceExists) {
                    acc[service.servicePerson].services.push({
                        assetServiceDate: service.assetServiceDate,
                        assetName: service.assetName,
                        assetsCode: service.assetsCode,
                        make: service.make,
                        location: service.location,
                        unit: service.unit,
                    });
                }

                return acc;
            }, {} as Record<string, GroupedService>);
    
            // Loop through each grouped service and process
            for (const [person, data] of Object.entries(groupedServices)) {
                const { mobileNo, services,unit  } = data;  // Ensure correct typing for mobileNo and services
                const normalizedUnit = unit.replace('-', '');
    
                // Create the message content by combining services for the person
                let messageContent = `Service Alert \\n ${data.unit || '-'} \\n`;
    
                services.forEach((service, index) => {
                    messageContent += `\\n*Service ${index + 1}:* \\n Asset Name: ${service.assetName || '-'} \\n Asset Code: ${service.assetsCode || '-'} \\n Make: ${service.make || '-'} \\n Location: ${service.location || '-'} \\n`;
                });
    
                messageContent += `\\n Service Person: ${person} \\n Mobile No: ${mobileNo}`;
    
                const parameters = [
                    { "type": "text", "text": moment().format('YYYY-MM-DD') },
                    { "type": "text", "text": messageContent },
                ];

                let contacts: string[] = [mobileNo]; // Send to service person

                // Add the HOD contact for the unit, if available
                if (unit && unitHODNumbers[normalizedUnit]) {
                    contacts.push(...unitHODNumbers[normalizedUnit]);
                }

                // Add common numbers (global recipients)
                contacts.push(...commonNumbers);
    
                // const contacts = [mobileNo, ...commonNumbers];
                for (const contact of contacts) {
                    if (!contact) {
                        console.error(`Invalid contact number: ${contact}`);
                        overallStatusFlag = false;
                        continue;
                    }
                    let statusFlag = await this.sendMessageWithRetry(contact, parameters);
                    overallStatusFlag = overallStatusFlag && statusFlag;
                    await this.delay(2000); // Ensure we are sending messages with a small delay between them
                }
            }
    
            return new CommonResponse(overallStatusFlag, overallStatusFlag ? 1 : 0, overallStatusFlag ? 'Messages sent successfully' : 'Failed to send some messages', result);
        } else {
            return new CommonResponse(false, 0, 'No data found', null);
        }
    } catch (err) {
        throw new Error(`Error retrieving KPI data: ${err.message}`);
    }
}

    
    
    private async sendMessageWithRetry(contact: string, parameters: any[], retries: number = 3): Promise<boolean> {
        for (let attempt = 1; attempt <= retries; attempt++) {
            const whatsappRes = new MessageParameters(contact, 'vrs_alert', parameters, 'en_us');
            console.log(`Attempt ${attempt} - Sending WhatsApp message to ${contact} with data:`, JSON.stringify(whatsappRes));
            
            // Log the request details for debugging
            console.log(`Request details: recipient=${contact}, parameters=${JSON.stringify(parameters)}`);
    
            const messageStatus = await this.wpService.sendMessageThroughFbApi(whatsappRes);
            
            // Log the full response for debugging
            console.log(`Response from WhatsApp API:`, messageStatus);
    
            if (messageStatus.status) {
                return true;
            } else {
                console.error(`Attempt ${attempt} - Failed to send message to ${contact}:`, messageStatus.internalMessage);
    
                // Additional logging for error details
                console.error(`Error details:`, messageStatus);
    
                if (attempt < retries) {
                    console.log(`Retrying to send message to ${contact}...`);
                }
            }
        }
        return false;
    }
    

    async downtimeAssetService(createDto: AssetServiceDto): Promise<CommonResponse> {
        const manager = getManager();

        try {
            const query = `
                SELECT emp.employee_name, emp.mobile_no,aa.plant
                FROM shahi_asset_master.employee_details emp
                LEFT JOIN shahi_assets.location loc ON loc.location_head = emp.employee_id
                LEFT JOIN shahi_assets.asset_location_mapping alc ON alc.location_id = loc.location_id
                LEFT JOIN shahi_assets.assets aa ON aa.asset_id = alc.asset_id
                WHERE alc.asset_id = ${createDto.assetId}
            `;

            const result = await manager.query(query, [createDto.assetId]);

            if (!result.length) {
                throw new Error(`No employee found for asset ID: ${createDto.assetId}`);
            }

            const assetService = new AssetService();
            assetService.assetId = createDto.assetId;
            assetService.assetName = createDto.assetName;
            assetService.serviceName = 'Downtime';
            assetService.serviceProvider = 'In-House';
            assetService.serviceOwner = result[0].employee_name;
            assetService.phoneNumber = result[0].mobile_no;
            assetService.serviceType = 'unPlanned';
            assetService.createdUser = createDto.createdUser;
            assetService.status = ServiceStatusEnum.INPROGRESS;
            assetService.startDate = new Date();
            assetService.createdAt = new Date();
            assetService.updatedAt = new Date();

            const savedAssetService = await this.assetServiceRepo.save(assetService);

            const downtimeQuery = `
            INSERT INTO shahi_asset_master.downtime_tracking (asset_id,machine_name, startTime, status,unit_id)
            VALUES (?, ?, ?, ?, ?)
        `;
            await manager.query(downtimeQuery, [assetService.assetId,assetService.assetName, new Date(), 'PENDING',result[0].plant]);
            return new CommonResponse(true, 1, 'Data retrieved', savedAssetService);
        } catch (error) {
            console.error('Error in downtimeAssetService:', error);
            throw new Error('Failed to create downtime asset service');
        }
    }


    async downtimecompleteService(completeServiceDto: AssetByCode): Promise<CommonResponse> {
        const manager = getManager();

        const assetService = await this.assetServiceRepo.findOne({where:{ assetId:completeServiceDto.assetId,status:'INPROGRESS',serviceName:'Downtime'} });
        if (!assetService) {
            throw new Error(`Service with ID ${completeServiceDto.assetServiceId} not found`);
        }

        assetService.status = ServiceStatusEnum.COMPLETE;
        assetService.completedDate = new Date();
        assetService.updatedAt = new Date();
        const savedAssetService = await this.assetServiceRepo.save(assetService);

        const downtimeTrackingQuery = `
            UPDATE shahi_asset_master.downtime_tracking
            SET status = 'CLOSED', endTime = ?
            WHERE asset_id = ? AND status = 'PENDING'
        `;
        await manager.query(downtimeTrackingQuery, [new Date(), assetService.assetId]);
        const assetTransaction = new AssetTransaction();
        assetTransaction.assetId = assetService.assetId;
        assetTransaction.assetsName = assetService.assetName; 
        assetTransaction.assetsCode = completeServiceDto.assetsCode; 
        assetTransaction.assetCategory = assetService.assetCategory; 
        assetTransaction.status = AssetStatusEnum.Service; 
        assetTransaction.isActive = true;
        assetTransaction.serviceStatus = ServiceStatusEnum.COMPLETE;
        assetTransaction.createdAt = new Date();
        assetTransaction.createdUser = assetService.createdUser; 
        assetTransaction.updatedAt = new Date();
        assetTransaction.assetServiceDate = assetService.assetServiceDate; 
        assetTransaction.serviceType = assetService.serviceType;
        assetTransaction.serviceName = assetService.serviceName;     
        await this.assetTransactionRepo.save(assetTransaction);

        return new CommonResponse(true, 1, 'Data retrieved', savedAssetService);
    }


    async getMissedAlertsService(assetIds: number[]): Promise<CommonResponse> {
        try {
            const manager = getManager();
            const assetCodes: string[] = [];
            const mobileNumbersSet: Set<string> = new Set();

            for (const assetServeId of assetIds) {
                const query = `
                SELECT aa.assets_code, emp.mobile_no 
                FROM shahi_assets.asset_service ass 
                LEFT JOIN shahi_assets.assets aa ON aa.asset_id = ass.asset_id
                LEFT JOIN shahi_asset_master.employee_details emp ON emp.employee_name = ass.service_owner
                WHERE ass.asset_serve_id = ?`;

                const result = await manager.query(query, [assetServeId]);
                console.log(result,'ooooooo')
                if (result.length > 0) {
                    assetCodes.push(...result.map(service => service.assets_code));
                    result.forEach(service => mobileNumbersSet.add(service.mobile_no));
                }
            }

            if (assetCodes.length > 0) {
                const mobileNumbers = Array.from(mobileNumbersSet);
                const contactDetails = whatsApp.contacts;
                let statusFlag;

                // Gather all asset codes in one message
                const consolidatedAssetCodes = assetCodes.join(',');

                const messageContent = `Service Alert \\n Asset Codes: ${consolidatedAssetCodes ? consolidatedAssetCodes : ' -'} \\n These Services Are Missed. Please Check And Complete.`;

                const parameters = [
                    { "type": "text", "text": moment().format('YYYY-MM-DD') },
                    { "type": "text", "text": messageContent },
                ];

                for (const contact of mobileNumbers) {
                    const whatsappRes = new MessageParameters(contact, 'vrs_alert', parameters, 'en_us');
                    const messageStatus = await this.wpService.sendMessageThroughFbApi(whatsappRes);
                    console.log(messageStatus, 'messageStatus');

                    if (!messageStatus.status) {
                        statusFlag = false;
                        console.error(`Failed to send message to ${contact}:`, messageStatus.internalMessage);
                        break;
                    } else {
                        statusFlag = true;
                    }
                }

                return new CommonResponse(statusFlag, statusFlag ? 1 : 0, statusFlag ? 'Messages sent successfully' : 'Failed to send some messages', assetCodes);
            } else {
                return new CommonResponse(false, 0, 'No data found', null);
            }
        } catch (err) {
            throw new Error(`Error retrieving KPI data: ${err.message}`);
        }
    }

    async getAllAssetsMaintenance(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT aas.asset_category,isc.item_sub_category , it.item_name AS assets_name,aas.assets_code,aas.amc_available ,aas.date_of_purchased,
        aas.name,aas.warrenty_expired_date,aas.insurance_date,aas.insurance,aas.warrenty_available,aas.expired_date,aas.asset_cost,aas.status,
        aas.asset_serialno,aas.model,aas.year,aas.asset_supplier,aas.asset_condition,emp.employee_name AS owner_of_asset,aas.transaction_date,aas.decommission_approved_by,
        aas.service_tenure,aas.insurance_provided_by,aas.asset_invoice_no,aas.item_id,aas.grn_id,aas.no_of_units,aas.units_of_measurements,aas.last_checkin,aas.last_checkout,aas.amc_reason,
        aas.department,aas.employee_id,aas.maintenance_duedate,aas.asset_id,unc.unit_name AS plant,aas.asset_type,assi.employee_id,empd.employee_name,empd.department_id,dep.dept_name,aas.service_type,aas.service_status,aas.amc_provider, aas.asset_mode,
        locc.location_id,lo.location_id ,loc.location_name,it.item_name,aas.host_address,mi.asset_maintainance_id,mi.maintainance_type,mi.cost_of_repair,mi.damage_reason,mi.remarks,mi.can_be_reused,mi.expired_date as exprDate FROM ` + appSettings.assets_db + `.assets aas 
        LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
         LEFT JOIN `+ appSettings.assets_db + `.asset_maintainance mi ON mi.asset_id = aas.asset_id
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
        LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id 
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN `+ appSettings.masters_db + `.employee_details emp ON emp.employee_id = aas.owner_of_asset
        LEFT JOIN `+ appSettings.assets_db + `.asset_assignment assi ON assi.asset_id = aas.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.employee_details empd ON empd.employee_id = assi.employee_id
        LEFT JOIN `+ appSettings.masters_db + `.departments dep ON dep.dept_id = empd.department_id
        WHERE aas.asset_id > 0 AND aas.asset_mode = "OwnedAsset"`
        if (req.plantId > 0 && req.plantId != 5) {
            getEntities = getEntities + 'and aas.plant = ' + req.plantId
        }
        getEntities = getEntities + ` GROUP BY aas.assets_code ORDER BY it.item_name ASC`
        const assetdata: {
            asset_category: string, assets_name: number, assets_code: string, amc_available: string, date_of_purchased: Date,
            name: string, warrenty_expired_date: Date, insurance_date: Date, insurance: string, warrenty_available: string,
            expired_date: Date, asset_cost: number, status: AssetStatusEnum, asset_serialno: string, asset_condition: string, invoice: string, model: string,
            asset_supplier: string, item_id: number, grn_id: number, no_of_units: number, year: Date, units_of_measurements: string, last_checkin: Date, last_checkout: Date, amc_reason: string,
            asset_invoice_no: string, owner_of_asset: string, department: string, employee_id: number, maintenance_duedate: Date, transaction_date: Date, decommission_approved_by: string,
            service_tenure: string, insurance_provided_by: string, plant: string, asset_id: number, location_name: string, asset_type: string, employee_name: string, dept_name: string, service_type: string, service_status: ServiceStatusEnum, amc_provider: string,asset_mode :string, item_sub_category: string, item_name: string,host_address: string, asset_maintainance_id? : number,maintainance_type?: string,cost_of_repair?:string,damage_reason?:string,remarks?: string,can_be_reused?:string,exprDate:string
        }[] = await manager.query(getEntities)

        const response = [];
        assetdata.forEach(data => {
            response.push(new AssetDto(data.asset_id, data.assets_name, data.assets_code, data.asset_serialno, data.item_id, data.grn_id,
                data.no_of_units, data.insurance, data.insurance_date, null, data.model, data.year,
                data.asset_supplier, data.asset_invoice_no, data.expired_date, data.asset_cost, data.date_of_purchased, data.asset_category, data.status, data.asset_condition, data.amc_available, data.name,
                null, data.owner_of_asset, data.units_of_measurements, data.location_name, data.last_checkin, data.last_checkout, data.warrenty_available, data.warrenty_expired_date,
                data.employee_id, data.department, data.maintenance_duedate, data.transaction_date, null, true, data.item_name, null, 1, data.decommission_approved_by,
                data.service_tenure, data.insurance_provided_by, data.plant, data.amc_reason, data.item_sub_category, data.asset_type, data.employee_name, data.dept_name, data.service_status, data.service_type, data.amc_provider,null,null,null,null,null,null,null,null,null,data.asset_mode,null,null,null,null,null,null,data.host_address,null,null,null,null,null,null,null,null,null,null,null,null,null,null,data.asset_maintainance_id,data.maintainance_type,data.cost_of_repair,data.damage_reason,data.remarks,data.can_be_reused,data.exprDate))
        })
        return new CommonResponse(true, 1, 'Data retrieved', response)
    }


    async updateWarranty(req: any): Promise<CommonResponse> {
        try {
            const upDateRecord = await this.repo.update({ assetId: req.assetId }, { warrenty: req.warrenty, warrentyExpiredDate: req.warrentyExpiredDate })
            console.log(upDateRecord.affected,'kkkkkkkkkkkkkkkkkkkkk')
            if (upDateRecord.affected) {
                return new CommonResponse(true, 62651, "Updated Successfully")
            } else {
                throw new ErrorResponse(5162, "Somthing Went Wrong")
            }
        } catch (error) {
            throw new ErrorResponse(6562, error.message)
        }
    }

    async updateInsurance(req: any): Promise<CommonResponse> {
        try {
            const upDateRecord = await this.repo.update({ assetId: req.assetId }, { insuranceRefNum: req. insuranceRefNum,  insurance : req. insurance ,insuranceDate: req.insuranceDate,insuranceProvidedBy : req.insuranceProvidedBy })
            if (upDateRecord.affected) {
                return new CommonResponse(true, 62651, "Updated Successfully")
            } else {
                throw new ErrorResponse(5162, "Somthing Went Wrong")
            }
        } catch (error) {
            throw new ErrorResponse(6562, error.message)
        }
    }

    async updateAmc(req: any): Promise<CommonResponse> {
        try {
            const upDateRecord = await this.repo.update({ assetId: req.assetId }, { amc: req. amc,  amcProvider : req. amcProvider ,amcname: req.amcname,amcno : req.amcno })
            if (upDateRecord.affected) {
                return new CommonResponse(true, 62651, "Updated Successfully")
            } else {
                throw new ErrorResponse(5162, "Somthing Went Wrong")
            }
        } catch (error) {
            throw new ErrorResponse(6562, error.message)
        }
    }

    async getAllAssetModel(req:AssetModelReq): Promise<CommonResponse> {
      
        const records = await this.repo.find({
            where: {
             
                assetCategory: In(req.assetCategory)  
            },
            select: ['model']
          });

        // if (!records.length) {
        //   throw new ErrorResponse(99998, 'No Records Found');
        // }
        
      
        return new CommonResponse(true, 53, 'AssetModel data retrieved SuccessFully',records);
      }


      async getAmcMachinesList(req?: AssetServiceReq): Promise<CommonResponse> {
        const manager = getManager();
        
        let baseQuery = `SELECT isc.item_sub_category AS subCategory, it.item_name AS assetsName, aas.assets_code AS assetsCode, aas.amc_available AS amcAvailable,
            aas.name, aas.asset_cost, aas.status, 
            aas.asset_serialno, aas.model, emp.employee_name AS owner_of_asset,
            unc.unit_name AS plant,unc.unit_code_id AS plantId,
            loc.location_name, aas.amc_start_date, aas.amc_end_date ,lo.location_id
            FROM shahi_assets.assets aas 
            LEFT JOIN shahi_asset_master.unitcodes unc ON unc.unit_code_id = aas.plant
            LEFT JOIN shahi_assets.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
            LEFT JOIN shahi_assets.location loc ON loc.location_id = lo.location_id 
            LEFT JOIN shahi_asset_master.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
            LEFT JOIN shahi_asset_master.items it ON it.item_id = aas.assets_name
            LEFT JOIN shahi_asset_master.employee_details emp ON emp.employee_id = aas.owner_of_asset
            LEFT JOIN shahi_assets.asset_assignment assi ON assi.asset_id = aas.asset_id
            LEFT JOIN shahi_asset_master.employee_details empd ON empd.employee_id = assi.employee_id
            LEFT JOIN shahi_asset_master.departments dep ON dep.dept_id = empd.department_id
            WHERE aas.amc_available = 'Yes'`;
           
       
        if (req?.plant) {
            baseQuery += ' AND aas.plant = ' + req.plant;
        }
        if (req?.location) {
            baseQuery += ' AND loc.location_name = "' + req.location + '"';
        }
        if (req?.assetCode) {
            baseQuery += ' AND aas.assets_code = "' + req.assetCode + '"';
        }
        if (req?.startDate && req?.endDate) {
            const formattedStartDate = moment(req.startDate).format("YYYY-MM-DD");
            const formattedEndDate = moment(req.endDate).format("YYYY-MM-DD");
            baseQuery += ` AND DATE(aas.amc_end_date) BETWEEN '${formattedStartDate}' AND '${formattedEndDate}' `;
        }
        if (req?.assetCategory) {
            baseQuery += ` AND aas.asset_category = '${req.assetCategory}'`;
        }
    
        baseQuery += ' ORDER BY aas.amc_end_date ASC';
        
        const data = await manager.query(baseQuery);
        if (data?.length) {
            return new CommonResponse(true, 1111, 'Data Retrieved Successfully', data);
        } else {
            return new CommonResponse(false, 9999, 'No Data Found');
        }
      }


    async cardsData(req?: any): Promise<CommonResponse> {
    try {
        const manager = getManager();
        const queries: string[] = [];

        // Vendors count
        let query1 = `SELECT COUNT(*) AS vendorsCount FROM shahi_asset_master.vendors`;
        queries.push(query1);

        // Request count
        let query2 = `SELECT COUNT(*) AS requestCount FROM shahi_assets.asset_requistion WHERE 1=1`;
        if (req?.plant) {
            query2 += ` AND from_plant = ${req.plant}`;
        }
        queries.push(query2);

        // Transfer count
        let query3 = `SELECT COUNT(*) AS transferCount FROM shahi_assets.asset_transfer WHERE 1=1`;
        if (req?.plant) {
            query3 += ` AND unit_id = ${req.plant}`;
        }
        queries.push(query3);

        // Assets count
        let query4 = `SELECT COUNT(*) AS assetsCount FROM shahi_assets.assets WHERE 1=1`;
        if (req?.plant) {
            query4 += ` AND plant = '${req.plant}'`;
        }
        queries.push(query4);

        // Downtime count
        let query5 = `SELECT COUNT(*) AS downtimeCount FROM shahi_asset_master.downtime_tracking WHERE 1=1`;
        if (req?.plant) {
            query5 += ` AND unit_id = '${req.plant}'`;
        }
        queries.push(query5);

        // Skills count
        let query6 = `SELECT COUNT(*) AS skillCount
                      FROM shahi_asset_master.employee_skill_matrix sk
                      LEFT JOIN shahi_asset_master.employee_details emp ON emp.employee_id = sk.employee_id
                      WHERE 1=1`;
        if (req?.plant) {
            query6 += ` AND emp.unit_id = '${req.plant}'`;
        }
        queries.push(query6);

        // Calibration count
        let query7 = `SELECT COUNT(*) AS calibrationCount FROM shahi_asset_master.calibrations WHERE 1=1`;
        if (req?.plant) {
            query7 += ` AND plant = ${req.plant}`;
        }
        queries.push(query7);

        // AMC count
        let query8 = `SELECT COUNT(*) AS amcCount FROM shahi_assets.assets WHERE amc_available = 'Yes'`;
        if (req?.plant) {
            query8 += ` AND plant = ${req.plant}`;
        }
        queries.push(query8);

        // Spare stock count
        let query9 = `SELECT COUNT(*) AS spareCount FROM shahi_assets.spare_stock`;
        queries.push(query9);

        let query10 = `SELECT COUNT(*) AS serviceCount FROM shahi_assets.asset_service ss
        LEFT JOIN shahi_assets.assets ass ON ass.asset_id = ss.asset_id WHERE 1=1`;
        if (req?.plant) {
            query10 += ` AND plant = '${req.plant}'`;
        }
        queries.push(query10);

        // Execute all queries in parallel
        const results = await Promise.all(queries.map((query) => manager.query(query)));

        // Combine results
        const data = {
            vendorsCount: results[0][0]?.vendorsCount || 0,
            requestCount: results[1][0]?.requestCount || 0,
            transferCount: results[2][0]?.transferCount || 0,
            assetsCount: results[3][0]?.assetsCount || 0,
            downtimeCount: results[4][0]?.downtimeCount || 0,
            skillCount: results[5][0]?.skillCount || 0,
            calibrationCount: results[6][0]?.calibrationCount || 0,
            amcCount: results[7][0]?.amcCount || 0,
            spareCount: results[8][0]?.spareCount || 0,
            serviceCount: results[9][0]?.serviceCount || 0,
        };

        return new CommonResponse(true, 1111, 'Data Retrieved Successfully', data);
    } catch (err) {
        console.error('Error fetching cards data:', err);
        return new CommonResponse(false, 9999, 'Error retrieving data', null);
    }
}


async locationWiseData(req: locationWiseReq): Promise<CommonResponse> {
    const manager = getManager();

    let getEntities = `
    SELECT 
        loc.location_name AS location, 
        aa.plant,
        COUNT(aa.asset_id) AS totalAssets,     
        SUM(CASE WHEN ass.status = 'OPEN' THEN 1 ELSE 0 END) AS openServices,
        SUM(CASE WHEN ass.status IN ('COMPLETED', 'APPROVED') THEN 1 ELSE 0 END) AS completedServices
    FROM 
        ` + appSettings.assets_db + `.asset_service ass
    LEFT JOIN 
        ` + appSettings.assets_db + `.asset_location_mapping lcc ON lcc.asset_id = ass.asset_id
    LEFT JOIN 
        ` + appSettings.assets_db + `.location loc ON loc.location_id = lcc.location_id
    LEFT JOIN 
        ` + appSettings.assets_db + `.assets aa ON aa.asset_id = ass.asset_id
    WHERE 1=1`; 
if (req?.plant) {
        getEntities += ` AND aa.plant = ` + req.plant;
    }
 getEntities += `
    GROUP BY 
        loc.location_name, 
        aa.plant`;

    
    const locationData = await manager.query(getEntities);
   return new CommonResponse(true, 1, 'Data retrieved successfully', locationData);
}



async employeesWiseData(req: locationWiseReq): Promise<CommonResponse> {
    const manager = getManager();
let query = `
        SELECT 
            ass.service_owner AS employee, 
            emp.unit_id AS plant,
            SUM(CASE WHEN ass.status = 'OPEN' THEN 1 ELSE 0 END) AS openServices,
            SUM(CASE WHEN ass.status IN ('COMPLETED', 'APPROVED') THEN 1 ELSE 0 END) AS completedServices
        FROM 
            shahi_assets.asset_service ass
        LEFT JOIN 
            shahi_asset_master.employee_details emp 
            ON emp.employee_name = ass.service_owner
        WHERE 1=1`;
        if (req?.plant) {
            query += ` AND emp.unit_id = ` + req.plant;
        }
     query += `
        GROUP BY 
            ass.service_owner, 
            emp.unit_id`;
    const employeesData = await manager.query(query);
 return new CommonResponse(true, 1, 'Data retrieved successfully', employeesData);
}

async MonthWiseServicesData(req: locationWiseReq): Promise<CommonResponse> {
    const manager = getManager();
    let query = `
        SELECT 
            DATE_FORMAT(ass.act_asset_service_date, '%Y-%b') AS month,  
            emp.unit_id AS plant,
            SUM(CASE WHEN ass.status = 'OPEN' THEN 1 ELSE 0 END) AS openServices,
            SUM(CASE WHEN ass.status IN ('COMPLETED', 'APPROVED') THEN 1 ELSE 0 END) AS completedServices
        FROM 
            shahi_assets.asset_service ass
        LEFT JOIN 
            shahi_asset_master.employee_details emp 
            ON emp.employee_name = ass.service_owner
        WHERE 1=1`;
        
   
    if (req?.plant) {
        query += ` AND emp.unit_id = ` + req.plant;
    }
    
    query += `
        GROUP BY 
           DATE_FORMAT(ass.act_asset_service_date, '%Y-%b')
           ORDER BY 
            MIN(ass.act_asset_service_date) ASC;`;  

   
    const actualServiceData = await manager.query(query);
    return new CommonResponse(true, 1, 'Data retrieved successfully', actualServiceData);
}


@Cron('*/10 * * * * *')
async CompletedChecklist(): Promise<CommonResponse> {
    const manager = getManager();
    let query = `UPDATE asset_service_checklist ass
INNER JOIN asset_service ss ON ss.asset_serve_id = ass.asset_serve_id
SET ass.checklist_status = 'Completed'
WHERE ss.status = 'COMPLETED'`; 
    const actualServiceData = await manager.query(query);
    return new CommonResponse(true, 1, 'Data retrieved successfully', actualServiceData);
}

async WeeklyServicesData(req: locationWiseReq): Promise<CommonResponse> {
    const manager = getManager();
    let query = `
        SELECT 
    a.asset_id AS assetId,
    i.item_name AS assetName,
    a.assets_code AS assetCode,
    l.location_name AS locationName,
    asr.asset_service_date AS serviceDate,
    asr.asset_serve_id AS assetServiceId,
    asr.service_owner AS serviceOwner
FROM 
   shahi_assets.asset_service asr
LEFT JOIN 
    shahi_assets.assets a ON a.asset_id = asr.asset_id
LEFT JOIN 
    shahi_asset_master.item_sub_categories ic ON ic.item_sub_category_id = a.asset_category
LEFT JOIN 
    shahi_asset_master.items i ON i.item_id = a.assets_name 
LEFT JOIN 
    shahi_asset_master.unitcodes uc ON uc.unit_code_id = a.plant
LEFT JOIN 
    shahi_assets.asset_location_mapping lm ON lm.asset_id = a.asset_id
LEFT JOIN 
    shahi_assets.location l ON l.location_id = lm.location_id 
WHERE  WEEKOFYEAR(asr.asset_service_date) = WEEKOFYEAR(CURDATE()) 
    AND YEAR(asr.asset_service_date) = YEAR(CURDATE())
    AND asr.status = 'OPEN'`;
        
   
    if (req?.plant) {
        query += ` AND a.plant = ` + req.plant;
    }
    
    query += `
         order by asr.asset_service_date asc`;  

   
    const actualServiceData = await manager.query(query);
    return new CommonResponse(true, 1, 'Data retrieved successfully', actualServiceData);
}



}
